module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/lib/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 36);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(24);


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("jsbn");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable  */
var _require = __webpack_require__(3),
    BigInteger = _require.BigInteger,
    SecureRandom = _require.SecureRandom;

var _require2 = __webpack_require__(34),
    ECCurveFp = _require2.ECCurveFp;

var rng = new SecureRandom();

var _generateEcparam = generateEcparam(),
    curve = _generateEcparam.curve,
    G = _generateEcparam.G,
    n = _generateEcparam.n;
/**
 * 获取公共椭圆曲线
 */


function getGlobalCurve() {
  return curve;
}
/**
 * 生成ecparam
 */


function generateEcparam() {
  // 椭圆曲线
  var p = new BigInteger('FFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF00000000FFFFFFFFFFFFFFFF', 16);
  var a = new BigInteger('FFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF00000000FFFFFFFFFFFFFFFC', 16);
  var b = new BigInteger('28E9FA9E9D9F5E344D5A9E4BCF6509A7F39789F515AB8F92DDBCBD414D940E93', 16);
  var curve = new ECCurveFp(p, a, b); // 基点

  var gxHex = '32C4AE2C1F1981195F9904466A39C9948FE30BBFF2660BE1715A4589334C74C7';
  var gyHex = 'BC3736A2F4F6779C59BDCEE36B692153D0A9877CC62A474002DF32E52139F0A0';
  var G = curve.decodePointHex('04' + gxHex + gyHex);
  var n = new BigInteger('FFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFF7203DF6B21C6052B53BBF40939D54123', 16);
  return {
    curve: curve,
    G: G,
    n: n
  };
}
/**
 * 生成密钥对
 */


function generateKeyPairHex() {
  var d = new BigInteger(n.bitLength(), rng);
  d = d.mod(n.subtract(BigInteger.ONE));
  d = d.add(BigInteger.ONE); // 随机数

  var privateKey = leftPad(d.toString(16), 64);
  var P = G.multiply(d); // P = dG，p 为公钥，d 为私钥

  var PxKey = P.getX().toBigInteger().toString(16);
  var Px = leftPad(PxKey, 64);
  var PyKey = P.getY().toBigInteger().toString(16);
  var Py = leftPad(PyKey, 64);
  var publicKey = '04' + Px + Py;
  return {
    privateKey: privateKey,
    publicKey: publicKey
  };
}
/**
 * 解析utf8字符串到16进制
 */


function parseUtf8StringToHex(input) {
  input = unescape(encodeURIComponent(input));
  var length = input.length; // 转换到字数组

  var words = [];

  for (var i = 0; i < length; i++) {
    words[i >>> 2] |= (input.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
  } // 转换到16进制


  var hexChars = [];

  for (var _i = 0; _i < length; _i++) {
    var bite = words[_i >>> 2] >>> 24 - _i % 4 * 8 & 0xff;
    hexChars.push((bite >>> 4).toString(16));
    hexChars.push((bite & 0x0f).toString(16));
  }

  return hexChars.join('');
}
/**
 * 解析arrayBuffer到16进制字符串
 */


function parseArrayBufferToHex(input) {
  return Array.prototype.map.call(new Uint8Array(input), function (x) {
    return ('00' + x.toString(16)).slice(-2);
  }).join('');
}
/**
 * 补全16进制字符串
 */


function leftPad(input, num) {
  if (input.length >= num) return input;
  return new Array(num - input.length + 1).join('0') + input;
}
/**
 * 转成16进制串
 */


function arrayToHex(arr) {
  var words = [];
  var j = 0;

  for (var i = 0; i < arr.length * 2; i += 2) {
    words[i >>> 3] |= parseInt(arr[j], 10) << 24 - i % 8 * 4;
    j++;
  } // 转换到16进制


  var hexChars = [];

  for (var _i2 = 0; _i2 < arr.length; _i2++) {
    var bite = words[_i2 >>> 2] >>> 24 - _i2 % 4 * 8 & 0xff;
    hexChars.push((bite >>> 4).toString(16));
    hexChars.push((bite & 0x0f).toString(16));
  }

  return hexChars.join('');
}
/**
 * 转成utf8串
 */


function arrayToUtf8(arr) {
  var words = [];
  var j = 0;

  for (var i = 0; i < arr.length * 2; i += 2) {
    words[i >>> 3] |= parseInt(arr[j], 10) << 24 - i % 8 * 4;
    j++;
  }

  try {
    var latin1Chars = [];

    for (var _i3 = 0; _i3 < arr.length; _i3++) {
      var bite = words[_i3 >>> 2] >>> 24 - _i3 % 4 * 8 & 0xff;
      latin1Chars.push(String.fromCharCode(bite));
    }

    return decodeURIComponent(escape(latin1Chars.join('')));
  } catch (e) {
    throw new Error('Malformed UTF-8 data');
  }
}
/**
 * 转成ascii码数组
 */


function hexToArray(hexStr) {
  var words = [];
  var hexStrLength = hexStr.length;

  if (hexStrLength % 2 !== 0) {
    hexStr = leftPad(hexStr, hexStrLength + 1);
  }

  hexStrLength = hexStr.length;

  for (var i = 0; i < hexStrLength; i += 2) {
    words.push(parseInt(hexStr.substr(i, 2), 16));
  }

  return words;
}

module.exports = {
  getGlobalCurve: getGlobalCurve,
  generateEcparam: generateEcparam,
  generateKeyPairHex: generateKeyPairHex,
  parseUtf8StringToHex: parseUtf8StringToHex,
  parseArrayBufferToHex: parseArrayBufferToHex,
  leftPad: leftPad,
  arrayToHex: arrayToHex,
  arrayToUtf8: arrayToUtf8,
  hexToArray: hexToArray
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@cloudpivot-shared/utils/src/generate-id");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable */
var _require = __webpack_require__(3),
    BigInteger = _require.BigInteger;

var _ = __webpack_require__(4);

var copyArray = function copyArray(sourceArray, sourceIndex, destinationArray, destinationIndex, length) {
  for (var i = 0; i < length; i++) {
    destinationArray[destinationIndex + i] = sourceArray[sourceIndex + i];
  }
};

var Int32 = {
  minValue: -2147483648,
  maxValue: 2147483647,
  parse: function parse(n) {
    if (n < this.minValue) {
      var bigInteger = Number(-n);
      var bigIntegerRadix = bigInteger.toString(2);
      var subBigIntegerRadix = bigIntegerRadix.substr(bigIntegerRadix.length - 31, 31);
      var reBigIntegerRadix = '';

      for (var i = 0; i < subBigIntegerRadix.length; i++) {
        var subBigIntegerRadixItem = subBigIntegerRadix.substr(i, 1);
        reBigIntegerRadix += subBigIntegerRadixItem === '0' ? '1' : '0';
      }

      var result = parseInt(reBigIntegerRadix, 2);
      return result + 1;
    } else if (n > this.maxValue) {
      var _bigInteger = Number(n);

      var _bigIntegerRadix = _bigInteger.toString(2);

      var _subBigIntegerRadix = _bigIntegerRadix.substr(_bigIntegerRadix.length - 31, 31);

      var _reBigIntegerRadix = '';

      for (var _i = 0; _i < _subBigIntegerRadix.length; _i++) {
        var _subBigIntegerRadixItem = _subBigIntegerRadix.substr(_i, 1);

        _reBigIntegerRadix += _subBigIntegerRadixItem === '0' ? '1' : '0';
      }

      var _result = parseInt(_reBigIntegerRadix, 2);

      return -(_result + 1);
    } else {
      return n;
    }
  },
  parseByte: function parseByte(n) {
    if (n < 0) {
      var bigInteger = Number(-n);
      var bigIntegerRadix = bigInteger.toString(2);
      var subBigIntegerRadix = bigIntegerRadix.substr(bigIntegerRadix.length - 8, 8);
      var reBigIntegerRadix = '';

      for (var i = 0; i < subBigIntegerRadix.length; i++) {
        var subBigIntegerRadixItem = subBigIntegerRadix.substr(i, 1);
        reBigIntegerRadix += subBigIntegerRadixItem === '0' ? '1' : '0';
      }

      var result = parseInt(reBigIntegerRadix, 2);
      return (result + 1) % 256;
    } else if (n > 255) {
      var _bigInteger2 = Number(n);

      var _bigIntegerRadix2 = _bigInteger2.toString(2);

      return parseInt(_bigIntegerRadix2.substr(_bigIntegerRadix2.length - 8, 8), 2);
    } else {
      return n;
    }
  }
};

var SM3Digest = /*#__PURE__*/function () {
  "use strict";

  function SM3Digest() {
    _classCallCheck(this, SM3Digest);

    this.xBuf = [];
    this.xBufOff = 0;
    this.byteCount = 0;
    this.DIGEST_LENGTH = 32;
    this.v0 = [0x7380166f, 0x4914b2b9, 0x172442d7, 0xda8a0600, 0xa96f30bc, 0x163138aa, 0xe38dee4d, 0xb0fb0e4e];
    this.v0 = [0x7380166f, 0x4914b2b9, 0x172442d7, -628488704, -1452330820, 0x163138aa, -477237683, -1325724082];
    this.v = new Array(8);
    this.v_ = new Array(8);
    this.X0 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.X = new Array(68);
    this.xOff = 0;
    this.T_00_15 = 0x79cc4519;
    this.T_16_63 = 0x7a879d8a;

    if (arguments.length > 0) {
      this.initDigest(arguments.length <= 0 ? undefined : arguments[0]);
    } else {
      this.init();
    }
  }

  _createClass(SM3Digest, [{
    key: "init",
    value: function init() {
      this.xBuf = new Array(4);
      this.reset();
    }
  }, {
    key: "initDigest",
    value: function initDigest(t) {
      this.xBuf = [].concat(t.xBuf);
      this.xBufOff = t.xBufOff;
      this.byteCount = t.byteCount;
      copyArray(t.X, 0, this.X, 0, t.X.length);
      this.xOff = t.xOff;
      copyArray(t.v, 0, this.v, 0, t.v.length);
    }
  }, {
    key: "getDigestSize",
    value: function getDigestSize() {
      return this.DIGEST_LENGTH;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.byteCount = 0;
      this.xBufOff = 0;
      var keys = Object.keys(this.xBuf);

      for (var i = 0, len = keys.length; i < len; i++) {
        this.xBuf[keys[i]] = null;
      }

      copyArray(this.v0, 0, this.v, 0, this.v0.length);
      this.xOff = 0;
      copyArray(this.X0, 0, this.X, 0, this.X0.length);
    }
  }, {
    key: "processBlock",
    value: function processBlock() {
      var i;
      var ww = this.X;
      var ww_ = new Array(64);

      for (i = 16; i < 68; i++) {
        ww[i] = this.p1(ww[i - 16] ^ ww[i - 9] ^ this.rotate(ww[i - 3], 15)) ^ this.rotate(ww[i - 13], 7) ^ ww[i - 6];
      }

      for (i = 0; i < 64; i++) {
        ww_[i] = ww[i] ^ ww[i + 4];
      }

      var vv = this.v;
      var vv_ = this.v_;
      copyArray(vv, 0, vv_, 0, this.v0.length);
      var SS1;
      var SS2;
      var TT1;
      var TT2;
      var aaa;

      for (i = 0; i < 16; i++) {
        aaa = this.rotate(vv_[0], 12);
        SS1 = Int32.parse(Int32.parse(aaa + vv_[4]) + this.rotate(this.T_00_15, i));
        SS1 = this.rotate(SS1, 7);
        SS2 = SS1 ^ aaa;
        TT1 = Int32.parse(Int32.parse(this.ff_00_15(vv_[0], vv_[1], vv_[2]) + vv_[3]) + SS2) + ww_[i];
        TT2 = Int32.parse(Int32.parse(this.gg_00_15(vv_[4], vv_[5], vv_[6]) + vv_[7]) + SS1) + ww[i];
        vv_[3] = vv_[2];
        vv_[2] = this.rotate(vv_[1], 9);
        vv_[1] = vv_[0];
        vv_[0] = TT1;
        vv_[7] = vv_[6];
        vv_[6] = this.rotate(vv_[5], 19);
        vv_[5] = vv_[4];
        vv_[4] = this.p0(TT2);
      }

      for (i = 16; i < 64; i++) {
        aaa = this.rotate(vv_[0], 12);
        SS1 = Int32.parse(Int32.parse(aaa + vv_[4]) + this.rotate(this.T_16_63, i));
        SS1 = this.rotate(SS1, 7);
        SS2 = SS1 ^ aaa;
        TT1 = Int32.parse(Int32.parse(this.ff_16_63(vv_[0], vv_[1], vv_[2]) + vv_[3]) + SS2) + ww_[i];
        TT2 = Int32.parse(Int32.parse(this.gg_16_63(vv_[4], vv_[5], vv_[6]) + vv_[7]) + SS1) + ww[i];
        vv_[3] = vv_[2];
        vv_[2] = this.rotate(vv_[1], 9);
        vv_[1] = vv_[0];
        vv_[0] = TT1;
        vv_[7] = vv_[6];
        vv_[6] = this.rotate(vv_[5], 19);
        vv_[5] = vv_[4];
        vv_[4] = this.p0(TT2);
      }

      for (i = 0; i < 8; i++) {
        vv[i] ^= Int32.parse(vv_[i]);
      }

      this.xOff = 0;
      copyArray(this.X0, 0, this.X, 0, this.X0.length);
    }
  }, {
    key: "processWord",
    value: function processWord(in_Renamed, inOff) {
      var n = in_Renamed[inOff] << 24;
      n |= (in_Renamed[++inOff] & 0xff) << 16;
      n |= (in_Renamed[++inOff] & 0xff) << 8;
      n |= in_Renamed[++inOff] & 0xff;
      this.X[this.xOff] = n;

      if (++this.xOff === 16) {
        this.processBlock();
      }
    }
  }, {
    key: "processLength",
    value: function processLength(bitLength) {
      if (this.xOff > 14) {
        this.processBlock();
      }

      this.X[14] = this.urShiftLong(bitLength, 32);
      this.X[15] = bitLength & 0xffffffff;
    }
  }, {
    key: "intToBigEndian",
    value: function intToBigEndian(n, bs, off) {
      bs[off] = Int32.parseByte(this.urShift(n, 24)) & 0xff;
      bs[++off] = Int32.parseByte(this.urShift(n, 16)) & 0xff;
      bs[++off] = Int32.parseByte(this.urShift(n, 8)) & 0xff;
      bs[++off] = Int32.parseByte(n) & 0xff;
    }
  }, {
    key: "doFinal",
    value: function doFinal(out_Renamed, outOff) {
      this.finish();

      for (var i = 0; i < 8; i++) {
        this.intToBigEndian(this.v[i], out_Renamed, outOff + i * 4);
      }

      this.reset();
      return this.DIGEST_LENGTH;
    }
  }, {
    key: "update",
    value: function update(input) {
      this.xBuf[this.xBufOff++] = input;

      if (this.xBufOff === this.xBuf.length) {
        this.processWord(this.xBuf, 0);
        this.xBufOff = 0;
      }

      this.byteCount++;
    }
  }, {
    key: "blockUpdate",
    value: function blockUpdate(input, inOff, length) {
      while (this.xBufOff !== 0 && length > 0) {
        this.update(input[inOff]);
        inOff++;
        length--;
      }

      while (length > this.xBuf.length) {
        this.processWord(input, inOff);
        inOff += this.xBuf.length;
        length -= this.xBuf.length;
        this.byteCount += this.xBuf.length;
      }

      while (length > 0) {
        this.update(input[inOff]);
        inOff++;
        length--;
      }
    }
  }, {
    key: "finish",
    value: function finish() {
      var bitLength = this.byteCount << 3;
      this.update(128);

      while (this.xBufOff !== 0) {
        this.update(0);
      }

      this.processLength(bitLength);
      this.processBlock();
    }
  }, {
    key: "rotate",
    value: function rotate(x, n) {
      return x << n | this.urShift(x, 32 - n);
    }
  }, {
    key: "p0",
    value: function p0(X) {
      return X ^ this.rotate(X, 9) ^ this.rotate(X, 17);
    }
  }, {
    key: "p1",
    value: function p1(X) {
      return X ^ this.rotate(X, 15) ^ this.rotate(X, 23);
    }
  }, {
    key: "ff_00_15",
    value: function ff_00_15(X, Y, Z) {
      return X ^ Y ^ Z;
    }
  }, {
    key: "ff_16_63",
    value: function ff_16_63(X, Y, Z) {
      return X & Y | X & Z | Y & Z;
    }
  }, {
    key: "gg_00_15",
    value: function gg_00_15(X, Y, Z) {
      return X ^ Y ^ Z;
    }
  }, {
    key: "gg_16_63",
    value: function gg_16_63(X, Y, Z) {
      return X & Y | ~X & Z;
    }
  }, {
    key: "urShift",
    value: function urShift(number, bits) {
      if (number > Int32.maxValue || number < Int32.minValue) {
        number = Int32.parse(number);
      }

      return number >>> bits;
    }
  }, {
    key: "urShiftLong",
    value: function urShiftLong(number, bits) {
      var returnV;
      var big = new BigInteger();
      big.fromInt(number);

      if (big.signum() >= 0) {
        returnV = big.shiftRight(bits).intValue();
      } else {
        var bigAdd = new BigInteger();
        bigAdd.fromInt(2);
        var shiftLeftBits = ~bits;
        var shiftLeftNumber = '';

        if (shiftLeftBits < 0) {
          var shiftRightBits = 64 + shiftLeftBits;

          for (var i = 0; i < shiftRightBits; i++) {
            shiftLeftNumber += '0';
          }

          var shiftLeftNumberBigAdd = new BigInteger();
          shiftLeftNumberBigAdd.fromInt(number >> bits);
          var shiftLeftNumberBig = new BigInteger('10' + shiftLeftNumber, 2);
          shiftLeftNumber = shiftLeftNumberBig.toRadix(10);
          var r = shiftLeftNumberBig.add(shiftLeftNumberBigAdd);
          returnV = r.toRadix(10);
        } else {
          shiftLeftNumber = bigAdd.shiftLeft(~bits).intValue();
          returnV = (number >> bits) + shiftLeftNumber;
        }
      }

      return returnV;
    }
  }, {
    key: "getZ",
    value: function getZ(g, publicKey, userId) {
      // ZA=H256(ENTLA ∥ IDA ∥ a ∥ b ∥ xG ∥ yG ∥xA ∥yA)
      var len = 0;

      if (userId) {
        if (typeof userId !== 'string') throw new Error("sm2: Type of userId Must be String! Receive Type: ".concat(_typeof(userId)));
        if (userId.length >= 8192) throw new Error("sm2: The Length of userId Must Less Than 8192! Length: ".concat(userId.length));
        userId = _.parseUtf8StringToHex(userId);
        len = userId.length * 4;
      }

      this.update(len >> 8 & 0x00ff);
      this.update(len & 0x00ff);

      if (userId) {
        var userIdWords = _.hexToArray(userId);

        this.blockUpdate(userIdWords, 0, userIdWords.length);
      }

      var aWords = _.hexToArray(_.leftPad(g.curve.a.toBigInteger().toRadix(16), 64));

      var bWords = _.hexToArray(_.leftPad(g.curve.b.toBigInteger().toRadix(16), 64));

      var gxWords = _.hexToArray(_.leftPad(g.getX().toBigInteger().toRadix(16), 64));

      var gyWords = _.hexToArray(_.leftPad(g.getY().toBigInteger().toRadix(16), 64));

      var pxWords = _.hexToArray(publicKey.substr(0, 64));

      var pyWords = _.hexToArray(publicKey.substr(64, 64));

      this.blockUpdate(aWords, 0, aWords.length);
      this.blockUpdate(bWords, 0, bWords.length);
      this.blockUpdate(gxWords, 0, gxWords.length);
      this.blockUpdate(gyWords, 0, gyWords.length);
      this.blockUpdate(pxWords, 0, pxWords.length);
      this.blockUpdate(pyWords, 0, pyWords.length);
      var md = new Array(this.getDigestSize());
      this.doFinal(md, 0);
      return md;
    }
  }]);

  return SM3Digest;
}();

module.exports = SM3Digest;

/***/ }),
/* 15 */
/***/ (function(module) {

module.exports = JSON.parse("{\"App\":{\"App\":[{\"parameters\":{\"query\":[],\"body\":[\"createAppDTO\"]},\"method\":\"post\",\"actionName\":\"postApp\",\"url\":\"/app\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateAppDTO\"]},\"method\":\"put\",\"actionName\":\"editApp\",\"url\":\"/app\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"copyAppDTO\"]},\"method\":\"post\",\"actionName\":\"copy\",\"url\":\"/app/copy\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\",\"projectCode\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"import\",\"url\":\"/app/import\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"searchKey\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/app/list/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getApp\",\"url\":\"/app/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteApp\",\"url\":\"/app/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"domainModel\",\"url\":\"/app/{appCode}/domain_model\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"domainModelBasic\",\"url\":\"/app/{appCode}/domain_model_basic\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"ui\",\"url\":\"/app/{appCode}/ui\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"validate\",\"url\":\"/app/{appCode}/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"workflow\",\"url\":\"/app/{appCode}/workflow\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"ActionPermission\":[{\"parameters\":{\"query\":[],\"body\":[\"createActionPermissionDTO\"]},\"method\":\"post\",\"actionName\":\"postActionPermission\",\"url\":\"/app/action_permission\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"deleteActionPermissionDTO\"]},\"method\":\"delete\",\"actionName\":\"deleteActionPermission\",\"url\":\"/app/action_permission\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/action_permission/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"actionPermission\",\"url\":\"/app/{appCode}/schema/{schemaCode}/action_permission/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"BizObjectSchema\":[{\"parameters\":{\"query\":[],\"body\":[\"bizObjectSchema\"]},\"method\":\"post\",\"actionName\":\"postBizObjectSchema\",\"url\":\"/app/biz_object_schema\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"bizObjectSchema\"]},\"method\":\"put\",\"actionName\":\"editBizObjectSchema\",\"url\":\"/app/biz_object_schema\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"ids\"]},\"method\":\"post\",\"actionName\":\"listById\",\"url\":\"/app/biz_object_schema/list_by_id\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getList\",\"url\":\"/app/{appCode}/biz_object_schema/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"codes\"]},\"method\":\"post\",\"actionName\":\"postList\",\"url\":\"/app/{appCode}/biz_object_schema/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"schemaCodes\"]},\"method\":\"post\",\"actionName\":\"reverseQueryDomainModels\",\"url\":\"/app/{appCode}/biz_object_schema/reverse_query_domain_models\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getBizObjectSchema\",\"url\":\"/app/{appCode}/biz_object_schema/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteBizObjectSchema\",\"url\":\"/app/{appCode}/biz_object_schema/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"correlation\",\"url\":\"/app/{appCode}/biz_object_schema/{code}/correlation\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/module/{moduleCode}/biz_object_schema/list\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppVersion\":[{\"parameters\":{\"query\":[],\"body\":[\"appVersion\"]},\"method\":\"post\",\"actionName\":\"build\",\"url\":\"/app/build\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"validate\",\"url\":\"/app/{appCode}/deploy/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"validateOffline\",\"url\":\"/app/{appCode}/offline/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/version/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"version\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getVersion\",\"url\":\"/app/{appCode}/version/{version}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"version\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteVersion\",\"url\":\"/app/{appCode}/version/{version}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"version\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"dataFileId\",\"url\":\"/app/{appCode}/version/{version}/data_file_id\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"version\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"download\",\"url\":\"/app/{appCode}/version/{version}/download\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"SourceCode\":[{\"parameters\":{\"query\":[],\"body\":[\"createSourceCodeDTO\"]},\"method\":\"post\",\"actionName\":\"postCode\",\"url\":\"/app/code\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateSourceCodeDTO\"]},\"method\":\"put\",\"actionName\":\"editCode\",\"url\":\"/app/code\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"compileDTO\"]},\"method\":\"post\",\"actionName\":\"compile\",\"url\":\"/app/code/compile\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"getMethodLineDTO\"]},\"method\":\"post\",\"actionName\":\"line\",\"url\":\"/app/code/line\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"completionDTO\"]},\"method\":\"post\",\"actionName\":\"completion\",\"url\":\"/app/code/text_document/completion\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"hoverDTO\"]},\"method\":\"post\",\"actionName\":\"hover\",\"url\":\"/app/code/text_document/hover\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateSourceCodeDTO\"]},\"method\":\"get\",\"actionName\":\"updateWithoutSave\",\"url\":\"/app/code/update_without_save\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"className\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getClassName\",\"url\":\"/app/{appCode}/class_name/{className}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"className\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteClassName\",\"url\":\"/app/{appCode}/class_name/{className}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/code/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listCode\",\"url\":\"/app/{appCode}/schema/code/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"classDeclaration\",\"url\":\"/app/{appCode}/schema/{schemaCode}/code/class_declaration\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"DomainModel\":[{\"parameters\":{\"query\":[],\"body\":[\"domainModel\"]},\"method\":\"post\",\"actionName\":\"postDomainModel\",\"url\":\"/app/domain_model\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"domainModel\"]},\"method\":\"put\",\"actionName\":\"editDomainModel\",\"url\":\"/app/domain_model\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"sourceAppCode\",\"sourceIncludeSchemaCode\",\"targetAppCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"availableRemoteSchema\",\"url\":\"/app/domain_model/available_remote_schema\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"setting\",\"url\":\"/app/domain_model/import_sql/setting\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"domainModel\"]},\"method\":\"post\",\"actionName\":\"reference\",\"url\":\"/app/domain_model/reference\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"validateRemoteModelOption\"]},\"method\":\"post\",\"actionName\":\"validate\",\"url\":\"/app/domain_model/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"file\",\"sqlType\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"importSql\",\"url\":\"/app/{appCode}/domain_model/import_sql\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"domainModelUpdatedTimeMap\"]},\"method\":\"post\",\"actionName\":\"incrementGet\",\"url\":\"/app/{appCode}/domain_model/increment_get\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/domain_model/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"relation\",\"url\":\"/app/{appCode}/domain_model/schema/{schemaCode}/relation\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"domainModel\",\"url\":\"/app/{appCode}/domain_model/{domainModelCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelCode\",\"schemaCode\",\"schemaType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"referenceBizObjectSchema\",\"url\":\"/app/{appCode}/domain_model/{domainModelCode}/biz_object_schema/{schemaCode}/reference\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"referenceDomainModel\",\"url\":\"/app/{appCode}/domain_model/{domainModelCode}/reference\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"parent\",\"url\":\"/app/{appCode}/domain_model/{domainModelCode}/schema/{schemaCode}/parent\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelCode\",\"propertyCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"referenceProperty\",\"url\":\"/app/{appCode}/domain_model/{domainModelCode}/schema/{schemaCode}/property/{propertyCode}/reference\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"cascaded\",\"domainModelCode\",\"propertyCode\",\"referenceSchemaCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"referenceSchemaRelation\",\"url\":\"/app/{appCode}/domain_model/{domainModelCode}/schema_relation/{referenceSchemaCode}/reference\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelType\",\"moduleCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listDomainModel\",\"url\":\"/app/{appCode}/module/{moduleCode}/domain_model/list\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppExtension\":[{\"parameters\":{\"query\":[],\"body\":[\"appActionStyle\"]},\"method\":\"post\",\"actionName\":\"submit\",\"url\":\"/app/extension/action_style/submit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"crc32\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"download\",\"url\":\"/app/extension/domain_service_file/download\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"action\",\"url\":\"/app/{appCode}/extension/action\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"style\",\"url\":\"/app/{appCode}/extension/style\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Job\":[{\"parameters\":{\"query\":[],\"body\":[\"createJobDTO\"]},\"method\":\"post\",\"actionName\":\"postJob\",\"url\":\"/app/job\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateJobDTO\"]},\"method\":\"put\",\"actionName\":\"editJob\",\"url\":\"/app/job\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getJob\",\"url\":\"/app/job/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteJob\",\"url\":\"/app/job/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"enabled\",\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"enabled\",\"url\":\"/app/job/{id}/enabled/{enabled}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/module/{moduleCode}/job/list\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Logic\":[{\"parameters\":{\"query\":[],\"body\":[\"createLogicDTO\"]},\"method\":\"post\",\"actionName\":\"postLogic\",\"url\":\"/app/logic\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateLogicDTO\"]},\"method\":\"put\",\"actionName\":\"editLogic\",\"url\":\"/app/logic\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listBySchema\",\"url\":\"/app/logic/list_by_schema\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateLogicDTO\"]},\"method\":\"post\",\"actionName\":\"reference\",\"url\":\"/app/logic/parameter/reference\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"resetServiceActivity\",\"url\":\"/app/logic/reset_service_activity\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/logic/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"modifiedTimeMap\"]},\"method\":\"post\",\"actionName\":\"newlyAdded\",\"url\":\"/app/{appCode}/logic/newly_added\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"compound\",\"url\":\"/app/{appCode}/module/{moduleCode}/logic/compound\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\",\"returnDetail\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listLogic\",\"url\":\"/app/{appCode}/module/{moduleCode}/logic/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"underline\",\"url\":\"/app/{appCode}/schema/{schemaCode}/logic/schema/underline\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"appVersion\",\"debug\",\"logicCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getLogic\",\"url\":\"/app/{appCode}/schema/{schemaCode}/logic/{logicCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"logicCode\",\"schemaCode\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteLogic\",\"url\":\"/app/{appCode}/schema/{schemaCode}/logic/{logicCode}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppMenu\":[{\"parameters\":{\"query\":[],\"body\":[\"createAppMenuDTO\"]},\"method\":\"post\",\"actionName\":\"postMenu\",\"url\":\"/app/menu\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateAppMenuDTO\"]},\"method\":\"put\",\"actionName\":\"editMenu\",\"url\":\"/app/menu\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"appMenu\"]},\"method\":\"post\",\"actionName\":\"replace\",\"url\":\"/app/menu/replace\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"support\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/menu/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getMenu\",\"url\":\"/app/{appCode}/menu/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteMenu\",\"url\":\"/app/{appCode}/menu/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppModule\":[{\"parameters\":{\"query\":[],\"body\":[\"createAppModuleDTO\"]},\"method\":\"post\",\"actionName\":\"postModule\",\"url\":\"/app/module\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateAppModuleDTO\"]},\"method\":\"put\",\"actionName\":\"editModule\",\"url\":\"/app/module\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/module/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"backend\",\"url\":\"/app/{appCode}/module/list/backend\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getModule\",\"url\":\"/app/{appCode}/module/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteModule\",\"url\":\"/app/{appCode}/module/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Page\":[{\"parameters\":{\"query\":[],\"body\":[\"createPageDTO\"]},\"method\":\"post\",\"actionName\":\"postPage\",\"url\":\"/app/page\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updatePageDTO\"]},\"method\":\"put\",\"actionName\":\"editPage\",\"url\":\"/app/page\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"deletePageDTO\"]},\"method\":\"post\",\"actionName\":\"delete\",\"url\":\"/app/page/delete\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"deletePageDTO\"]},\"method\":\"post\",\"actionName\":\"validate\",\"url\":\"/app/page/delete/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/module/{moduleCode}/page/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\",\"newIndex\",\"newPageGroupCode\",\"oldIndex\",\"oldPageGroupCode\",\"pageCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"resort\",\"url\":\"/app/{appCode}/module/{moduleCode}/page/resort\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\",\"pageGroupCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listPage\",\"url\":\"/app/{appCode}/module/{moduleCode}/page_group/{pageGroupCode}/page/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"page\",\"url\":\"/app/{appCode}/page/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"boundSchemaAndButtonData\",\"url\":\"/app/{appCode}/page/{code}/bound_schema_and_button_data\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"boundSchemaData\",\"url\":\"/app/{appCode}/page/{code}/bound_schema_data\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PageGroup\":[{\"parameters\":{\"query\":[],\"body\":[\"pageGroup\"]},\"method\":\"post\",\"actionName\":\"postPageGroup\",\"url\":\"/app/page_group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"pageGroup\"]},\"method\":\"put\",\"actionName\":\"editPageGroup\",\"url\":\"/app/page_group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"deletePageGroupDTO\"]},\"method\":\"post\",\"actionName\":\"delete\",\"url\":\"/app/page_group/delete\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"deletePageDTO\"]},\"method\":\"post\",\"actionName\":\"validate\",\"url\":\"/app/page_group/delete/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/module/{moduleCode}/page_group/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"newIndex\",\"oldIndex\",\"pageGroupCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"resort\",\"url\":\"/app/{appCode}/page_group/{pageGroupCode}/resort\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PageMaster\":[{\"parameters\":{\"query\":[],\"body\":[\"pageMaster\"]},\"method\":\"post\",\"actionName\":\"postPageMaster\",\"url\":\"/app/page_master\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"pageMaster\"]},\"method\":\"put\",\"actionName\":\"editPageMaster\",\"url\":\"/app/page_master\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"icon\",\"url\":\"/app/{appCode}/page_master/download/icon\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/page_master/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"iconUpload\",\"url\":\"/app/{appCode}/page_master/upload/icon\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getPageMaster\",\"url\":\"/app/{appCode}/page_master/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deletePageMaster\",\"url\":\"/app/{appCode}/page_master/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PrintTemplate\":[{\"parameters\":{\"query\":[],\"body\":[\"createPrintTemplateDTO\"]},\"method\":\"post\",\"actionName\":\"postPrintTemplate\",\"url\":\"/app/print_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updatePrintTemplateDTO\"]},\"method\":\"put\",\"actionName\":\"editPrintTemplate\",\"url\":\"/app/print_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"printTemplateQueryDTO\"]},\"method\":\"post\",\"actionName\":\"list\",\"url\":\"/app/print_template/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"namespace\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"domainModelMessage\",\"url\":\"/app/print_template/namespace/{namespace}/domain_model_message\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getPrintTemplate\",\"url\":\"/app/print_template/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deletePrintTemplate\",\"url\":\"/app/print_template/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\",\"name\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"rename\",\"url\":\"/app/print_template/{id}/rename\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppUsedConfig\":[{\"parameters\":{\"query\":[],\"body\":[\"appUsedConfig\"]},\"method\":\"post\",\"actionName\":\"config\",\"url\":\"/app/used/config\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/used/config/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"configUsed\",\"url\":\"/app/used/config/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"UsuallyUsedUiComponent\":[{\"parameters\":{\"query\":[],\"body\":[\"createUsuallyUsedUiComponentDTO\"]},\"method\":\"post\",\"actionName\":\"usuallyUsedUiComponent\",\"url\":\"/app/usually_used_ui_component\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/usually_used_ui_component/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"usuallyUsedUiComponentApp\",\"url\":\"/app/usually_used_ui_component/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Workflow\":[{\"parameters\":{\"query\":[],\"body\":[\"createWorkflowDTO\"]},\"method\":\"post\",\"actionName\":\"postWorkflow\",\"url\":\"/app/workflow\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"updateWorkflowDTO\"]},\"method\":\"put\",\"actionName\":\"editWorkflow\",\"url\":\"/app/workflow\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"functionValidDTO\"]},\"method\":\"post\",\"actionName\":\"validate\",\"url\":\"/app/workflow/function/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"participantDataDTO\"]},\"method\":\"post\",\"actionName\":\"participants\",\"url\":\"/app/workflow/participants\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"validateSchema\",\"url\":\"/app/workflow/schema/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"workflowTemplateJson\"]},\"method\":\"post\",\"actionName\":\"validateTemplate\",\"url\":\"/app/workflow/template/validate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"moduleCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/{appCode}/module/{moduleCode}/workflow/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listWorkflow\",\"url\":\"/app/{appCode}/workflow/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"workflowCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getWorkflow\",\"url\":\"/app/{appCode}/workflow/{workflowCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"workflowCode\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteWorkflow\",\"url\":\"/app/{appCode}/workflow/{workflowCode}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppMenuItem\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"appMenuItemDTO\"]},\"method\":\"post\",\"actionName\":\"postItem\",\"url\":\"/app/{appCode}/menu/item\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"appMenuItemDTO\"]},\"method\":\"put\",\"actionName\":\"editItem\",\"url\":\"/app/{appCode}/menu/item\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"code\",\"menuCode\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"item\",\"url\":\"/app/{appCode}/menu/{menuCode}/item/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppRuntime\":[{\"parameters\":{\"query\":[\"appCode\",\"appVersion\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"delete\",\"url\":\"/app/{appCode}/version/{appVersion}/delete\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Callback\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getCallback\",\"url\":\"/callback/org/callback/{var}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"post\",\"actionName\":\"postCallback\",\"url\":\"/callback/org/callback/{var}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"CloudPivot\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"version\",\"url\":\"/cloud_pivot/version\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Common\":[{\"parameters\":{\"query\":[],\"body\":[\"commonDataQuery\"]},\"method\":\"post\",\"actionName\":\"data\",\"url\":\"/common/data\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Config\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"test\",\"url\":\"/config/test\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"DomainService\":{\"DomainServiceFeignService\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getApp\",\"url\":\"/domain_service/app/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"methodName\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"app\",\"url\":\"/domain_service/app/{appCode}/{schemaCode}/{methodName}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"DomainService\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"schemaCodes\"]},\"method\":\"post\",\"actionName\":\"postApp\",\"url\":\"/domain_service/app/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"domainModelCode\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"domainModel\",\"url\":\"/domain_service/app/{appCode}/domain_model/{domainModelCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"schemaCodes\"]},\"method\":\"post\",\"actionName\":\"perm\",\"url\":\"/domain_service/app/{appCode}/perm\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"app\",\"url\":\"/domain_service/domain_service/app/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"methodName\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"appDomainService\",\"url\":\"/domain_service/domain_service/app/{appCode}/{schemaCode}/{methodName}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"specification\",\"url\":\"/domain_service/specification\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"DomainServiceParser\":[{\"parameters\":{\"query\":[\"appCode\",\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"upload\",\"url\":\"/domain_service/upload\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Echo\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"echo\",\"url\":\"/echo\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Feign\":{\"ExportLog\":[{\"parameters\":{\"query\":[],\"body\":[\"exportLog\"]},\"method\":\"post\",\"actionName\":\"create\",\"url\":\"/feign/app/bo/export/log/create\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"delete\",\"url\":\"/feign/app/bo/export/log/delete/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"pageIndex\",\"pageSize\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"\",\"url\":\"/feign/app/bo/export/log/list/\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\",\"refId\",\"status\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"update\",\"url\":\"/feign/app/bo/export/log/update\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"SourceCode\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/feign/app/{appCode}/code/list\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AuthorizationExtension\":[{\"parameters\":{\"query\":[\"departmentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"jsapiTicket\",\"url\":\"/feign/extension_service/jsapi_ticket\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"bizParams\",\"code\",\"corpId\",\"type\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"user\",\"url\":\"/feign/extension_service/user\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"FileConfigFeign\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"config\",\"url\":\"/feign/file/common/config\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"fileStorageConfig\"]},\"method\":\"post\",\"actionName\":\"save\",\"url\":\"/feign/file/common/config/save\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"paramConfig\"]},\"method\":\"post\",\"actionName\":\"testConnection\",\"url\":\"/feign/file/common/config/test_connection\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"fileName\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getByName\",\"url\":\"/feign/file/common/record/get_by_name\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"refId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"record\",\"url\":\"/feign/file/common/record/{refId}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"FileFeign\":[{\"parameters\":{\"query\":[\"fileKey\",\"serviceId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteByKey\",\"url\":\"/feign/file/{serviceId}/delete_by_key\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"refId\",\"serviceId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteByRefid\",\"url\":\"/feign/file/{serviceId}/delete_by_refid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"refId\",\"serviceId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"download\",\"url\":\"/feign/file/{serviceId}/download\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\",\"fileKey\",\"fileName\",\"serviceId\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"upload\",\"url\":\"/feign/file/{serviceId}/upload\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\",\"serviceId\",\"watermark\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"hasWatermark\",\"url\":\"/feign/file/{serviceId}/upload/has_watermark\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\",\"serviceId\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"uploadImage\",\"url\":\"/feign/file/{serviceId}/upload_image\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"JobFeign\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/feign/job/app/{appCode}/job/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"modifiedTimeMap\"]},\"method\":\"post\",\"actionName\":\"newlyAdded\",\"url\":\"/feign/job/app/{appCode}/job/newly_added\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"JobRuntimeFeign\":[{\"parameters\":{\"query\":[\"appCode\",\"appVersion\",\"debug\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/feign/job/runtime/app/{appCode}/job/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"listRuntime\",\"url\":\"/feign/job/runtime/list\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Department\":[{\"parameters\":{\"query\":[],\"body\":[\"department\"]},\"method\":\"post\",\"actionName\":\"postDepartment\",\"url\":\"/feign/organization/department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"department\"]},\"method\":\"put\",\"actionName\":\"editDepartment\",\"url\":\"/feign/organization/department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"allRootDepartment\",\"url\":\"/feign/organization/department/all_root_department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"addList\"]},\"method\":\"post\",\"actionName\":\"batch\",\"url\":\"/feign/organization/department/batch\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"organizationId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteOrganization\",\"url\":\"/feign/organization/department/delete_organization\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"departmentUser\"]},\"method\":\"post\",\"actionName\":\"departmentUser\",\"url\":\"/feign/organization/department/department_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"departmentUsers\"]},\"method\":\"post\",\"actionName\":\"batchDepartmentUser\",\"url\":\"/feign/organization/department/department_user/batch\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"sourceDepartmentId\",\"targetDepartmentId\"],\"body\":[\"userIds\"]},\"method\":\"post\",\"actionName\":\"butchUpdateSourceDepartment\",\"url\":\"/feign/organization/department/department_user/butch_update_source_department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"byUserid\",\"url\":\"/feign/organization/department/department_user/by_userid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"departmentIds\"]},\"method\":\"post\",\"actionName\":\"listByDepartmentIds\",\"url\":\"/feign/organization/department/department_user/list_by_department_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"userIds\"]},\"method\":\"post\",\"actionName\":\"listByUserIds\",\"url\":\"/feign/organization/department/department_user/list_by_user_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"targetDepartmentId\"],\"body\":[\"userIds\"]},\"method\":\"post\",\"actionName\":\"listByUseridDepartmentid\",\"url\":\"/feign/organization/department/department_user/list_by_userid_departmentid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"deptIds\"]},\"method\":\"post\",\"actionName\":\"listByIds\",\"url\":\"/feign/organization/department/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"names\"]},\"method\":\"post\",\"actionName\":\"listByNames\",\"url\":\"/feign/organization/department/list_by_names\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"fetchChild\",\"parentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByParentId\",\"url\":\"/feign/organization/department/list_by_parent_id\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"queryCodes\"]},\"method\":\"post\",\"actionName\":\"listByQuerycodes\",\"url\":\"/feign/organization/department/list_by_querycodes\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"rootDepartment\",\"url\":\"/feign/organization/department/root_department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"limit\",\"name\",\"offset\"],\"body\":[\"departmentIds\"]},\"method\":\"post\",\"actionName\":\"search\",\"url\":\"/feign/organization/department/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"resourceCode\"],\"body\":[\"departmentTreeQuery\"]},\"method\":\"post\",\"actionName\":\"tree\",\"url\":\"/feign/organization/department/tree\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"excludeDeptIds\",\"isFilterSelfMaintenance\",\"resourceCode\"],\"body\":[\"departmentTreeQuery\"]},\"method\":\"post\",\"actionName\":\"searchTree\",\"url\":\"/feign/organization/department/tree/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getDepartment\",\"url\":\"/feign/organization/department/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\",\"logical\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteDepartment\",\"url\":\"/feign/organization/department/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"parentDepartments\",\"url\":\"/feign/organization/department/{id}/parent_departments\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"pathName\",\"url\":\"/feign/organization/department/{id}/path_name\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Role\":[{\"parameters\":{\"query\":[],\"body\":[\"role\"]},\"method\":\"post\",\"actionName\":\"postRole\",\"url\":\"/feign/organization/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"role\"]},\"method\":\"put\",\"actionName\":\"editRole\",\"url\":\"/feign/organization/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleGroup\"]},\"method\":\"post\",\"actionName\":\"postGroup\",\"url\":\"/feign/organization/role/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleGroup\"]},\"method\":\"put\",\"actionName\":\"editGroup\",\"url\":\"/feign/organization/role/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"name\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/feign/organization/role/group/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"group\",\"url\":\"/feign/organization/role/group/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"codes\"]},\"method\":\"post\",\"actionName\":\"listByCodes\",\"url\":\"/feign/organization/role/list_by_codes\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"groupId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByGroupid\",\"url\":\"/feign/organization/role/list_by_groupid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleIds\"]},\"method\":\"post\",\"actionName\":\"listByIds\",\"url\":\"/feign/organization/role/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"unitIds\"]},\"method\":\"post\",\"actionName\":\"listByUnitids\",\"url\":\"/feign/organization/role/list_by_unitids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"key\",\"page\",\"roleType\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"searchByName\",\"url\":\"/feign/organization/role/search_by_name\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleUnit\"]},\"method\":\"post\",\"actionName\":\"postUnit\",\"url\":\"/feign/organization/role/unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleUnit\"]},\"method\":\"put\",\"actionName\":\"editUnit\",\"url\":\"/feign/organization/role/unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"ids\"]},\"method\":\"delete\",\"actionName\":\"deleteUnit\",\"url\":\"/feign/organization/role/unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"ids\"]},\"method\":\"post\",\"actionName\":\"listByIdsUnit\",\"url\":\"/feign/organization/role/unit/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleIds\"]},\"method\":\"post\",\"actionName\":\"listByRoleIds\",\"url\":\"/feign/organization/role/unit/list_by_role_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"unitIds\"]},\"method\":\"post\",\"actionName\":\"listByUnitidsUnit\",\"url\":\"/feign/organization/role/unit/list_by_unitids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"unitId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"unit\",\"url\":\"/feign/organization/role/unit/{unitId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getRole\",\"url\":\"/feign/organization/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteRole\",\"url\":\"/feign/organization/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"limit\",\"name\",\"offset\",\"roleId\",\"type\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getUnit\",\"url\":\"/feign/organization/role/{roleId}/unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[\"roleUnits\"]},\"method\":\"post\",\"actionName\":\"postUnitRole\",\"url\":\"/feign/organization/role/{roleId}/unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"clearScope\",\"url\":\"/feign/organization/role/{roleId}/unit/clear_scope\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Sync\":[{\"parameters\":{\"query\":[\"orgId\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"sync\",\"url\":\"/feign/organization/sync\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"SyncLog\":[{\"parameters\":{\"query\":[],\"body\":[\"syncLogQuery\"]},\"method\":\"post\",\"actionName\":\"listSyncLog\",\"url\":\"/feign/organization/synclog/listSyncLog\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"User\":[{\"parameters\":{\"query\":[],\"body\":[\"user\"]},\"method\":\"post\",\"actionName\":\"postUser\",\"url\":\"/feign/organization/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"user\"]},\"method\":\"put\",\"actionName\":\"editUser\",\"url\":\"/feign/organization/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"account\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"account\",\"url\":\"/feign/organization/user/account\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"dto\"]},\"method\":\"post\",\"actionName\":\"batchInsertUsers\",\"url\":\"/feign/organization/user/batch_insert_users\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"userIds\"]},\"method\":\"post\",\"actionName\":\"listByIds\",\"url\":\"/feign/organization/user/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"mobile\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"mobile\",\"url\":\"/feign/organization/user/mobile\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"mobiles\"]},\"method\":\"post\",\"actionName\":\"mobiles\",\"url\":\"/feign/organization/user/mobiles\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"names\"]},\"method\":\"post\",\"actionName\":\"names\",\"url\":\"/feign/organization/user/names\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"keyword\",\"limit\",\"offset\",\"userStatus\"],\"body\":[\"departmentIds\"]},\"method\":\"post\",\"actionName\":\"searchUser\",\"url\":\"/feign/organization/user/search_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"resourceCode\"],\"body\":[\"departmentTreeQuery\"]},\"method\":\"post\",\"actionName\":\"selection\",\"url\":\"/feign/organization/user/selection\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\",\"limit\",\"name\",\"offset\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"searchUserUser\",\"url\":\"/feign/organization/user/{departmentId}/search_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"department_id\",\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"user\",\"url\":\"/feign/organization/user/{department_id}/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"userOrganization\",\"url\":\"/feign/organization/user/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"index\",\"newPassword\",\"oldPassword\",\"userId\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"change\",\"url\":\"/feign/organization/user/{userId}/password/change\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"index\",\"oldPassword\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"check\",\"url\":\"/feign/organization/user/{userId}/password/check\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"reset\",\"url\":\"/feign/organization/user/{userId}/password/reset\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppPermissionFeignI\":[{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"apps\",\"url\":\"/feign/permission/app/apps\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"functionPermission\",\"url\":\"/feign/permission/app/function_permission\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"schemaPermission\",\"url\":\"/feign/permission/app/schema_permission\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppPermissionGroup\":[{\"parameters\":{\"query\":[],\"body\":[\"permissionGroup\"]},\"method\":\"post\",\"actionName\":\"postGroup\",\"url\":\"/feign/permission/app/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"permissionGroup\"]},\"method\":\"put\",\"actionName\":\"editGroup\",\"url\":\"/feign/permission/app/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"permissionGroupId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteScope\",\"url\":\"/feign/permission/app/group/delete_scope\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"groupRoles\"]},\"method\":\"post\",\"actionName\":\"role\",\"url\":\"/feign/permission/app/group/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"name\",\"page\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/feign/permission/app/group/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"name\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"searchCount\",\"url\":\"/feign/permission/app/group/search_count\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"permGroupId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getGroup\",\"url\":\"/feign/permission/app/group/{permGroupId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"permGroupId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteGroup\",\"url\":\"/feign/permission/app/group/{permGroupId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"permGroupId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/feign/permission/app/group/{permGroupId}/role/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"permGroupId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getPermission\",\"url\":\"/feign/permission/app/permission\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"appPermission\"]},\"method\":\"put\",\"actionName\":\"editPermission\",\"url\":\"/feign/permission/app/permission\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppRoleFeignServiceImpl\":[{\"parameters\":{\"query\":[],\"body\":[\"appRole\"]},\"method\":\"post\",\"actionName\":\"postRole\",\"url\":\"/feign/permission/app/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"appRole\"]},\"method\":\"put\",\"actionName\":\"editRole\",\"url\":\"/feign/permission/app/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"apps\",\"url\":\"/feign/permission/app/role/apps/{roleId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleName\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/feign/permission/app/role/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"groupId\",\"roleId\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"upgradeRole\",\"url\":\"/feign/permission/app/role/upgrade_role/{roleId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"roleName\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listRole\",\"url\":\"/feign/permission/app/role/{appCode}/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"role\",\"url\":\"/feign/permission/app/role/{roleId}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PlatformPermissionGroup\":[{\"parameters\":{\"query\":[],\"body\":[\"perm\"]},\"method\":\"post\",\"actionName\":\"postGroup\",\"url\":\"/feign/platform/permission/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"perm\"]},\"method\":\"put\",\"actionName\":\"editGroup\",\"url\":\"/feign/platform/permission/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"name\",\"page\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"searchByName\",\"url\":\"/feign/platform/permission/group/search_by_name\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getGroup\",\"url\":\"/feign/platform/permission/group/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteGroup\",\"url\":\"/feign/platform/permission/group/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PlatformPermissionGroupUser\":[{\"parameters\":{\"query\":[],\"body\":[\"groupUser\"]},\"method\":\"post\",\"actionName\":\"postUser\",\"url\":\"/feign/platform/permission/group/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"groupUser\"]},\"method\":\"put\",\"actionName\":\"editUser\",\"url\":\"/feign/platform/permission/group/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"groupUsers\"]},\"method\":\"post\",\"actionName\":\"batch\",\"url\":\"/feign/platform/permission/group/user/batch\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"permissionGroupIds\"]},\"method\":\"post\",\"actionName\":\"listByGroupids\",\"url\":\"/feign/platform/permission/group/user/list_by_groupids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"page\",\"permissionGroupId\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"query\",\"url\":\"/feign/platform/permission/group/user/query\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getUser\",\"url\":\"/feign/platform/permission/group/user/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteUser\",\"url\":\"/feign/platform/permission/group/user/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"clearScope\",\"url\":\"/feign/platform/permission/group/user/{id}/unit/clear_scope\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PlatformPermissionServiceI\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"allPerm\",\"url\":\"/feign/platform/permission/user/all_perm\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"resource\",\"url\":\"/feign/platform/permission/user/app/resource\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"appManagers\",\"url\":\"/feign/platform/permission/user/app_managers\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"app\",\"url\":\"/feign/platform/permission/user/user/app\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"resourceCode\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"manageRange\",\"url\":\"/feign/platform/permission/user/user/manage_range\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"permission\",\"url\":\"/feign/platform/permission/user/user/permission\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"platform\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"resources\",\"url\":\"/feign/platform/permission/user/user/resources\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppMetadataRuntime\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"schemaCodes\"]},\"method\":\"post\",\"actionName\":\"list\",\"url\":\"/feign/runtime/app/{appCode}/biz_object_schema/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"all\",\"url\":\"/feign/runtime/app/{appCode}/biz_object_schema/list/all\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"resource\",\"url\":\"/feign/runtime/app/{appCode}/resource\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"BaseSecurityClient\":[{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"client\",\"url\":\"/feign/security/client/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"ConfigManagement\":[{\"parameters\":{\"query\":[],\"body\":[\"configs\"]},\"method\":\"post\",\"actionName\":\"configManagement\",\"url\":\"/feign/system/config_management\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"configType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByType\",\"url\":\"/feign/system/config_management/list_by_type\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"configType\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"configManagementSystem\",\"url\":\"/feign/system/config_management/{configType}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getMessageAccount\",\"url\":\"/feign/system/message_account\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"messageAccount\"]},\"method\":\"post\",\"actionName\":\"postMessageAccount\",\"url\":\"/feign/system/message_account\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"messageAccount\"]},\"method\":\"put\",\"actionName\":\"editMessageAccount\",\"url\":\"/feign/system/message_account\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"idList\"]},\"method\":\"delete\",\"actionName\":\"deleteMessageAccount\",\"url\":\"/feign/system/message_account\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"code\",\"type\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"code\",\"url\":\"/feign/system/message_account/code\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"limit\",\"offset\",\"type\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"query\",\"url\":\"/feign/system/message_account/query\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\",\"type\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"restDefaultAccount\",\"url\":\"/feign/system/message_account/rest_default_account\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"SecuritySetting\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"passwordRegularExpression\",\"url\":\"/feign/system/security/password_regular_expression\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getPasswordRule\",\"url\":\"/feign/system/security/password_rule\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"passwordRule\"]},\"method\":\"post\",\"actionName\":\"postPasswordRule\",\"url\":\"/feign/system/security/password_rule\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"passwordRule\"]},\"method\":\"put\",\"actionName\":\"editPasswordRule\",\"url\":\"/feign/system/security/password_rule\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getPasswordRuleSecurity\",\"url\":\"/feign/system/security/password_rule/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deletePasswordRule\",\"url\":\"/feign/system/security/password_rule/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"GetCurrentUser\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getCurrentUser\",\"url\":\"/get_current_user\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Launcher\":[{\"parameters\":{\"query\":[\"appCode\",\"appVersion\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"bizObjectSchema\",\"url\":\"/launcher/app/{appCode}/version/{appVersion}/biz_object_schema\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"appVersion\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"bizObjectSchemaVersion\",\"url\":\"/launcher/app/{appCode}/version/{appVersion}/biz_object_schema/{schemaCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"appVersion\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"sourceCode\",\"url\":\"/launcher/app/{appCode}/version/{appVersion}/biz_object_schema/{schemaCode}/source_code\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"appVersion\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"sourceCodeVersion\",\"url\":\"/launcher/app/{appCode}/version/{appVersion}/source_code\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Lifecycle\":{\"Application\":[{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"app\",\"url\":\"/lifecycle/app\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"code\",\"url\":\"/lifecycle/app/code/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"clusterId\",\"namespace\",\"version\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"schema\",\"url\":\"/lifecycle/app/deployed/schema\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"qry\"]},\"method\":\"post\",\"actionName\":\"list\",\"url\":\"/lifecycle/app/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"appRunningQry\"]},\"method\":\"post\",\"actionName\":\"running\",\"url\":\"/lifecycle/app/running\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getApp\",\"url\":\"/lifecycle/app/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteApp\",\"url\":\"/lifecycle/app/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getGit\",\"url\":\"/lifecycle/cloudpivot/service/configure/git\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"postGit\",\"url\":\"/lifecycle/cloudpivot/service/configure/git\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppConfig\":[{\"parameters\":{\"query\":[\"appCode\",\"version\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"config\",\"url\":\"/lifecycle/app/config\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"ApplicationVersion\":[{\"parameters\":{\"query\":[\"appId\",\"pageNum\",\"pageSize\",\"version\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"version\",\"url\":\"/lifecycle/app/version\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"lastest\",\"url\":\"/lifecycle/app/version/lastest\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"versionApp\",\"url\":\"/lifecycle/app/version/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"ApplicationOperation\":[{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"status\",\"url\":\"/lifecycle/application/status\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"version\",\"url\":\"/lifecycle/application/version\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"CloudPivotInfo\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"info\",\"url\":\"/lifecycle/cloudpivot/deployment/info\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"clusterId\",\"id\",\"keyword\",\"namespace\",\"status\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/lifecycle/cloudpivot/list\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Middleware\":[{\"parameters\":{\"query\":[\"pageNum\",\"pageSize\",\"url\",\"usedStatus\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getDbServer\",\"url\":\"/lifecycle/db_server\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"postDbServer\",\"url\":\"/lifecycle/db_server\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"put\",\"actionName\":\"editDbServer\",\"url\":\"/lifecycle/db_server\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"status\",\"url\":\"/lifecycle/db_server/status/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"dbServer\",\"url\":\"/lifecycle/db_server/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"databases\",\"url\":\"/lifecycle/list/instances/databases\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getConfig\",\"url\":\"/lifecycle/logs/store/config\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"logStoreConfig\"]},\"method\":\"post\",\"actionName\":\"postConfig\",\"url\":\"/lifecycle/logs/store/config\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AlarmStrategy\":[{\"parameters\":{\"query\":[\"alarmMode\",\"id\",\"monitorType\",\"name\",\"pageNum\",\"pageSize\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getStrategy\",\"url\":\"/lifecycle/monitor/alarm/strategy\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"dto\"]},\"method\":\"post\",\"actionName\":\"postStrategy\",\"url\":\"/lifecycle/monitor/alarm/strategy\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"strategy\",\"url\":\"/lifecycle/monitor/alarm/strategy/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Openfeign\":[{\"parameters\":{\"query\":[],\"body\":[\"department\"]},\"method\":\"post\",\"actionName\":\"postDepartment\",\"url\":\"/openfeign/organization/department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"department\"]},\"method\":\"put\",\"actionName\":\"editDepartment\",\"url\":\"/openfeign/organization/department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"names\"]},\"method\":\"post\",\"actionName\":\"byFullPath\",\"url\":\"/openfeign/organization/department/by_full_path\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"physical\"],\"body\":[\"departmentIds\"]},\"method\":\"post\",\"actionName\":\"deleteByIds\",\"url\":\"/openfeign/organization/department/delete_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"get\",\"url\":\"/openfeign/organization/department/get\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getMainByUserid\",\"url\":\"/openfeign/organization/department/get_main_by_userid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"sourceId\",\"targetIds\",\"unitType\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"isSourceBelongToTarget\",\"url\":\"/openfeign/organization/department/is_source_belong_to_target\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"codes\"]},\"method\":\"post\",\"actionName\":\"listByCodes\",\"url\":\"/openfeign/organization/department/list_by_codes\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"departmentIds\"]},\"method\":\"post\",\"actionName\":\"listByIds\",\"url\":\"/openfeign/organization/department/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentIds\"],\"body\":[\"sourceIds\"]},\"method\":\"post\",\"actionName\":\"listBySourceids\",\"url\":\"/openfeign/organization/department/list_by_sourceids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByUserid\",\"url\":\"/openfeign/organization/department/list_by_userid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"fetchChild\",\"parentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listChild\",\"url\":\"/openfeign/organization/department/list_child\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listParents\",\"url\":\"/openfeign/organization/department/list_parents\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\",\"recursionType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"managers\",\"url\":\"/openfeign/organization/department/managers\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"departmentUser\"]},\"method\":\"post\",\"actionName\":\"postDepartmentUser\",\"url\":\"/openfeign/organization/department_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"departmentUser\"]},\"method\":\"put\",\"actionName\":\"editDepartmentUser\",\"url\":\"/openfeign/organization/department_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteByDepartmentid\",\"url\":\"/openfeign/organization/department_user/delete_by_departmentid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteByUserid\",\"url\":\"/openfeign/organization/department_user/delete_by_userid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getDepartmentUser\",\"url\":\"/openfeign/organization/department_user/get\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByDepartmentid\",\"url\":\"/openfeign/organization/department_user/list_by_departmentid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByUseridDepartmentUser\",\"url\":\"/openfeign/organization/department_user/list_by_userid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getDepartmentUserOrganization\",\"url\":\"/openfeign/organization/department_user/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteDepartmentUser\",\"url\":\"/openfeign/organization/department_user/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"organization\"]},\"method\":\"post\",\"actionName\":\"postOrganization\",\"url\":\"/openfeign/organization/organization\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"organization\"]},\"method\":\"put\",\"actionName\":\"editOrganization\",\"url\":\"/openfeign/organization/organization\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"corpId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"corpid\",\"url\":\"/openfeign/organization/organization/corpid/{corpId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"orgIds\"]},\"method\":\"delete\",\"actionName\":\"deleteByIdsOrganization\",\"url\":\"/openfeign/organization/organization/delete_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getByDepartmentid\",\"url\":\"/openfeign/organization/organization/get_by_departmentid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/openfeign/organization/organization/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"organization\",\"url\":\"/openfeign/organization/organization/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"role\"]},\"method\":\"post\",\"actionName\":\"postRole\",\"url\":\"/openfeign/organization/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"role\"]},\"method\":\"put\",\"actionName\":\"editRole\",\"url\":\"/openfeign/organization/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"byCode\",\"url\":\"/openfeign/organization/role/by_code\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleGroup\"]},\"method\":\"post\",\"actionName\":\"postGroup\",\"url\":\"/openfeign/organization/role/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleGroup\"]},\"method\":\"put\",\"actionName\":\"editGroup\",\"url\":\"/openfeign/organization/role/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"group\",\"url\":\"/openfeign/organization/role/group/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"limit\",\"offset\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listRole\",\"url\":\"/openfeign/organization/role/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByUseridRole\",\"url\":\"/openfeign/organization/role/list_by_userid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getRole\",\"url\":\"/openfeign/organization/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteRole\",\"url\":\"/openfeign/organization/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleUnit\"]},\"method\":\"post\",\"actionName\":\"postRoleUnit\",\"url\":\"/openfeign/organization/role_unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleUnit\"]},\"method\":\"put\",\"actionName\":\"editRoleUnit\",\"url\":\"/openfeign/organization/role_unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleUnitIds\"]},\"method\":\"delete\",\"actionName\":\"deleteRoleUnit\",\"url\":\"/openfeign/organization/role_unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"ids\"]},\"method\":\"post\",\"actionName\":\"listByIdsRoleUnit\",\"url\":\"/openfeign/organization/role_unit/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleIds\"]},\"method\":\"post\",\"actionName\":\"listByRoleIds\",\"url\":\"/openfeign/organization/role_unit/list_by_role_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"unitIds\"]},\"method\":\"post\",\"actionName\":\"listByUnitids\",\"url\":\"/openfeign/organization/role_unit/list_by_unitids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"unitId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"roleUnit\",\"url\":\"/openfeign/organization/role_unit/{unitId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"deptIds\",\"excludeDeptIds\",\"excludeOrgId\",\"excludeUserIds\",\"isFilterSelfMaintenance\",\"orgId\",\"resourceCode\",\"strategy\",\"userId\"],\"body\":[\"selectionTree\"]},\"method\":\"post\",\"actionName\":\"tree\",\"url\":\"/openfeign/organization/selection/tree\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"deptIds\",\"excludeDeptIds\",\"excludeOrgId\",\"excludeUserIds\",\"isFilterSelfMaintenance\",\"keyword\",\"orgId\",\"resourceCode\",\"strategy\"],\"body\":[\"selectionTree\"]},\"method\":\"post\",\"actionName\":\"search\",\"url\":\"/openfeign/organization/selection/tree/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"user\"]},\"method\":\"post\",\"actionName\":\"postUser\",\"url\":\"/openfeign/organization/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"user\"]},\"method\":\"put\",\"actionName\":\"editUser\",\"url\":\"/openfeign/organization/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"account\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"account\",\"url\":\"/openfeign/organization/user/account\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"names\"]},\"method\":\"post\",\"actionName\":\"byFullPathUser\",\"url\":\"/openfeign/organization/user/by_full_path\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"userIds\"]},\"method\":\"delete\",\"actionName\":\"deleteByIdsUser\",\"url\":\"/openfeign/organization/user/delete_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"corpId\",\"sourceId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getByCorpidSourceid\",\"url\":\"/openfeign/organization/user/get_by_corpid_sourceid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getById\",\"url\":\"/openfeign/organization/user/get_by_id\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"name\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getByName\",\"url\":\"/openfeign/organization/user/get_by_name\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"fetchChild\"],\"body\":[\"departmentIds\"]},\"method\":\"post\",\"actionName\":\"listByDepartments\",\"url\":\"/openfeign/organization/user/list_by_departments\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"employeeNos\"]},\"method\":\"post\",\"actionName\":\"listByEmployeeNos\",\"url\":\"/openfeign/organization/user/list_by_employeeNos\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"userIds\"]},\"method\":\"post\",\"actionName\":\"listByIdsUser\",\"url\":\"/openfeign/organization/user/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"mobiles\"]},\"method\":\"post\",\"actionName\":\"listByMobiles\",\"url\":\"/openfeign/organization/user/list_by_mobiles\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"names\"]},\"method\":\"post\",\"actionName\":\"listByNames\",\"url\":\"/openfeign/organization/user/list_by_names\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByRolecode\",\"url\":\"/openfeign/organization/user/list_by_rolecode\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByRoleid\",\"url\":\"/openfeign/organization/user/list_by_roleid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentIds\",\"level\",\"qryType\",\"recursionType\",\"userIds\"],\"body\":[\"managerQuery\"]},\"method\":\"post\",\"actionName\":\"managerByDepartmentUserLevel\",\"url\":\"/openfeign/organization/user/manager_by_department_user_level\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"qryType\",\"recursionType\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"managerByUserId\",\"url\":\"/openfeign/organization/user/manager_by_user_id\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"endType\",\"initiateId\",\"level\",\"qryType\",\"targetId\",\"unitType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"managersUser\",\"url\":\"/openfeign/organization/user/managers\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"mobile\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"mobile\",\"url\":\"/openfeign/organization/user/mobile\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentIds\",\"roleId\",\"userIds\"],\"body\":[\"managerQuery\"]},\"method\":\"post\",\"actionName\":\"roleUserByDepartmentUser\",\"url\":\"/openfeign/organization/user/role_user_by_department_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"keyword\",\"limit\",\"offset\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"searchUser\",\"url\":\"/openfeign/organization/user/search_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"initiateId\",\"qryType\",\"targetId\",\"unitType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"simplManagers\",\"url\":\"/openfeign/organization/user/simpl_managers\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"roleUnitOrganization\",\"url\":\"/openfeign/organization/{roleId}/role_unit\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"OperationLog\":[{\"parameters\":{\"query\":[],\"body\":[\"operationLog\"]},\"method\":\"post\",\"actionName\":\"operationLog\",\"url\":\"/operation_log\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PageTemplate\":[{\"parameters\":{\"query\":[],\"body\":[\"pageTemplate\"]},\"method\":\"post\",\"actionName\":\"postPageTemplate\",\"url\":\"/page_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"pageTemplate\"]},\"method\":\"put\",\"actionName\":\"editPageTemplate\",\"url\":\"/page_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"codes\"]},\"method\":\"delete\",\"actionName\":\"deletePageTemplate\",\"url\":\"/page_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"code\",\"deleted\",\"type\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/page_template/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"code\",\"createdBy\",\"deleted\",\"limit\",\"name\",\"offset\",\"publishedStatus\",\"source\",\"status\",\"type\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/page_template/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"page_template_code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"pageTemplate\",\"url\":\"/page_template/{page_template_code}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Print\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"approval\",\"url\":\"/print/flow/type/and/approval\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Project\":[{\"parameters\":{\"query\":[],\"body\":[\"dto\"]},\"method\":\"post\",\"actionName\":\"postProject\",\"url\":\"/project\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"dto\"]},\"method\":\"put\",\"actionName\":\"editProject\",\"url\":\"/project\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/project/app/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"listProject\",\"url\":\"/project/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"options\"]},\"method\":\"post\",\"actionName\":\"sort\",\"url\":\"/project/sort\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"sortType\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listSortType\",\"url\":\"/project/userId/{userId}/sort_type/{sortType}/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"code\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"project\",\"url\":\"/project/{code}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listApp\",\"url\":\"/project/{code}/app/list\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Runtime\":{\"AppRuntime\":[{\"parameters\":{\"query\":[\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"install\",\"url\":\"/runtime/app/install\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppMetadataRuntime\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"app\",\"url\":\"/runtime/app/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/runtime/app/{appCode}/action_permission/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listAppModule\",\"url\":\"/runtime/app/{appCode}/app_module/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"schemaCodes\"]},\"method\":\"post\",\"actionName\":\"listBizObjectSchema\",\"url\":\"/runtime/app/{appCode}/biz_object_schema/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"bizObjectSchema\",\"url\":\"/runtime/app/{appCode}/biz_object_schema/{schemaCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listDomainModel\",\"url\":\"/runtime/app/{appCode}/domain_model/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listDomainModelRelation\",\"url\":\"/runtime/app/{appCode}/domain_model_relation/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"schemaCodes\"]},\"method\":\"get\",\"actionName\":\"getDomainServiceApi\",\"url\":\"/runtime/app/{appCode}/domain_service_api\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"schemaCodes\"]},\"method\":\"post\",\"actionName\":\"postDomainServiceApi\",\"url\":\"/runtime/app/{appCode}/domain_service_api\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"homepage\",\"url\":\"/runtime/app/{appCode}/homepage\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listLogic\",\"url\":\"/runtime/app/{appCode}/logic/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"menu\",\"url\":\"/runtime/app/{appCode}/menu\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"all\",\"url\":\"/runtime/app/{appCode}/menu/all\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"menuCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"menuApp\",\"url\":\"/runtime/app/{appCode}/menu/{menuCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"pageCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"page\",\"url\":\"/runtime/app/{appCode}/page/{pageCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"pageMasterCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"pageMaster\",\"url\":\"/runtime/app/{appCode}/page_master/{pageMasterCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"detail\",\"url\":\"/runtime/app/{appCode}/print/detail/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"action\",\"url\":\"/runtime/app/{appCode}/settings/action\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"style\",\"url\":\"/runtime/app/{appCode}/settings/style\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"sourceCode\",\"url\":\"/runtime/app/{appCode}/source_code\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"WorkflowRuntime\":[{\"parameters\":{\"query\":[\"appCode\",\"appVersion\",\"debug\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getStartWorkflowCode\",\"url\":\"/runtime/app/{appCode}/schema/{schemaCode}/get_start_workflow_code\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"debug\",\"workflowCode\",\"workflowVersion\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"workflow\",\"url\":\"/runtime/app/{appCode}/workflow/{workflowCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/runtime/workflow/list\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"SchedulingTask\":[{\"parameters\":{\"query\":[],\"body\":[\"jobExecuteLog\"]},\"method\":\"post\",\"actionName\":\"addLog\",\"url\":\"/scheduling_task/add_log\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"listAppCodes\",\"url\":\"/scheduling_task/list_app_codes\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"schedulingTask\"]},\"method\":\"post\",\"actionName\":\"send\",\"url\":\"/scheduling_task/send\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"TestFeign2\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"testFeign2\",\"url\":\"/test_feign2\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"TestFeignOrg\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"testFeignOrg\",\"url\":\"/test_feign_org\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Todo\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"countWorkitem\",\"url\":\"/todo/count_workitem\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\",\"todoType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getById\",\"url\":\"/todo/get_by_id\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"batchOperate\",\"todoType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listAppcodeByTodotype\",\"url\":\"/todo/list_appcode_by_todotype\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"todoType\"],\"body\":[\"instanceIds\"]},\"method\":\"post\",\"actionName\":\"listByInstanceIds\",\"url\":\"/todo/list_by_instance_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"todoType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listWorkflowByTodotype\",\"url\":\"/todo/list_workflow_by_todotype\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"remind\"]},\"method\":\"post\",\"actionName\":\"remind\",\"url\":\"/todo/remind\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"todo\"]},\"method\":\"post\",\"actionName\":\"save\",\"url\":\"/todo/save\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"search\",\"url\":\"/todo/search\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Workflow\":{\"WorkflowAgencyEntrust\":[{\"parameters\":{\"query\":[],\"body\":[\"agencyEntrust\"]},\"method\":\"post\",\"actionName\":\"postAgencyEntrust\",\"url\":\"/workflow/agency_entrust\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"agencyEntrust\"]},\"method\":\"put\",\"actionName\":\"editAgencyEntrust\",\"url\":\"/workflow/agency_entrust\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"ids\"]},\"method\":\"delete\",\"actionName\":\"deleteAgencyEntrust\",\"url\":\"/workflow/agency_entrust\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\",\"workflowCode\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"listConsignoridsByMandataryid\",\"url\":\"/workflow/agency_entrust/list_consignorids_by_mandataryid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"listWorkflowEntrusts\",\"url\":\"/workflow/agency_entrust/list_workflow_entrusts\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"search\",\"url\":\"/workflow/agency_entrust/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"agencyEntrust\",\"url\":\"/workflow/agency_entrust/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"WorkflowInstance\":[{\"parameters\":{\"query\":[],\"body\":[\"workflowInstance\"]},\"method\":\"post\",\"actionName\":\"save\",\"url\":\"/workflow/save\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"search\",\"url\":\"/workflow/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"state\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"workFlows\",\"url\":\"/workflow/work_flows\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"CONFIG\":{\"basePath\":\"/api/metadata\",\"host\":\"httpgateway\"}}");

/***/ }),
/* 16 */
/***/ (function(module) {

module.exports = JSON.parse("{\"App\":{\"AppDeploy\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getAppUrl\",\"url\":\"/app/deploy/get_app_url\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"keyword\",\"page\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/app/deploy/search\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"JobInfo\":[{\"parameters\":{\"query\":[\"appCode\",\"name\",\"page\",\"size\",\"status\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"job\",\"url\":\"/app/job\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Import\":[{\"parameters\":{\"query\":[],\"body\":[\"importQuery\"]},\"method\":\"post\",\"actionName\":\"download\",\"url\":\"/app/schema/biz_object/child/import_template/download\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"file\",\"schemaCode\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"import\",\"url\":\"/app/{appCode}/schema/{schemaCode}/biz_object/child/import\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"file\",\"schemaCode\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"importBizObject\",\"url\":\"/app/{appCode}/schema/{schemaCode}/biz_object/import\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"downloadImportTemplate\",\"url\":\"/app/{appCode}/schema/{schemaCode}/biz_object/import_template/download\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppUsedConfig\":[{\"parameters\":{\"query\":[],\"body\":[\"appUsedConfig\"]},\"method\":\"post\",\"actionName\":\"config\",\"url\":\"/app/used/config\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/app/used/config/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"configUsed\",\"url\":\"/app/used/config/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Export\":[{\"parameters\":{\"query\":[\"appCode\",\"pageIndex\",\"pageSize\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getHistory\",\"url\":\"/app/{appCode}/domain_service/export/history\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteHistory\",\"url\":\"/app/{appCode}/domain_service/export/history\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"schemaCode\"],\"body\":[\"criteriaQuery\"]},\"method\":\"post\",\"actionName\":\"export\",\"url\":\"/app/{appCode}/domain_service/{schemaCode}/export\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PermissionRuntime\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[\"schemaCodes\"]},\"method\":\"post\",\"actionName\":\"page\",\"url\":\"/app/{appCode}/permission/page\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Apps\":[{\"parameters\":{\"query\":[\"lang\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"extendComponent\",\"url\":\"/apps/client/extend_component\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"deleted\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"pageTemplate\",\"url\":\"/apps/client/page_template\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Echo\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"echo\",\"url\":\"/echo\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"File\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"whiteList\",\"url\":\"/file/whiteList\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"refId\",\"serviceId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"download\",\"url\":\"/file/{serviceId}/download\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"refId\",\"serviceId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"bytes\",\"url\":\"/file/{serviceId}/download/bytes\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\",\"locationInfo\",\"serviceId\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"upload\",\"url\":\"/file/{serviceId}/upload\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\",\"locationInfo\",\"serviceId\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"uploadPrint\",\"url\":\"/file/{serviceId}/uploadPrint\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"refId\",\"serviceId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"view\",\"url\":\"/file/{serviceId}/view\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"FileStorage\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getFileStorage\",\"url\":\"/file_storage\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"fileStorageConfig\"]},\"method\":\"post\",\"actionName\":\"postFileStorage\",\"url\":\"/file_storage\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"GetMessageFormUrl\":[{\"parameters\":{\"query\":[\"messageId\",\"wordRecordId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getMessageFormUrl\",\"url\":\"/get_message_form_url\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Integration\":[{\"parameters\":{\"query\":[\"connectorId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/integration/connector/action/{connectorId}/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"listConnector\",\"url\":\"/integration/connector/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"adapterType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByAdapter\",\"url\":\"/integration/connector/list_by_adapter\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Lifecycle\":{\"AppFromLifecycle\":[{\"parameters\":{\"query\":[\"id\",\"keyword\",\"pageNum\",\"pageSize\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getApp\",\"url\":\"/lifecycle/app\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"postApp\",\"url\":\"/lifecycle/app\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"appZip\",\"url\":\"/lifecycle/app/file/appZip\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appId\",\"needTotalCount\",\"offset\",\"pageNum\",\"pageSize\",\"version\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"version\",\"url\":\"/lifecycle/app/version\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"delete\",\"url\":\"/lifecycle/app/version/delete\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"app\",\"url\":\"/lifecycle/app/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppDeployment\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"deployed\",\"url\":\"/lifecycle/app/deployed/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"version\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"imported\",\"url\":\"/lifecycle/app/imported/{appCode}/{version}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"clusterId\",\"keyword\",\"namespace\",\"needTotalCount\",\"offset\",\"pageNum\",\"pageSize\",\"status\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/lifecycle/app/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"clusterId\",\"keyword\",\"namespace\",\"needTotalCount\",\"offset\",\"pageNum\",\"pageSize\",\"status\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"permission\",\"url\":\"/lifecycle/app/list/permission\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"status\",\"url\":\"/lifecycle/application/status\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"validate\",\"url\":\"/lifecycle/application/validate/{appCode}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"version\",\"url\":\"/lifecycle/application/version\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"validateOffline\",\"url\":\"/lifecycle/application/{appCode}/offline/validate\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"CloudPivotDeployment\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"info\",\"url\":\"/lifecycle/cloudpivot/deployment/info\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"clusterId\",\"id\",\"keyword\",\"namespace\",\"status\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/lifecycle/cloudpivot/list\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"SystemFromLifecycle\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getGit\",\"url\":\"/lifecycle/cloudpivot/service/configure/git\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"postGit\",\"url\":\"/lifecycle/cloudpivot/service/configure/git\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppMiddleware\":[{\"parameters\":{\"query\":[\"needTotalCount\",\"offset\",\"pageNum\",\"pageSize\",\"url\",\"usedStatus\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getDbServer\",\"url\":\"/lifecycle/db_server\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"postDbServer\",\"url\":\"/lifecycle/db_server\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"put\",\"actionName\":\"editDbServer\",\"url\":\"/lifecycle/db_server\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"status\",\"url\":\"/lifecycle/db_server/status/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"dbServer\",\"url\":\"/lifecycle/db_server/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"databases\",\"url\":\"/lifecycle/list/instances/databases\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"CloudPivotLog\":[{\"parameters\":{\"query\":[\"clusterId\",\"end\",\"keywords\",\"logLevel\",\"namespace\",\"pageNum\",\"pageSize\",\"service\",\"start\",\"traceId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"logs\",\"url\":\"/lifecycle/logs\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"currentConfig\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getConfig\",\"url\":\"/lifecycle/logs/store/config\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"logStoreConfig\"]},\"method\":\"post\",\"actionName\":\"postConfig\",\"url\":\"/lifecycle/logs/store/config\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppMonitor\":[{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"message\",\"url\":\"/lifecycle/monitor/alarm/message\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"alarmMode\",\"id\",\"monitorType\",\"name\",\"pageNum\",\"pageSize\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getStrategy\",\"url\":\"/lifecycle/monitor/alarm/strategy\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"dto\"]},\"method\":\"post\",\"actionName\":\"postStrategy\",\"url\":\"/lifecycle/monitor/alarm/strategy\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"strategy\",\"url\":\"/lifecycle/monitor/alarm/strategy/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"endTime\",\"executeTime\",\"monitorType\",\"namespace\",\"pageNum\",\"pageSize\",\"startTime\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"api\",\"url\":\"/lifecycle/monitor/slow/api\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Log\":[{\"parameters\":{\"query\":[\"actionName\",\"connectorName\",\"page\",\"size\",\"status\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"integrationLogs\",\"url\":\"/log/business/integration_logs\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"beginTime\",\"endTime\",\"id\",\"page\",\"pageSize\",\"status\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"jobLogs\",\"url\":\"/log/business/job_logs\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"messageContent\",\"messageType\",\"page\",\"receiver\",\"size\",\"status\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"messageLogs\",\"url\":\"/log/business/message_logs\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Login\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"jwksJson\",\"url\":\"/login/auth/.well-known/jwks.json\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"modifyPasswordDto\"]},\"method\":\"put\",\"actionName\":\"modifyPassword\",\"url\":\"/login/auth/asset/modify_password\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"reset\",\"url\":\"/login/auth/asset/reset\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getLoginUrl\",\"url\":\"/login/auth/get_login_url\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getRsaKey\",\"url\":\"/login/auth/get_rsa_key\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"client_id\",\"refresh_token\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"refreshToken\",\"url\":\"/login/auth/refresh_token\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"switch\",\"url\":\"/login/auth/refresh_token/switch\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"corpId\",\"url\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"sign\",\"url\":\"/login/auth/sign\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Logs\":[{\"parameters\":{\"query\":[],\"body\":[\"logRecord\"]},\"method\":\"post\",\"actionName\":\"logs\",\"url\":\"/logs\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"post\",\"actionName\":\"index\",\"url\":\"/logs/index\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"OperateLogs\":[{\"parameters\":{\"query\":[\"beginTime\",\"endTime\",\"ip\",\"logType\",\"page\",\"size\",\"source\",\"userName\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"operateLogs\",\"url\":\"/operate_logs\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Organization\":{\"Department\":[{\"parameters\":{\"query\":[],\"body\":[\"department\"]},\"method\":\"post\",\"actionName\":\"postDepartment\",\"url\":\"/organization/department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"department\"]},\"method\":\"put\",\"actionName\":\"editDepartment\",\"url\":\"/organization/department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"connectorId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"adapterConfigParam\",\"url\":\"/organization/department/adapter_config_param\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"checkChild\",\"url\":\"/organization/department/check_child\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"checkRoot\",\"url\":\"/organization/department/check_root\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"parentId\",\"resourceCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getAllParentTree\",\"url\":\"/organization/department/get_all_parent_tree\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getDatasource\",\"url\":\"/organization/department/get_datasource\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"departmentDTO\"]},\"method\":\"post\",\"actionName\":\"initRoot\",\"url\":\"/organization/department/init_root\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"ids\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByIds\",\"url\":\"/organization/department/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"parentId\",\"resourceCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByParentId\",\"url\":\"/organization/department/list_by_parent_id\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByUserId\",\"url\":\"/organization/department/list_by_user_id/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"sourceType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listOrganizations\",\"url\":\"/organization/department/list_organizations\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"name\",\"page\",\"resourceCode\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/organization/department/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"deptIds\",\"excludeDeptIds\",\"excludeOrgId\",\"excludeUserIds\",\"includeDeptIds\",\"includeRoleIds\",\"includeUserIds\",\"isFilterSelfMaintenance\",\"orgId\",\"pageNum\",\"pageSize\",\"resourceCode\",\"rootDisplay\",\"searchType\",\"strategy\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"tree\",\"url\":\"/organization/department/tree\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"deptIds\",\"excludeDeptIds\",\"excludeOrgId\",\"excludeUserIds\",\"includeDeptIds\",\"includeRoleIds\",\"includeUserIds\",\"isFilterSelfMaintenance\",\"keyword\",\"orgId\",\"pageNum\",\"pageSize\",\"resourceCode\",\"searchType\",\"strategy\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"searchTree\",\"url\":\"/organization/department/tree/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"config\"]},\"method\":\"put\",\"actionName\":\"updateDatasource\",\"url\":\"/organization/department/update_datasource\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"departmentManagerDTO\"]},\"method\":\"put\",\"actionName\":\"updateDepartmentManager\",\"url\":\"/organization/department/update_department_manager\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\",\"sortKey\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"updateSortkey\",\"url\":\"/organization/department/update_sortkey\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\",\"name\",\"page\",\"resourceCode\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"users\",\"url\":\"/organization/department/users\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getDepartment\",\"url\":\"/organization/department/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteDepartment\",\"url\":\"/organization/department/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"parentDepartments\",\"url\":\"/organization/department/{id}/parent_departments\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"DepartmentImportExport\":[{\"parameters\":{\"query\":[\"orgConfigId\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"export\",\"url\":\"/organization/department/export\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"excel\",\"url\":\"/organization/department/import/excel\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"tagId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"result\",\"url\":\"/organization/department/import/excel/result\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"template\",\"url\":\"/organization/department/template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"upload\",\"url\":\"/organization/department/upload\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Role\":[{\"parameters\":{\"query\":[],\"body\":[\"role\"]},\"method\":\"post\",\"actionName\":\"postRole\",\"url\":\"/organization/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"role\"]},\"method\":\"put\",\"actionName\":\"editRole\",\"url\":\"/organization/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleGroup\"]},\"method\":\"post\",\"actionName\":\"postGroup\",\"url\":\"/organization/role/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleGroup\"]},\"method\":\"put\",\"actionName\":\"editGroup\",\"url\":\"/organization/role/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"name\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/organization/role/group/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"group\",\"url\":\"/organization/role/group/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"codes\",\"ids\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listRole\",\"url\":\"/organization/role/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"codes\"]},\"method\":\"post\",\"actionName\":\"listByCodes\",\"url\":\"/organization/role/list_by_codes\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"parentId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listById\",\"url\":\"/organization/role/list_by_id\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"name\",\"roleType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"searchByName\",\"url\":\"/organization/role/search_by_name\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"name\",\"roleType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/organization/role/tree/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"roleUnitIds\"]},\"method\":\"delete\",\"actionName\":\"unit\",\"url\":\"/organization/role/unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleUnitId\"],\"body\":[\"roleUnitScopes\"]},\"method\":\"post\",\"actionName\":\"scope\",\"url\":\"/organization/role/unit/{roleUnitId}/scope\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getRole\",\"url\":\"/organization/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteRole\",\"url\":\"/organization/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"name\",\"page\",\"roleId\",\"size\",\"type\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getUnit\",\"url\":\"/organization/role/{roleId}/unit\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[\"roleUnitTemps\"]},\"method\":\"post\",\"actionName\":\"postUnit\",\"url\":\"/organization/role/{roleId}/unit\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Sync\":[{\"parameters\":{\"query\":[\"orgId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"check\",\"url\":\"/organization/synchronize/check\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"orgId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"full\",\"url\":\"/organization/synchronize/full\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"SyncLog\":[{\"parameters\":{\"query\":[\"beginDate\",\"departmentId\",\"endDate\",\"page\",\"size\",\"type\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listSyncLog\",\"url\":\"/organization/synclog/listSyncLog\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"orgSyncLogDetail\"]},\"method\":\"post\",\"actionName\":\"syncLogDetailLocalData\",\"url\":\"/organization/synclog/syncLogDetailLocalData\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"User\":[{\"parameters\":{\"query\":[],\"body\":[\"user\"]},\"method\":\"post\",\"actionName\":\"postUser\",\"url\":\"/organization/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"user\"]},\"method\":\"put\",\"actionName\":\"editUser\",\"url\":\"/organization/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"vo\"]},\"method\":\"post\",\"actionName\":\"adjustDepartmentUser\",\"url\":\"/organization/user/adjust_department_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"vo\"]},\"method\":\"post\",\"actionName\":\"batchUpdateDepartment\",\"url\":\"/organization/user/batch_update_department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userIds\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"checkLastDepartment\",\"url\":\"/organization/user/check_last_department\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"mobile\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"checkRemoved\",\"url\":\"/organization/user/check_removed\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"userCopyDTO\"]},\"method\":\"put\",\"actionName\":\"copy\",\"url\":\"/organization/user/copy\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"departmentContainUser\",\"url\":\"/organization/user/department_contain_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getLoginInfo\",\"url\":\"/organization/user/get_login_info\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"ids\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByIds\",\"url\":\"/organization/user/list_by_ids\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"user\"]},\"method\":\"put\",\"actionName\":\"reEmploy\",\"url\":\"/organization/user/re_employ\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"keyword\",\"orgId\",\"page\",\"resourceCode\",\"size\",\"userStatus\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"searchUser\",\"url\":\"/organization/user/search_user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"userTopDTO\"]},\"method\":\"put\",\"actionName\":\"top\",\"url\":\"/organization/user/top\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"deptIds\",\"excludeDeptIds\",\"excludeOrgId\",\"excludeUserIds\",\"includeDeptIds\",\"includeRoleCodes\",\"includeRoleIds\",\"includeUserIds\",\"isFilterSelfMaintenance\",\"keyword\",\"orgId\",\"pageNum\",\"pageSize\",\"resourceCode\",\"searchType\",\"strategy\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/organization/user/tree/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"account\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"account\",\"url\":\"/organization/user/user/account\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByRoleid\",\"url\":\"/organization/user/user/list_by_roleid\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"departmentId\",\"userIds\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"users\",\"url\":\"/organization/user/users\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"department_id\",\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"user\",\"url\":\"/organization/user/{department_id}/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"userOrganization\",\"url\":\"/organization/user/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"index\",\"oldPassword\",\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"check\",\"url\":\"/organization/user/{userId}/password/check\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"index\",\"newPassword\",\"oldPassword\",\"userId\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"modify\",\"url\":\"/organization/user/{userId}/password/modify\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"reset\",\"url\":\"/organization/user/{userId}/password/reset\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"UserImport\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"exportTemplate\",\"url\":\"/organization/user/export_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"excel\",\"url\":\"/organization/user/import/excel\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"tagId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"result\",\"url\":\"/organization/user/import/excel/result\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"template\",\"url\":\"/organization/user/template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"upload\",\"url\":\"/organization/user/upload\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"PageTemplate\":[{\"parameters\":{\"query\":[\"createdby\",\"deleted\",\"pageIndex\",\"pageSize\",\"pageTemplateCode\",\"pageTemplateName\",\"publishedStatus\",\"source\",\"status\",\"templateType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getPageTemplate\",\"url\":\"/page_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"pageTemplate\"]},\"method\":\"post\",\"actionName\":\"postPageTemplate\",\"url\":\"/page_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"pageTemplate\"]},\"method\":\"put\",\"actionName\":\"editPageTemplate\",\"url\":\"/page_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"pageTemplate\"]},\"method\":\"post\",\"actionName\":\"export\",\"url\":\"/page_template/export\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"pageTemplateCode\",\"version\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"exportExtendComponent\",\"url\":\"/page_template/extend_component/export\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"post\",\"actionName\":\"import\",\"url\":\"/page_template/extend_component/import\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"zip\",\"url\":\"/page_template/extend_component/import/zip\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"file\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"importByApplication\",\"url\":\"/page_template/extend_component/import_by_application\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"codes\",\"lang\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"latestConfig\",\"url\":\"/page_template/extend_component/latest_config\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"pageTemplateCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"record\",\"url\":\"/page_template/extend_component/record\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"post\",\"actionName\":\"importPageTemplate\",\"url\":\"/page_template/import\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"page_template_code\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"pageTemplate\",\"url\":\"/page_template/{page_template_code}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Permission\":{\"AppPermission\":[{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"apps\",\"url\":\"/permission/app/apps\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"functionPermission\",\"url\":\"/permission/app/function_permission\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"groupVO\"]},\"method\":\"post\",\"actionName\":\"postGroup\",\"url\":\"/permission/app/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"groupVO\"]},\"method\":\"put\",\"actionName\":\"editGroup\",\"url\":\"/permission/app/group\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"permissionGroupId\"],\"body\":[\"permissionScopes\"]},\"method\":\"post\",\"actionName\":\"auth\",\"url\":\"/permission/app/group/auth/{appCode}/{permissionGroupId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"permGroupId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"authGroup\",\"url\":\"/permission/app/group/auth/{permGroupId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"default\",\"url\":\"/permission/app/group/default\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"name\",\"page\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/permission/app/group/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"permGroupId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getGroup\",\"url\":\"/permission/app/group/{permGroupId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"permGroupId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteGroup\",\"url\":\"/permission/app/group/{permGroupId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"query\"]},\"method\":\"post\",\"actionName\":\"schemaPermission\",\"url\":\"/permission/app/schema_permission\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"AppRole\":[{\"parameters\":{\"query\":[],\"body\":[\"appRole\"]},\"method\":\"post\",\"actionName\":\"postRole\",\"url\":\"/permission/app/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"appRole\"]},\"method\":\"put\",\"actionName\":\"editRole\",\"url\":\"/permission/app/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"apps\",\"url\":\"/permission/app/role/apps/{roleId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"groupId\",\"roleId\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"upgradeRole\",\"url\":\"/permission/app/role/upgrade_role/{roleId}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"list\",\"url\":\"/permission/app/role/{appCode}/list\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"roleId\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"role\",\"url\":\"/permission/app/role/{roleId}\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Platform\":{\"PlatformRole\":[{\"parameters\":{\"query\":[],\"body\":[\"permDto\"]},\"method\":\"post\",\"actionName\":\"role\",\"url\":\"/platform/role\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"allCustomPerm\",\"url\":\"/platform/role/all_custom_perm\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"allCustomPermTree\",\"url\":\"/platform/role/all_custom_perm_tree\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appName\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"appManagerApps\",\"url\":\"/platform/role/app_manager_apps\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"perms\",\"url\":\"/platform/role/perms\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"platform\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"resources\",\"url\":\"/platform/role/resources\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"key\",\"page\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/platform/role/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getRole\",\"url\":\"/platform/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[\"permDto\"]},\"method\":\"put\",\"actionName\":\"editRole\",\"url\":\"/platform/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deleteRole\",\"url\":\"/platform/role/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"put\",\"actionName\":\"clearUnitScope\",\"url\":\"/platform/role/{id}/clear_unit_scope\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"PlatformRoleUser\":[{\"parameters\":{\"query\":[],\"body\":[\"permDto\"]},\"method\":\"post\",\"actionName\":\"postUser\",\"url\":\"/platform/role/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"permDto\"]},\"method\":\"put\",\"actionName\":\"editUser\",\"url\":\"/platform/role/user\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"page\",\"roleId\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/platform/role/user/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"user\",\"url\":\"/platform/role/user/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Security\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"passwordRegularExpression\",\"url\":\"/security/password_regular_expression\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"getPasswordRule\",\"url\":\"/security/password_rule\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"passwordRule\"]},\"method\":\"post\",\"actionName\":\"postPasswordRule\",\"url\":\"/security/password_rule\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"passwordRule\"]},\"method\":\"put\",\"actionName\":\"editPasswordRule\",\"url\":\"/security/password_rule\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getPasswordRuleSecurity\",\"url\":\"/security/password_rule/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"deletePasswordRule\",\"url\":\"/security/password_rule/{id}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Send\":[{\"parameters\":{\"query\":[],\"body\":[\"message\"]},\"method\":\"post\",\"actionName\":\"send\",\"url\":\"/send\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"System\":{\"ConfigManagement\":[{\"parameters\":{\"query\":[],\"body\":[\"configs\"]},\"method\":\"post\",\"actionName\":\"configManagement\",\"url\":\"/system/config_management\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"configType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByType\",\"url\":\"/system/config_management/list_by_type\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"configType\"],\"body\":[]},\"method\":\"delete\",\"actionName\":\"configManagementSystem\",\"url\":\"/system/config_management/{configType}\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"MessageAccount\":[{\"parameters\":{\"query\":[\"id\",\"pageNum\",\"pageSize\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listSmsSign\",\"url\":\"/system/message_account/sms/list_sms_sign\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\",\"pageNum\",\"pageSize\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listSmsTemplate\",\"url\":\"/system/message_account/sms/list_sms_template\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"id\",\"templateCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"smsTemplate\",\"url\":\"/system/message_account/sms/sms_template\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Todo\":[{\"parameters\":{\"query\":[],\"body\":[]},\"method\":\"get\",\"actionName\":\"countWorkitem\",\"url\":\"/todo/count_workitem\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"batchOperate\",\"onlineApp\",\"todoType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getAllappcodeByTodotype\",\"url\":\"/todo/get_allappcode_by_todotype\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"todoType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getAllworkflowByTodotype\",\"url\":\"/todo/get_allworkflow_by_todotype\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"messageId\",\"todoType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getSingleTodo\",\"url\":\"/todo/get_single_todo\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"endTime\",\"instanceName\",\"moduleCode\",\"originator\",\"page\",\"size\",\"startTime\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listByInitiate\",\"url\":\"/todo/list_by_initiate\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"opCmd\"],\"body\":[\"remind\"]},\"method\":\"post\",\"actionName\":\"remind\",\"url\":\"/todo/remind\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"appCode\",\"batchOperate\",\"endTime\",\"instanceName\",\"instanceState\",\"moduleCode\",\"originator\",\"page\",\"size\",\"startTime\",\"todoType\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/todo/search\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"UserLoginLog\":[{\"parameters\":{\"query\":[\"beginTime\",\"endTime\",\"ip\",\"page\",\"size\",\"source\",\"userName\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"query\",\"url\":\"/user_login_log/query\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"V1\":{\"Advanced\":[{\"parameters\":{\"query\":[],\"body\":[\"parameter\"]},\"method\":\"post\",\"actionName\":\"getNodes\",\"url\":\"/v1/advanced/getNodes\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"Report\":[{\"parameters\":{\"query\":[\"appCode\"],\"body\":[]},\"method\":\"post\",\"actionName\":\"bizobjectschemas\",\"url\":\"/v1/dashboard/bizobjectschemas\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"dataSourceRequest\"]},\"method\":\"post\",\"actionName\":\"datasource\",\"url\":\"/v1/dashboard/datasource\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"dataSourceListRequest\"]},\"method\":\"post\",\"actionName\":\"datasourcelist\",\"url\":\"/v1/dashboard/datasourcelist\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"afterExecuteSqlRequest\"]},\"method\":\"post\",\"actionName\":\"executeafter\",\"url\":\"/v1/dashboard/executeafter\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"beforeExecuteSqlRequest\"]},\"method\":\"post\",\"actionName\":\"executebefore\",\"url\":\"/v1/dashboard/executebefore\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"getBizModelReferenceRequest\"]},\"method\":\"post\",\"actionName\":\"modelinfos\",\"url\":\"/v1/dashboard/modelinfos\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"parameter\"]},\"method\":\"post\",\"actionName\":\"savereportreference\",\"url\":\"/v1/dashboard/savereportreference\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"Workflow\":{\"WorkflowAgencyEntrust\":[{\"parameters\":{\"query\":[\"isCurrentUser\",\"isFilterExpired\",\"page\",\"size\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"getAgencyEntrust\",\"url\":\"/workflow/agency_entrust\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"agencyEntrust\"]},\"method\":\"post\",\"actionName\":\"postAgencyEntrust\",\"url\":\"/workflow/agency_entrust\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"opCmd\"]},\"method\":\"put\",\"actionName\":\"editAgencyEntrust\",\"url\":\"/workflow/agency_entrust\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"ids\"]},\"method\":\"delete\",\"actionName\":\"deleteAgencyEntrust\",\"url\":\"/workflow/agency_entrust\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"apps\",\"url\":\"/workflow/agency_entrust/apps\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"userId\",\"workflowCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"listUsers\",\"url\":\"/workflow/agency_entrust/list_users\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[],\"body\":[\"cmd\"]},\"method\":\"post\",\"actionName\":\"startAgentIds\",\"url\":\"/workflow/agency_entrust/start_agent_ids\",\"security\":[{\"Authorization\":[\"global\"]}]}],\"WorkflowInstance\":[{\"parameters\":{\"query\":[\"appCode\",\"endTime\",\"instanceName\",\"moduleCode\",\"originator\",\"page\",\"sequenceNo\",\"size\",\"startTime\",\"state\",\"workflowCode\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"search\",\"url\":\"/workflow/search\",\"security\":[{\"Authorization\":[\"global\"]}]},{\"parameters\":{\"query\":[\"state\"],\"body\":[]},\"method\":\"get\",\"actionName\":\"workFlows\",\"url\":\"/workflow/work_flows\",\"security\":[{\"Authorization\":[\"global\"]}]}]},\"CONFIG\":{\"basePath\":\"/api/webapi\",\"host\":\"httpgateway\"}}");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2RlNDIzMiIgZD0iTTUxMiA2NC4zMDM1MzhjLTI0Ny4yNTYzNiAwLTQ0Ny42OTY0NjIgMjAwLjQ0MDEwMi00NDcuNjk2NDYyIDQ0Ny42OTY0NjIgMCAyNDcuMjU0MzE0IDIwMC40NDAxMDIgNDQ3LjY5NjQ2MiA0NDcuNjk2NDYyIDQ0Ny42OTY0NjJzNDQ3LjY5NjQ2Mi0yMDAuNDQwMTAyIDQ0Ny42OTY0NjItNDQ3LjY5NjQ2MlM3NTkuMjU2MzYgNjQuMzAzNTM4IDUxMiA2NC4zMDM1Mzh6TTcxMC40OTE3MjcgNjY1LjI2NjcwOWMxMi40OTE0OTkgMTIuNDkxNDk5IDEyLjQ4OTQ1MiAzMi43Mjk0MjUtMC4wMDIwNDcgNDUuMjIwOTI0LTYuMjQ2MjYxIDYuMjQ2MjYxLTE0LjQyOTY0MSA5LjM3MDQxNS0yMi42MTE5OTcgOS4zNzA0MTVzLTE2LjM2MzY4OS0zLjEyMTA4NC0yMi42MDk5NS05LjM2NjMyMkw1MTIgNTU3LjIyMjk3MSAzNTguNzMwMjIxIDcxMC40OTE3MjdjLTYuMjQ2MjYxIDYuMjQ2MjYxLTE0LjQyOTY0MSA5LjM2NjMyMi0yMi42MTE5OTcgOS4zNjYzMjJzLTE2LjM2NTczNi0zLjEyNTE3Ny0yMi42MTE5OTctOS4zNzA0MTVjLTEyLjQ5MTQ5OS0xMi40OTE0OTktMTIuNDkxNDk5LTMyLjcyOTQyNSAwLTQ1LjIyMDkyNGwxNTMuMjY4NzU2LTE1My4yNjY3MDlMMzEzLjUwNzI1IDM1OC43MzAyMjFjLTEyLjQ5MTQ5OS0xMi40OTE0OTktMTIuNDg5NDUyLTMyLjcyOTQyNSAwLjAwMjA0Ny00NS4yMjA5MjRzMzIuNzI5NDI1LTEyLjQ5NTU5MiA0NS4yMjA5MjQtMC4wMDQwOTNsMTUzLjI2ODc1NiAxNTMuMjY4NzU2IDE1My4yNjg3NTYtMTUzLjI2ODc1NmMxMi40OTE0OTktMTIuNDkxNDk5IDMyLjcyOTQyNS0xMi40ODc0MDYgNDUuMjIwOTI0IDAuMDA0MDkzczEyLjQ5MzU0NSAzMi43Mjk0MjUgMC4wMDIwNDcgNDUuMjIwOTI0TDU1Ny4yMjUwMTcgNTEyIDcxMC40OTE3MjcgNjY1LjI2NjcwOXoiIC8+PC9zdmc+Cg=="

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIKICAgICAgICAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiCiAgICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGw9IiMyNGI4NGUiCiAgICAgICAgICBkPSJNNTEwLjY0NTY1NCA5NTkuMzQ5NTYxYy0yNDcuMjU2MzYgMC00NDcuNjkxMzQ1LTIwMC40NDYyNDEtNDQ3LjY5MTM0NS00NDcuNzAwNTU1IDAtMjQ3LjI0NzE1IDIwMC40MzYwMDgtNDQ3LjY5MjM2OSA0NDcuNjkxMzQ1LTQ0Ny42OTIzNjkgMjQ3LjI1NjM2IDAgNDQ3LjY5MzM5MiAyMDAuNDQ1MjE4IDQ0Ny42OTMzOTIgNDQ3LjY5MjM2OUM5NTguMzM5MDQ2IDc1OC45MDMzMiA3NTcuOTAyMDE0IDk1OS4zNDk1NjEgNTEwLjY0NTY1NCA5NTkuMzQ5NTYxek03ODQuMTkxNzc0IDM1NC4yMzY4ODNsLTE0LjM4NzY4NS0xNC4zODc2ODVjLTcuOTQ5MDQzLTcuOTQ5MDQzLTIwLjgyNjMyOC03Ljk0OTA0My0yOC43NzUzNyAwTDQ0Mi42MDA5MDkgNjMyLjA4NjAwNiAzMzMuMDQ0NzI0IDUxNy40MzA2ODZjLTMuNTk3OTQ1LTMuNTk2OTIxLTEyLjk1ODEyNi0wLjA2MDM3NS0yMC45MDgxOTIgNy44ODg2NjdsLTE0LjM4NzY4NSAxNC4zODk3MzJjLTcuOTQ5MDQzIDcuOTQ5MDQzLTExLjQ2NTEyMyAxNy4zMDkyMjQtNy44NjkyMjUgMjAuODk1OTEzTDQzNi4wNjQwMjkgNzEzLjU3NDk0OGMzLjU3NjQ1NSAzLjU5Nzk0NSAxMi45MzY2MzcgMC4wNDkxMTkgMjAuODg2NzAzLTcuODg4NjY3bDE0LjM2ODI0Mi0xNC4zODg3MDhjMi41NDI5MTYtMi41MjM0NzMgNC40MTE0NzMtNS4xMzY5OTcgNS45NjA3NTktNy43MTA2MTJsMzA2LjkxMzA2NS0zMDAuNTYzNDVDNzkyLjE0Mjg2MyAzNzUuMDgzNjc3IDc5Mi4xNDI4NjMgMzYyLjE4NTkyNiA3ODQuMTkxNzc0IDM1NC4yMzY4ODN6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIKICAgICAgICAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiCiAgICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGw9IiNmMmEwMWYiCiAgICAgICAgICBkPSJNOTUzLjYgNzc0LjRMNTYzLjIgMTQ3LjJjLTI1LjYtMzguNC04My4yLTM4LjQtMTA4LjggMEw2NCA3NzQuNGMtMjUuNiA0NC44IDYuNCA5NiA1MS4yIDk2aDc3NC40YzU3LjYgMCA4OS42LTUxLjIgNjQtOTZ6TTUxMiA3NTUuMmMtMTkuMiAwLTMyLTEyLjgtMzItMzJzMTIuOC0zMiAzMi0zMiAzMiAxMi44IDMyIDMyLTEyLjggMzItMzIgMzJ6IG0zMi0xNDcuMmMwIDE5LjItMTIuOCAzMi0zMiAzMnMtMzItMTIuOC0zMi0zMnYtMTkyYzAtMTkuMiAxMi44LTMyIDMyLTMyczMyIDEyLjggMzIgMzJ2MTkyeiIvPgo8L3N2Zz4K"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_toast_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_toast_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_toast_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIKICAgICAgICAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiCiAgICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGw9IiMwMEJGRkYiCiAgICAgICAgICBkPSJNODk1LjcwMTMzMyAzMDAuMTE3MzMzYzAgOS42LTMuMiAxOS4yODUzMzMtOS42IDI3LjM5MmwtMzQwLjkwNjY2NiA0MjMuODA4YTQzLjczMzMzMyA0My43MzMzMzMgMCAwIDEtNjguMDk2IDBMMTM3Ljk4NCAzMjkuMzAxMzMzQTQzLjY5MDY2NyA0My42OTA2NjcgMCAwIDEgMjA2LjA4IDI3NC42MDI2NjdsMzA1LjEwOTMzMyAzNzkuNjA1MzMzIDMwNi43NzMzMzQtMzgxLjUyNTMzM2E0My42OTA2NjcgNDMuNjkwNjY3IDAgMCAxIDc3LjczODY2NiAyNy40MzQ2NjZ6IgogICAgICAgICAgb3BhY2l0eT0iLjY1Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_panel_item_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_panel_item_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_panel_item_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = require("regenerator-runtime");

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_network_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_network_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_network_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_panel_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_panel_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_panel_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_board_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_board_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_board_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_popup_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_popup_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_popup_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_popup_custom_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_popup_custom_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_message_popup_custom_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_main_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_main_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_less_loader_dist_cjs_js_ref_4_2_node_modules_vue_loader_lib_index_js_vue_loader_options_main_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
var _require = __webpack_require__(3),
    BigInteger = _require.BigInteger;

var _require2 = __webpack_require__(33),
    encodeDer = _require2.encodeDer,
    decodeDer = _require2.decodeDer;

var SM3Digest = __webpack_require__(14);

var SM2Cipher = __webpack_require__(35);

var _ = __webpack_require__(4);

var _$generateEcparam = _.generateEcparam(),
    G = _$generateEcparam.G,
    curve = _$generateEcparam.curve,
    n = _$generateEcparam.n;

var C1C2C3 = 0;
/**
 * 加密
 */

function doEncrypt(msg, publicKey) {
  var cipherMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var cipher = new SM2Cipher();
  msg = _.hexToArray(_.parseUtf8StringToHex(msg));

  if (publicKey.length > 128) {
    publicKey = publicKey.substr(publicKey.length - 128);
  }

  var xHex = publicKey.substr(0, 64);
  var yHex = publicKey.substr(64);
  publicKey = cipher.createPoint(xHex, yHex);
  var c1 = cipher.initEncipher(publicKey);
  cipher.encryptBlock(msg);

  var c2 = _.arrayToHex(msg);

  var c3 = new Array(32);
  cipher.doFinal(c3);
  c3 = _.arrayToHex(c3);
  return cipherMode === C1C2C3 ? c1 + c2 + c3 : c1 + c3 + c2;
}
/**
 * 解密
 */


function doDecrypt(encryptData, privateKey) {
  var cipherMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var cipher = new SM2Cipher();
  privateKey = new BigInteger(privateKey, 16);
  var c1X = encryptData.substr(0, 64);
  var c1Y = encryptData.substr(0 + c1X.length, 64);
  var c1Length = c1X.length + c1Y.length;
  var c3 = encryptData.substr(c1Length, 64);
  var c2 = encryptData.substr(c1Length + 64);

  if (cipherMode === C1C2C3) {
    c3 = encryptData.substr(encryptData.length - 64);
    c2 = encryptData.substr(c1Length, encryptData.length - c1Length - 64);
  }

  var data = _.hexToArray(c2);

  var c1 = cipher.createPoint(c1X, c1Y);
  cipher.initDecipher(privateKey, c1);
  cipher.decryptBlock(data);
  var c3_ = new Array(32);
  cipher.doFinal(c3_);
  var isDecrypt = _.arrayToHex(c3_) === c3;

  if (isDecrypt) {
    var decryptData = _.arrayToUtf8(data);

    return decryptData;
  } else {
    return '';
  }
}
/**
 * 签名
 */


function doSignature(msg, privateKey) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      pointPool = _ref.pointPool,
      der = _ref.der,
      hash = _ref.hash,
      publicKey = _ref.publicKey,
      userId = _ref.userId;

  var hashHex = typeof msg === 'string' ? _.parseUtf8StringToHex(msg) : _.parseArrayBufferToHex(msg);

  if (hash) {
    // sm3杂凑
    publicKey = publicKey || getPublicKeyFromPrivateKey(privateKey);
    hashHex = doSm3Hash(hashHex, publicKey, userId);
  }

  var dA = new BigInteger(privateKey, 16);
  var e = new BigInteger(hashHex, 16); // k

  var k = null;
  var r = null;
  var s = null;

  do {
    do {
      var point = void 0;

      if (pointPool && pointPool.length) {
        point = pointPool.pop();
      } else {
        point = getPoint();
      }

      k = point.k; // r = (e + x1) mod n

      r = e.add(point.x1).mod(n);
    } while (r.equals(BigInteger.ZERO) || r.add(k).equals(n)); // s = ((1 + dA)^-1 * (k - r * dA)) mod n


    s = dA.add(BigInteger.ONE).modInverse(n).multiply(k.subtract(r.multiply(dA))).mod(n);
  } while (s.equals(BigInteger.ZERO));

  if (der) {
    // asn1 der编码
    return encodeDer(r, s);
  }

  return _.leftPad(r.toString(16), 64) + _.leftPad(s.toString(16), 64);
}
/**
 * 验签
 */


function doVerifySignature(msg, signHex, publicKey) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      der = _ref2.der,
      hash = _ref2.hash,
      userId = _ref2.userId;

  var hashHex = typeof msg === 'string' ? _.parseUtf8StringToHex(msg) : _.parseArrayBufferToHex(msg);

  if (hash) {
    // sm3杂凑
    hashHex = doSm3Hash(hashHex, publicKey, userId);
  }

  var r;
  var s;

  if (der) {
    var decodeDerObj = decodeDer(signHex);
    r = decodeDerObj.r;
    s = decodeDerObj.s;
  } else {
    r = new BigInteger(signHex.substring(0, 64), 16);
    s = new BigInteger(signHex.substring(64), 16);
  }

  var PA = curve.decodePointHex(publicKey);
  var e = new BigInteger(hashHex, 16); // t = (r + s) mod n

  var t = r.add(s).mod(n);
  if (t.equals(BigInteger.ZERO)) return false; // x1y1 = s * G + t * PA

  var x1y1 = G.multiply(s).add(PA.multiply(t)); // R = (e + x1) mod n

  var R = e.add(x1y1.getX().toBigInteger()).mod(n);
  return r.equals(R);
}
/**
 * sm3杂凑算法
 * 计算M值: Hash(za || msg)
 */


function doSm3Hash(hashHex, publicKey) {
  var userId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1234567812345678';
  var smDigest = new SM3Digest();
  var z = new SM3Digest().getZ(G, publicKey.substr(2, 128), userId);

  var zValue = _.hexToArray(_.arrayToHex(z).toString());

  var p = hashHex;

  var pValue = _.hexToArray(p);

  var hashData = new Array(smDigest.getDigestSize());
  smDigest.blockUpdate(zValue, 0, zValue.length);
  smDigest.blockUpdate(pValue, 0, pValue.length);
  smDigest.doFinal(hashData, 0);
  return _.arrayToHex(hashData).toString();
}
/**
 * 计算公钥
 */


function getPublicKeyFromPrivateKey(privateKey) {
  var PA = G.multiply(new BigInteger(privateKey, 16));

  var x = _.leftPad(PA.getX().toBigInteger().toString(16), 64);

  var y = _.leftPad(PA.getY().toBigInteger().toString(16), 64);

  return '04' + x + y;
}
/**
 * 获取椭圆曲线点
 */


function getPoint() {
  var keypair = _.generateKeyPairHex();

  var PA = curve.decodePointHex(keypair.publicKey);
  keypair.k = new BigInteger(keypair.privateKey, 16);
  keypair.x1 = PA.getX().toBigInteger();
  return keypair;
}

module.exports = {
  generateKeyPairHex: _.generateKeyPairHex,
  doEncrypt: doEncrypt,
  doDecrypt: doDecrypt,
  doSignature: doSignature,
  doVerifySignature: doVerifySignature,
  getPoint: getPoint
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable */
var _require = __webpack_require__(3),
    BigInteger = _require.BigInteger;

function bigIntToMinTwosComplementsHex(bigIntegerValue) {
  var h = bigIntegerValue.toString(16);

  if (h.substr(0, 1) !== '-') {
    if (h.length % 2 === 1) {
      h = '0' + h;
    } else if (!h.match(/^[0-7]/)) {
      h = '00' + h;
    }
  } else {
    var hPos = h.substr(1);
    var xorLen = hPos.length;

    if (xorLen % 2 === 1) {
      xorLen += 1;
    } else if (!h.match(/^[0-7]/)) {
      xorLen += 2;
    }

    var hMask = '';

    for (var i = 0; i < xorLen; i++) {
      hMask += 'f';
    }

    var biMask = new BigInteger(hMask, 16);
    var biNeg = biMask.xor(bigIntegerValue).add(BigInteger.ONE);
    h = biNeg.toString(16).replace(/^-/, '');
  }

  return h;
}
/**
 * base class for ASN.1 DER encoder object
 */


var ASN1Object = /*#__PURE__*/function () {
  "use strict";

  function ASN1Object() {
    _classCallCheck(this, ASN1Object);

    this.isModified = true;
    this.hTLV = null;
    this.hT = '00';
    this.hL = '00';
    this.hV = '';
  }
  /**
   * get hexadecimal ASN.1 TLV length(L) bytes from TLV value(V)
   */


  _createClass(ASN1Object, [{
    key: "getLengthHexFromValue",
    value: function getLengthHexFromValue() {
      var n = this.hV.length / 2;
      var hN = n.toString(16);

      if (hN.length % 2 === 1) {
        hN = '0' + hN;
      }

      if (n < 128) {
        return hN;
      } else {
        var hNlen = hN.length / 2;
        var head = 128 + hNlen;
        return head.toString(16) + hN;
      }
    }
    /**
     * get hexadecimal string of ASN.1 TLV bytes
     */

  }, {
    key: "getEncodedHex",
    value: function getEncodedHex() {
      if (this.hTLV == null || this.isModified) {
        this.hV = this.getFreshValueHex();
        this.hL = this.getLengthHexFromValue();
        this.hTLV = this.hT + this.hL + this.hV;
        this.isModified = false;
      }

      return this.hTLV;
    }
  }, {
    key: "getFreshValueHex",
    value: function getFreshValueHex() {
      return '';
    }
  }]);

  return ASN1Object;
}();
/**
 * class for ASN.1 DER Integer
 */


var DERInteger = /*#__PURE__*/function (_ASN1Object) {
  "use strict";

  _inherits(DERInteger, _ASN1Object);

  var _super = _createSuper(DERInteger);

  function DERInteger(options) {
    var _this;

    _classCallCheck(this, DERInteger);

    _this = _super.call(this);
    _this.hT = '02';

    if (options && options.bigint) {
      _this.hTLV = null;
      _this.isModified = true;
      _this.hV = bigIntToMinTwosComplementsHex(options.bigint);
    }

    return _this;
  }

  _createClass(DERInteger, [{
    key: "getFreshValueHex",
    value: function getFreshValueHex() {
      return this.hV;
    }
  }]);

  return DERInteger;
}(ASN1Object);
/**
 * class for ASN.1 DER Sequence
 */


var DERSequence = /*#__PURE__*/function (_ASN1Object2) {
  "use strict";

  _inherits(DERSequence, _ASN1Object2);

  var _super2 = _createSuper(DERSequence);

  function DERSequence(options) {
    var _this2;

    _classCallCheck(this, DERSequence);

    _this2 = _super2.call(this);
    _this2.hT = '30';
    _this2.asn1Array = [];

    if (options && options.array) {
      _this2.asn1Array = options.array;
    }

    return _this2;
  }

  _createClass(DERSequence, [{
    key: "getFreshValueHex",
    value: function getFreshValueHex() {
      var h = '';

      for (var i = 0; i < this.asn1Array.length; i++) {
        var asn1Obj = this.asn1Array[i];
        h += asn1Obj.getEncodedHex();
      }

      this.hV = h;
      return this.hV;
    }
  }]);

  return DERSequence;
}(ASN1Object);
/**
 * get byte length for ASN.1 L(length) bytes
 */


function getByteLengthOfL(s, pos) {
  if (s.substring(pos + 2, pos + 3) !== '8') return 1;
  var i = parseInt(s.substring(pos + 3, pos + 4), 10);
  if (i === 0) return -1; // length octet '80' indefinite length

  if (i > 0 && i < 10) return i + 1; // including '8?' octet;

  return -2; // malformed format
}
/**
 * get hexadecimal string for ASN.1 L(length) bytes
 */


function getHexOfL(s, pos) {
  var len = getByteLengthOfL(s, pos);
  if (len < 1) return '';
  return s.substring(pos + 2, pos + 2 + len * 2);
}
/**
 * get integer value of ASN.1 length for ASN.1 data
 */


function getIntOfL(s, pos) {
  var hLength = getHexOfL(s, pos);
  if (hLength === '') return -1;
  var bi;

  if (parseInt(hLength.substring(0, 1), 10) < 8) {
    bi = new BigInteger(hLength, 16);
  } else {
    bi = new BigInteger(hLength.substring(2), 16);
  }

  return bi.intValue();
}
/**
 * get ASN.1 value starting string position for ASN.1 object refered by index 'idx'.
 */


function getStartPosOfV(s, pos) {
  var lLen = getByteLengthOfL(s, pos);
  if (lLen < 0) return lLen;
  return pos + (lLen + 1) * 2;
}
/**
 * get hexadecimal string of ASN.1 V(value)
 */


function getHexOfV(s, pos) {
  var pos1 = getStartPosOfV(s, pos);
  var len = getIntOfL(s, pos);
  return s.substring(pos1, pos1 + len * 2);
}
/**
 * get next sibling starting index for ASN.1 object string
 */


function getPosOfNextSibling(s, pos) {
  var pos1 = getStartPosOfV(s, pos);
  var len = getIntOfL(s, pos);
  return pos1 + len * 2;
}
/**
 * get array of indexes of child ASN.1 objects
 */


function getPosArrayOfChildren(h, pos) {
  var a = [];
  var p0 = getStartPosOfV(h, pos);
  a.push(p0);
  var len = getIntOfL(h, pos);
  var p = p0;
  var k = 0;

  for (;;) {
    var pNext = getPosOfNextSibling(h, p);
    if (pNext == null || pNext - p0 >= len * 2) break;
    if (k >= 200) break;
    a.push(pNext);
    p = pNext;
    k++;
  }

  return a;
}

module.exports = {
  /**
   * ASN.1 DER编码
   */
  encodeDer: function encodeDer(r, s) {
    var derR = new DERInteger({
      bigint: r
    });
    var derS = new DERInteger({
      bigint: s
    });
    var derSeq = new DERSequence({
      array: [derR, derS]
    });
    return derSeq.getEncodedHex();
  },

  /**
   * 解析 ASN.1 DER
   */
  decodeDer: function decodeDer(input) {
    // 1. Items of ASN.1 Sequence Check
    var a = getPosArrayOfChildren(input, 0); // 2. Integer check

    var iTLV1 = a[0];
    var iTLV2 = a[1]; // 3. getting value

    var hR = getHexOfV(input, iTLV1);
    var hS = getHexOfV(input, iTLV2);
    var r = new BigInteger(hR, 16);
    var s = new BigInteger(hS, 16);
    return {
      r: r,
      s: s
    };
  }
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable */
var _require = __webpack_require__(3),
    BigInteger = _require.BigInteger;
/**
 * thanks for Tom Wu : http://www-cs-students.stanford.edu/~tjw/jsbn/
 *
 * Basic Javascript Elliptic Curve implementation
 * Ported loosely from BouncyCastle's Java EC code
 * Only Fp curves implemented for now
 */


var THREE = new BigInteger('3');
/**
 * 椭圆曲线域元素
 */

var ECFieldElementFp = /*#__PURE__*/function () {
  "use strict";

  function ECFieldElementFp(q, x) {
    _classCallCheck(this, ECFieldElementFp);

    this.x = x;
    this.q = q; // TODO if (x.compareTo(q) >= 0) error
  }
  /**
   * 判断相等
   */


  _createClass(ECFieldElementFp, [{
    key: "equals",
    value: function equals(other) {
      if (other === this) return true;
      return this.q.equals(other.q) && this.x.equals(other.x);
    }
    /**
     * 返回具体数值
     */

  }, {
    key: "toBigInteger",
    value: function toBigInteger() {
      return this.x;
    }
    /**
     * 取反
     */

  }, {
    key: "negate",
    value: function negate() {
      return new ECFieldElementFp(this.q, this.x.negate().mod(this.q));
    }
    /**
     * 相加
     */

  }, {
    key: "add",
    value: function add(b) {
      return new ECFieldElementFp(this.q, this.x.add(b.toBigInteger()).mod(this.q));
    }
    /**
     * 相减
     */

  }, {
    key: "subtract",
    value: function subtract(b) {
      return new ECFieldElementFp(this.q, this.x.subtract(b.toBigInteger()).mod(this.q));
    }
    /**
     * 相乘
     */

  }, {
    key: "multiply",
    value: function multiply(b) {
      return new ECFieldElementFp(this.q, this.x.multiply(b.toBigInteger()).mod(this.q));
    }
    /**
     * 相除
     */

  }, {
    key: "divide",
    value: function divide(b) {
      return new ECFieldElementFp(this.q, this.x.multiply(b.toBigInteger().modInverse(this.q)).mod(this.q));
    }
    /**
     * 平方
     */

  }, {
    key: "square",
    value: function square() {
      return new ECFieldElementFp(this.q, this.x.square().mod(this.q));
    }
  }]);

  return ECFieldElementFp;
}();

var ECPointFp = /*#__PURE__*/function () {
  "use strict";

  function ECPointFp(curve, x, y, z) {
    _classCallCheck(this, ECPointFp);

    this.curve = curve;
    this.x = x;
    this.y = y; // 标准射影坐标系：zinv == null 或 z * zinv == 1

    this.z = z == null ? BigInteger.ONE : z;
    this.zinv = null; // TODO: compression flag
  }

  _createClass(ECPointFp, [{
    key: "getX",
    value: function getX() {
      if (this.zinv === null) this.zinv = this.z.modInverse(this.curve.q);
      return this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q));
    }
  }, {
    key: "getY",
    value: function getY() {
      if (this.zinv === null) this.zinv = this.z.modInverse(this.curve.q);
      return this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q));
    }
    /**
     * 判断相等
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (other === this) return true;
      if (this.isInfinity()) return other.isInfinity();
      if (other.isInfinity()) return this.isInfinity(); // u = y2 * z1 - y1 * z2

      var u = other.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(other.z)).mod(this.curve.q);
      if (!u.equals(BigInteger.ZERO)) return false; // v = x2 * z1 - x1 * z2

      var v = other.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(other.z)).mod(this.curve.q);
      return v.equals(BigInteger.ZERO);
    }
    /**
     * 是否是无穷远点
     */

  }, {
    key: "isInfinity",
    value: function isInfinity() {
      if (this.x === null && this.y === null) return true;
      return this.z.equals(BigInteger.ZERO) && !this.y.toBigInteger().equals(BigInteger.ZERO);
    }
    /**
     * 取反，x 轴对称点
     */

  }, {
    key: "negate",
    value: function negate() {
      return new ECPointFp(this.curve, this.x, this.y.negate(), this.z);
    }
    /**
     * 相加
     *
     * 标准射影坐标系：
     *
     * λ1 = x1 * z2
     * λ2 = x2 * z1
     * λ3 = λ1 − λ2
     * λ4 = y1 * z2
     * λ5 = y2 * z1
     * λ6 = λ4 − λ5
     * λ7 = λ1 + λ2
     * λ8 = z1 * z2
     * λ9 = λ3^2
     * λ10 = λ3 * λ9
     * λ11 = λ8 * λ6^2 − λ7 * λ9
     * x3 = λ3 * λ11
     * y3 = λ6 * (λ9 * λ1 − λ11) − λ4 * λ10
     * z3 = λ10 * λ8
     */

  }, {
    key: "add",
    value: function add(b) {
      if (this.isInfinity()) return b;
      if (b.isInfinity()) return this;
      var x1 = this.x.toBigInteger();
      var y1 = this.y.toBigInteger();
      var z1 = this.z;
      var x2 = b.x.toBigInteger();
      var y2 = b.y.toBigInteger();
      var z2 = b.z;
      var q = this.curve.q;
      var w1 = x1.multiply(z2).mod(q);
      var w2 = x2.multiply(z1).mod(q);
      var w3 = w1.subtract(w2);
      var w4 = y1.multiply(z2).mod(q);
      var w5 = y2.multiply(z1).mod(q);
      var w6 = w4.subtract(w5);

      if (BigInteger.ZERO.equals(w3)) {
        if (BigInteger.ZERO.equals(w6)) {
          return this.twice(); // this == b，计算自加
        }

        return this.curve.infinity; // this == -b，则返回无穷远点
      }

      var w7 = w1.add(w2);
      var w8 = z1.multiply(z2).mod(q);
      var w9 = w3.square().mod(q);
      var w10 = w3.multiply(w9).mod(q);
      var w11 = w8.multiply(w6.square()).subtract(w7.multiply(w9)).mod(q);
      var x3 = w3.multiply(w11).mod(q);
      var y3 = w6.multiply(w9.multiply(w1).subtract(w11)).subtract(w4.multiply(w10)).mod(q);
      var z3 = w10.multiply(w8).mod(q);
      return new ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
    }
    /**
     * 自加
     *
     * 标准射影坐标系：
     *
     * λ1 = 3 * x1^2 + a * z1^2
     * λ2 = 2 * y1 * z1
     * λ3 = y1^2
     * λ4 = λ3 * x1 * z1
     * λ5 = λ2^2
     * λ6 = λ1^2 − 8 * λ4
     * x3 = λ2 * λ6
     * y3 = λ1 * (4 * λ4 − λ6) − 2 * λ5 * λ3
     * z3 = λ2 * λ5
     */

  }, {
    key: "twice",
    value: function twice() {
      if (this.isInfinity()) return this;
      if (!this.y.toBigInteger().signum()) return this.curve.infinity;
      var x1 = this.x.toBigInteger();
      var y1 = this.y.toBigInteger();
      var z1 = this.z;
      var q = this.curve.q;
      var a = this.curve.a.toBigInteger();
      var w1 = x1.square().multiply(THREE).add(a.multiply(z1.square())).mod(q);
      var w2 = y1.shiftLeft(1).multiply(z1).mod(q);
      var w3 = y1.square().mod(q);
      var w4 = w3.multiply(x1).multiply(z1).mod(q);
      var w5 = w2.square().mod(q);
      var w6 = w1.square().subtract(w4.shiftLeft(3)).mod(q);
      var x3 = w2.multiply(w6).mod(q);
      var y3 = w1.multiply(w4.shiftLeft(2).subtract(w6)).subtract(w5.shiftLeft(1).multiply(w3)).mod(q);
      var z3 = w2.multiply(w5).mod(q);
      return new ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
    }
    /**
     * 倍点计算
     */

  }, {
    key: "multiply",
    value: function multiply(k) {
      if (this.isInfinity()) return this;
      if (!k.signum()) return this.curve.infinity; // 使用加减法

      var k3 = k.multiply(THREE);
      var neg = this.negate();
      var Q = this;

      for (var i = k3.bitLength() - 2; i > 0; i--) {
        Q = Q.twice();
        var k3Bit = k3.testBit(i);
        var kBit = k.testBit(i);

        if (k3Bit !== kBit) {
          Q = Q.add(k3Bit ? this : neg);
        }
      }

      return Q;
    }
  }]);

  return ECPointFp;
}();
/**
 * 椭圆曲线 y^2 = x^3 + ax + b
 */


var ECCurveFp = /*#__PURE__*/function () {
  "use strict";

  function ECCurveFp(q, a, b) {
    _classCallCheck(this, ECCurveFp);

    this.q = q;
    this.a = this.fromBigInteger(a);
    this.b = this.fromBigInteger(b);
    this.infinity = new ECPointFp(this, null, null); // 无穷远点
  }
  /**
   * 判断两个椭圆曲线是否相等
   */


  _createClass(ECCurveFp, [{
    key: "equals",
    value: function equals(other) {
      if (other === this) return true;
      return this.q.equals(other.q) && this.a.equals(other.a) && this.b.equals(other.b);
    }
    /**
     * 生成椭圆曲线域元素
     */

  }, {
    key: "fromBigInteger",
    value: function fromBigInteger(x) {
      return new ECFieldElementFp(this.q, x);
    }
    /**
     * 解析 16 进制串为椭圆曲线点
     */

  }, {
    key: "decodePointHex",
    value: function decodePointHex(s) {
      switch (parseInt(s.substr(0, 2), 16)) {
        // 第一个字节
        case 0:
          return this.infinity;

        case 2:
        case 3:
          // 不支持的压缩方式
          return null;

        case 4:
        case 6:
        case 7:
          var len = (s.length - 2) / 2;
          var xHex = s.substr(2, len);
          var yHex = s.substr(len + 2, len);
          return new ECPointFp(this, this.fromBigInteger(new BigInteger(xHex, 16)), this.fromBigInteger(new BigInteger(yHex, 16)));

        default:
          // 不支持
          return null;
      }
    }
  }]);

  return ECCurveFp;
}();

module.exports = {
  ECPointFp: ECPointFp,
  ECCurveFp: ECCurveFp
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable */
var _require = __webpack_require__(3),
    BigInteger = _require.BigInteger;

var SM3Digest = __webpack_require__(14);

var _ = __webpack_require__(4);

var SM2Cipher = /*#__PURE__*/function () {
  "use strict";

  function SM2Cipher() {
    _classCallCheck(this, SM2Cipher);

    this.ct = 1;
    this.p2 = null;
    this.sm3keybase = null;
    this.sm3c3 = null;
    this.key = new Array(32);
    this.keyOff = 0;
  }

  _createClass(SM2Cipher, [{
    key: "reset",
    value: function reset() {
      this.sm3keybase = new SM3Digest();
      this.sm3c3 = new SM3Digest();

      var xWords = _.hexToArray(_.leftPad(this.p2.getX().toBigInteger().toRadix(16), 64));

      var yWords = _.hexToArray(_.leftPad(this.p2.getY().toBigInteger().toRadix(16), 64));

      this.sm3keybase.blockUpdate(xWords, 0, xWords.length);
      this.sm3c3.blockUpdate(xWords, 0, xWords.length);
      this.sm3keybase.blockUpdate(yWords, 0, yWords.length);
      this.ct = 1;
      this.nextKey();
    }
  }, {
    key: "nextKey",
    value: function nextKey() {
      var sm3keycur = new SM3Digest(this.sm3keybase);
      sm3keycur.update(this.ct >> 24 & 0x00ff);
      sm3keycur.update(this.ct >> 16 & 0x00ff);
      sm3keycur.update(this.ct >> 8 & 0x00ff);
      sm3keycur.update(this.ct & 0x00ff);
      sm3keycur.doFinal(this.key, 0);
      this.keyOff = 0;
      this.ct++;
    }
  }, {
    key: "initEncipher",
    value: function initEncipher(userKey) {
      var keypair = _.generateKeyPairHex();

      var k = new BigInteger(keypair.privateKey, 16);
      var publicKey = keypair.publicKey;
      this.p2 = userKey.multiply(k); // [k](Pb)

      this.reset();

      if (publicKey.length > 128) {
        publicKey = publicKey.substr(publicKey.length - 128);
      }

      return publicKey;
    }
  }, {
    key: "encryptBlock",
    value: function encryptBlock(data) {
      this.sm3c3.blockUpdate(data, 0, data.length);

      for (var i = 0; i < data.length; i++) {
        if (this.keyOff === this.key.length) {
          this.nextKey();
        }

        data[i] ^= this.key[this.keyOff++] & 0xff;
      }
    }
  }, {
    key: "initDecipher",
    value: function initDecipher(userD, c1) {
      this.p2 = c1.multiply(userD);
      this.reset();
    }
  }, {
    key: "decryptBlock",
    value: function decryptBlock(data) {
      for (var i = 0; i < data.length; i++) {
        if (this.keyOff === this.key.length) {
          this.nextKey();
        }

        data[i] ^= this.key[this.keyOff++] & 0xff;
      }

      this.sm3c3.blockUpdate(data, 0, data.length);
    }
  }, {
    key: "doFinal",
    value: function doFinal(c3) {
      var yWords = _.hexToArray(_.leftPad(this.p2.getY().toBigInteger().toRadix(16), 64));

      this.sm3c3.blockUpdate(yWords, 0, yWords.length);
      this.sm3c3.doFinal(c3, 0);
      this.reset();
    }
  }, {
    key: "createPoint",
    value: function createPoint(x, y) {
      var publicKey = '04' + x + y;

      var point = _.getGlobalCurve().decodePointHex(publicKey);

      return point;
    }
  }]);

  return SM2Cipher;
}();

module.exports = SM2Cipher;

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__(2);
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(0);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/utils/index.ts
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var hostConfig = {
  errCode: ['errCode', 'errcode', 'error'],
  data: ['data'],
  errMessage: ['errMessage', 'errMsg', 'statusText'],
  errKey: ['errKey'],
  success: ['success', 'isSuccess'],
  timestamp: ['timestamp'],
  traceId: ['traceId'],
  correctGuid: ['correctGuid', 'correctGuide'],
  total: ['total']
};
function setHostConfig(config) {
  if (config && config.toString() === '[object Object]') {
    Object.keys(config).forEach(function (key) {
      if (!hostConfig[key]) return;

      if (typeof config[key] === 'string') {
        hostConfig[key].unshift(config[key]);
      } else if (Array.isArray(config[key])) {
        hostConfig[key] = _toConsumableArray(new Set([].concat(config[key], hostConfig[key])));
      }
    });
  }
}
/**
 * 随机字符串
 */

function randomKey() {
  var str = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRRSTUVWXYZ01234567890';
  var key = '';

  for (var i = 0; i < 10; i++) {
    var index = parseInt((Math.random() * str.length).toString(), 10);
    key += str[index];
  }

  return key;
}
function dataAdapter(res) {
  if (!res) return;
  var result = {};
  Object.keys(hostConfig).forEach(function (key) {
    result[key] = getResponseByConfig(res, key);
  }); // 其余的数据

  var newRes = {};
  Object.keys(res).forEach(function (key) {
    /* eslint-disable-next-line */
    if (!result.hasOwnProperty(key)) {
      newRes[key] = res[key];
    }
  });
  return _objectSpread(_objectSpread({}, newRes), result);
}
function getResponseByConfig(res, key) {
  var keys = hostConfig[key];
  return getResponse(res, keys);
}

function getResponse(res, key) {
  if (!res) return;
  var result;

  if (typeof key === 'string') {
    result = res[key];
  }

  if (Array.isArray(key)) {
    key.some(function (k) {
      var r = res[k];

      if (r) {
        result = r;
        return true;
      }
    });
  } // const resData = res && res.data;
  // if (typeof key === 'string') {
  //   result = (resData && resData[key]) || res[key];
  // }
  // if (Array.isArray(key)) {
  //   key.some(k => {
  //     const r = (resData && resData[k]) || res[k];
  //     if (r) {
  //       result = r;
  //       return true;
  //     }
  //   });
  // }


  return result;
}
/**
 * 错误码适配方法
 * @param res
 */


function errorCodeAdapter(res) {
  var _res$request, _res$config, _res$config2;

  // 如果标记isAdapted，则表示已经处理过了，此处不再处理
  if (res && res.isAdapted) return res;
  var responseData = res === null || res === void 0 ? void 0 : res.data;
  var info = {
    key: randomKey(),
    httpStatus: res === null || res === void 0 ? void 0 : res.status,
    responseURL: (res === null || res === void 0 ? void 0 : res.request) && (res === null || res === void 0 ? void 0 : (_res$request = res.request) === null || _res$request === void 0 ? void 0 : _res$request.responseURL) || (res === null || res === void 0 ? void 0 : (_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url),
    path: window.location.href,
    headers: res === null || res === void 0 ? void 0 : res.headers,
    requestData: res === null || res === void 0 ? void 0 : (_res$config2 = res.config) === null || _res$config2 === void 0 ? void 0 : _res$config2.data,
    errcode: (getResponse(res, hostConfig.errCode) || '-').toString(),
    errmsg: getResponse(res, hostConfig.errMessage) || '',
    data: getResponse(responseData, hostConfig.data) || '',
    traceId: getResponse(res, hostConfig.traceId) || '',
    correctGuide: getResponse(res, hostConfig.correctGuid) || '',
    timeStamp: getResponse(res, hostConfig.timestamp),
    isAdapted: true
  };
  return info;
}
/**
 * 下于10的数字补零
 * @param number { number }
 * @return { string }
 */

function dateString(number) {
  if (number < 10) return '0' + number.toString();
  return number.toString();
}
/**
 * 日期格式
 * @param date { number }
 * @return { string } "YYYY/MM/DD HH:mm:ss"
 */


function dateFormat(date) {
  var d = new Date(date);
  var year = d.getFullYear();
  var day = dateString(d.getDate());
  var month = dateString(d.getMonth() + 1);
  var hour = dateString(d.getHours());
  var minute = dateString(d.getMinutes());
  var second = dateString(d.getSeconds());
  return year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/main.vue?vue&type=template&id=bc750a7e&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cloudPivot-error-container" },
    [
      _vm._l(_vm.errs, function(item, index) {
        return _c("toast", {
          key: item.key,
          attrs: { msg: item.errmsg, index: index, type: item.type },
          on: {
            click: function() {
              !item.options.autoHide && _vm.remove(item.key)
            }
          }
        })
      }),
      _vm.showPanel
        ? _c("panel", {
            attrs: { errors: _vm.captureErrors },
            on: { clear: _vm.clearCaptureError }
          })
        : _vm._e(),
      _vm.showBoard
        ? _c("message-board", {
            attrs: {
              title: _vm.messageBoardOptions.title,
              message: _vm.messageBoardOptions.message
            }
          })
        : _vm._e(),
      _c("div", { ref: "popup" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/main.vue?vue&type=template&id=bc750a7e&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/toast.vue?vue&type=template&id=8fad1762&
var toastvue_type_template_id_8fad1762_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cloudPivot-error-catcher-toast",
      class: _vm.type + "-toast",
      style: { top: _vm.top },
      on: { click: _vm.onClick }
    },
    [
      _c("span", { staticClass: "cloudPivot-error-catcher-icon" }, [
        _c("img", { attrs: { src: _vm.icon[_vm.type] } })
      ]),
      _vm._v("\n  " + _vm._s(_vm.msg) + "\n")
    ]
  )
}
var toastvue_type_template_id_8fad1762_staticRenderFns = []
toastvue_type_template_id_8fad1762_render._withStripped = true


// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/toast.vue?vue&type=template&id=8fad1762&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--6-1!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/toast.vue?vue&type=script&lang=ts&
// import Vue from "vue";
/* harmony default export */ var toastvue_type_script_lang_ts_ = ({
  name: 'Toast',
  props: {
    msg: String,
    index: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true,
      "default": 'error'
    }
  },
  data: function data() {
    return {
      icon: {
        error: __webpack_require__(17),
        success: __webpack_require__(18),
        warning: __webpack_require__(19),
        info: __webpack_require__(20)
      }
    };
  },
  computed: {
    top: function top() {
      return (this.index * 40 + 40).toString() + 'px';
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  }
});
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/toast.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_toastvue_type_script_lang_ts_ = (toastvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./packages/domain-api/src/error-catcher/components/toast.vue?vue&type=style&index=0&lang=less&
var toastvue_type_style_index_0_lang_less_ = __webpack_require__(21);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/toast.vue






/* normalize component */

var component = normalizeComponent(
  components_toastvue_type_script_lang_ts_,
  toastvue_type_template_id_8fad1762_render,
  toastvue_type_template_id_8fad1762_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/domain-api/src/error-catcher/components/toast.vue"
/* harmony default export */ var components_toast = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/panel.vue?vue&type=template&id=5023b1ac&
var panelvue_type_template_id_5023b1ac_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "panel",
      staticClass: "cloudPivot-error-catcher-panel",
      class: { show: _vm.show }
    },
    [
      _c(
        "a",
        {
          staticClass: "cloudPivot-error-catcher-panel-clear",
          class: { bottom: !_vm.networkBarVisible },
          on: { click: _vm.clear }
        },
        [_vm._v("\n    清空所有(" + _vm._s(_vm.errors.length) + ") x\n  ")]
      ),
      _c(
        "a",
        {
          staticClass: "cloudPivot-error-catcher-panel-doc",
          class: { bottom: !_vm.networkBarVisible },
          attrs: {
            href: "https://h3ui.cloudpivot.cn/components/error-catcher",
            target: "_blank",
            rel: "noreferrer noflow"
          }
        },
        [_vm._v("\n    使用文档\n  ")]
      ),
      _c(
        "div",
        {
          staticClass: "cloudPivot-error-catcher-panel-tab",
          class: { new: _vm.isChange, draging: _vm.draging },
          style: { top: _vm.top },
          attrs: { draggable: "true" },
          on: {
            dragstart: _vm.dragStart,
            drag: _vm.drag,
            dragend: _vm.dragEnd,
            click: _vm.toggle
          }
        },
        [_vm._v("\n    错误(" + _vm._s(_vm.errors.length) + ")\n  ")]
      ),
      _c(
        "div",
        {
          ref: "container",
          staticClass: "cloudPivot-error-catcher-panel-container"
        },
        [
          _c(
            "div",
            { ref: "inner" },
            [
              _vm._l(_vm.errors, function(item, index) {
                return _c("panel-item", {
                  key: item.key,
                  attrs: { item: item, index: index }
                })
              }),
              _vm.errors.length === 0
                ? _c(
                    "div",
                    { staticClass: "cloudPivot-error-catcher-panel-no-error" },
                    [_vm._v("\n        暂无错误记录\n      ")]
                  )
                : _vm._e(),
              _c("div", {
                staticClass: "cloudPivot-error-catcher-panel-placeholder"
              })
            ],
            2
          )
        ]
      ),
      _c("network", { on: { networkBarClose: _vm.networkBarClose } })
    ],
    1
  )
}
var panelvue_type_template_id_5023b1ac_staticRenderFns = []
panelvue_type_template_id_5023b1ac_render._withStripped = true


// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/panel.vue?vue&type=template&id=5023b1ac&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/panel-item.vue?vue&type=template&id=73813cc4&
var panel_itemvue_type_template_id_73813cc4_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cloudPivot-error-catcher-panel-item",
      class: { hidden: !_vm.show }
    },
    [
      _c("span", { staticClass: "cloudPivot-error-catcher-panel-item-time" }, [
        _vm._v(_vm._s(_vm.time))
      ]),
      _c(
        "a",
        {
          staticClass: "cloudPivot-error-catcher-panel-item-hide",
          on: { click: _vm.toggle }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.show ? "隐藏" : "展开") +
              "(" +
              _vm._s(_vm.index + 1) +
              ")\n    "
          ),
          _c("img", {
            staticClass: "cloudPivot-error-catcher-panel-item-arrow",
            class: { active: _vm.show },
            attrs: { src: _vm.arrow }
          })
        ]
      ),
      _c(
        "ul",
        { staticClass: "cloudPivot-error-catcher-panel-item-error-table" },
        [
          _c(
            "li",
            {
              staticClass: "cloudPivot-error-catcher-panel-item-error",
              class: { cross: !_vm.item.traceId }
            },
            [
              _c("span", [_vm._v("错误码:")]),
              _c("div", [
                _vm.item.errcode &&
                _vm.item.errcode !== "-" &&
                _vm.item.errcode !== "" &&
                /\d/.test(_vm.item.errcode)
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "cloudPivot-error-catcher-panel-item-error-code",
                        attrs: {
                          href: "_",
                          target: "_blank",
                          rel: "noopener noreferer"
                        }
                      },
                      [_vm._v(_vm._s(_vm.item.errcode))]
                    )
                  : _c("span", [_vm._v(_vm._s(_vm.item.errcode))])
              ])
            ]
          ),
          _vm.item.traceId
            ? _c(
                "li",
                { staticClass: "cloudPivot-error-catcher-panel-item-error" },
                [
                  _c("span", [_vm._v("Trace Id:")]),
                  _c("div", [_vm._v(_vm._s(_vm.item.traceId))])
                ]
              )
            : _vm._e(),
          _c(
            "li",
            { staticClass: "cross cloudPivot-error-catcher-panel-item-error" },
            [
              _c("span", [_vm._v("错误信息:")]),
              _c("div", [_vm._v(_vm._s(_vm.item.errmsg))])
            ]
          ),
          _vm.item.httpStatus
            ? _c("li", { staticClass: "cross" }, [
                _c("span", [_vm._v("http Status:")]),
                _c("div", [_vm._v(_vm._s(_vm.item.httpStatus))])
              ])
            : _vm._e(),
          _vm.item.responseURL
            ? _c("li", { staticClass: "cross" }, [
                _c("span", [_vm._v("请求地址:")]),
                _c("div", [_vm._v(_vm._s(_vm.item.responseURL))])
              ])
            : _vm._e(),
          _vm.item.requestData
            ? _c("li", { staticClass: "cross" }, [
                _c("span", [_vm._v("请求参数:")]),
                _c(
                  "div",
                  {
                    staticClass:
                      "cloudPivot-error-catcher-panel-item-request-params"
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.item.requestData) + "\n      "
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm.item.path
            ? _c("li", { staticClass: "cross" }, [
                _c("span", [_vm._v("来源地址:")]),
                _c("div", [_vm._v(_vm._s(_vm.item.path))])
              ])
            : _vm._e(),
          _vm.item.headers || _vm.item.data
            ? _c("li", { staticClass: "cross" }, [
                _c("span", [
                  _c("a", { on: { click: _vm.toggleDetail } }, [
                    _vm._v("其他信息")
                  ]),
                  _c("img", {
                    staticClass: "cloudPivot-error-catcher-panel-item-arrow",
                    class: { active: _vm.showDetail },
                    attrs: { src: _vm.arrow }
                  })
                ])
              ])
            : _vm._e(),
          _vm.item.headers && _vm.showDetail
            ? _c("li", { staticClass: "cross" }, [
                _c("span", [_vm._v("headers:")]),
                _c(
                  "div",
                  _vm._l(Object.keys(_vm.item.headers), function(k) {
                    return _c("div", { key: k }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(k) +
                          ": " +
                          _vm._s(_vm.item.headers[k]) +
                          "\n        "
                      )
                    ])
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm.item.data && _vm.showDetail
            ? _c("li", { staticClass: "cross" }, [
                _c("span", [_vm._v("data:")]),
                _c("div", [
                  typeof _vm.item.data === "object"
                    ? _c(
                        "div",
                        _vm._l(Object.keys(_vm.item.data), function(k) {
                          return _c("div", { key: k }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(k) +
                                ": " +
                                _vm._s(_vm.item.data[k]) +
                                "\n          "
                            )
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  typeof _vm.item.data !== "object"
                    ? _c("div", [
                        _vm._v(
                          "\n          " + _vm._s(_vm.item.data) + "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var panel_itemvue_type_template_id_73813cc4_staticRenderFns = []
panel_itemvue_type_template_id_73813cc4_render._withStripped = true


// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/panel-item.vue?vue&type=template&id=73813cc4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--6-1!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/panel-item.vue?vue&type=script&lang=ts&

/* harmony default export */ var panel_itemvue_type_script_lang_ts_ = ({
  name: 'PanelItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      show: true,
      showDetail: false,
      arrow: __webpack_require__(22)
    };
  },
  computed: {
    time: function time() {
      return dateFormat(this.item.timeStamp);
    }
  },
  methods: {
    toggleDetail: function toggleDetail() {
      this.showDetail = !this.showDetail;
    },
    toggle: function toggle() {
      this.show = !this.show;
    }
  }
});
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/panel-item.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_panel_itemvue_type_script_lang_ts_ = (panel_itemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./packages/domain-api/src/error-catcher/components/panel-item.vue?vue&type=style&index=0&lang=less&
var panel_itemvue_type_style_index_0_lang_less_ = __webpack_require__(23);

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/panel-item.vue






/* normalize component */

var panel_item_component = normalizeComponent(
  components_panel_itemvue_type_script_lang_ts_,
  panel_itemvue_type_template_id_73813cc4_render,
  panel_itemvue_type_template_id_73813cc4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var panel_item_api; }
panel_item_component.options.__file = "packages/domain-api/src/error-catcher/components/panel-item.vue"
/* harmony default export */ var panel_item = (panel_item_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/network.vue?vue&type=template&id=56cb58d6&
var networkvue_type_template_id_56cb58d6_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isClose
    ? _c("div", { staticClass: "cloudPivot-error-catcher-network" }, [
        _c("input", {
          staticClass: "error",
          attrs: { type: "button", value: "网络错误请求测试1" },
          on: { click: _vm.connect }
        }),
        _c("input", {
          staticClass: "error",
          attrs: { type: "button", value: "网络错误请求测试2" },
          on: { click: _vm.connectAPI }
        }),
        _c("input", {
          staticClass: "error",
          attrs: { type: "button", value: "前端错误测试" },
          on: { click: _vm.frontEndError }
        }),
        _c(
          "a",
          {
            staticClass: "cloudPivot-error-catcher-network-close",
            on: { click: _vm.close }
          },
          [_vm._v("X")]
        )
      ])
    : _vm._e()
}
var networkvue_type_template_id_56cb58d6_staticRenderFns = []
networkvue_type_template_id_56cb58d6_render._withStripped = true


// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/network.vue?vue&type=template&id=56cb58d6&

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(1);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--6-1!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/network.vue?vue&type=script&lang=ts&


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


/* harmony default export */ var networkvue_type_script_lang_ts_ = ({
  data: function data() {
    return {
      isClose: false
    };
  },
  methods: {
    mounted: function mounted() {
      console.log('mounted');
    },
    connect: function connect() {
      return _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config, index, options;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = [{
                  url: '/error-demo/',
                  method: 'GET'
                }, {
                  url: '/error-demo/',
                  method: 'GET',
                  data: {
                    name: 'hello'
                  }
                }, {
                  url: '/error-demo/',
                  method: 'GET',
                  headers: {
                    contentType: 'application/json'
                  },
                  data: {
                    name: 'hello'
                  }
                }, {
                  url: '/error-demo1/',
                  method: 'GET',
                  headers: {
                    contentType: 'application/json'
                  },
                  data: {
                    name: 'hello'
                  }
                }];
                index = parseInt((Math.random() * config.length).toString(), 10);
                options = config[index];
                _context.next = 5;
                return external_axios_default.a.request(options);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    connectAPI: function connectAPI() {
      return _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var options;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = {
                  url: '/api/console/error/biz'
                };
                _context2.next = 3;
                return external_axios_default.a.request(options);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    frontEndError: function frontEndError() {
      setTimeout(this.throwError, 0);
    },
    throwError: function throwError() {
      var types = ['Type Error', 'Exception'];
      var index = parseInt((Math.random() * types.length).toString(), 10);
      throw Error(types[index]);
    },
    close: function close() {
      this.isClose = true;
      this.$emit('networkBarClose');
    }
  }
});
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/network.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_networkvue_type_script_lang_ts_ = (networkvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./packages/domain-api/src/error-catcher/components/network.vue?vue&type=style&index=0&lang=less&
var networkvue_type_style_index_0_lang_less_ = __webpack_require__(25);

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/network.vue






/* normalize component */

var network_component = normalizeComponent(
  components_networkvue_type_script_lang_ts_,
  networkvue_type_template_id_56cb58d6_render,
  networkvue_type_template_id_56cb58d6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var network_api; }
network_component.options.__file = "packages/domain-api/src/error-catcher/components/network.vue"
/* harmony default export */ var network = (network_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--6-1!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/panel.vue?vue&type=script&lang=ts&


/* harmony default export */ var panelvue_type_script_lang_ts_ = ({
  name: 'Panel',
  components: {
    PanelItem: panel_item,
    Network: network
  },
  props: {
    errors: {
      type: Array,
      required: true,
      "default": function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      show: false,
      isChange: false,
      reachBottom: true,
      handScrolled: false,
      tabTop: 80,
      tabOY: 0,
      draging: true,
      networkBarVisible: true
    };
  },
  computed: {
    top: function top() {
      return this.tabTop + 'px';
    }
  },
  watch: {
    errors: function errors() {
      var _this = this;

      this.isChange = false;
      this.$nextTick(function () {
        if (!_this.handScrolled) {
          _this.scrollBottom();
        }

        _this.isChange = true;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.initTabTop();
    var container = this.$refs.container;
    var inner = this.$refs.inner;
    container.addEventListener('scroll', function () {
      var scrollTop = container.scrollTop;
      var target = inner.clientHeight - container.clientHeight;
      _this2.handScrolled = true;

      if (Math.abs(target - scrollTop) < 10) {
        _this2.reachBottom = true;
        _this2.handScrolled = false;
      }
    }, false);
  },
  methods: {
    initTabTop: function initTabTop() {
      var t = localStorage.getItem('tabTop');
      if (t) this.tabTop = Number(t);
    },
    clear: function clear() {
      this.$emit('clear');
      this.handScrolled = false;
    },
    networkBarClose: function networkBarClose() {
      this.networkBarVisible = false;
    },
    scrollBottom: function scrollBottom() {
      var container = this.$refs.container;
      var inner = this.$refs.inner;
      var target = inner.clientHeight - container.clientHeight;
      target = target < 0 ? 0 : target;
      var scrollTop = container.scrollTop;
      var y = target;
      var continueAnimation = Math.abs(target - scrollTop) > 10;

      if (continueAnimation) {
        y = scrollTop + (target - scrollTop) / 10;
      } // console.log('scrolling', y)


      container.scrollTo(0, y);

      if (continueAnimation) {
        requestAnimationFrame(this.scrollBottom);
      }
    },
    toggle: function toggle() {
      this.show = !this.show;
    },
    dragStart: function dragStart(e) {
      var img = new Image();
      img.src = __webpack_require__(26);
      img.style.opacity = '0';
      e.dataTransfer.setDragImage(img, 0, 0);
      e.dataTransfer.setData('text/plain', 1);
      this.draging = true;
    },
    drag: function drag(e) {
      var scrollTop = document.documentElement.scrollTop;
      var y = e.pageY - scrollTop;

      if (y !== 0) {
        this.tabTop = y - 60;
      }

      e.preventDefault();
    },
    dragEnd: function dragEnd() {
      this.draging = false;
      localStorage.setItem('tabTop', this.tabTop.toString());
    }
  }
});
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/panel.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_panelvue_type_script_lang_ts_ = (panelvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./packages/domain-api/src/error-catcher/components/panel.vue?vue&type=style&index=0&lang=less&
var panelvue_type_style_index_0_lang_less_ = __webpack_require__(27);

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/panel.vue






/* normalize component */

var panel_component = normalizeComponent(
  components_panelvue_type_script_lang_ts_,
  panelvue_type_template_id_5023b1ac_render,
  panelvue_type_template_id_5023b1ac_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var panel_api; }
panel_component.options.__file = "packages/domain-api/src/error-catcher/components/panel.vue"
/* harmony default export */ var panel = (panel_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/message-board.vue?vue&type=template&id=1bd80b48&
var message_boardvue_type_template_id_1bd80b48_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cloudPivot-error-catcher-board",
      class: [_vm.containerClass, _vm.theme.containerClass]
    },
    [
      _vm.closeable
        ? _c("span", {
            staticClass: "cloudPivot-error-catcher-board-close",
            on: { click: _vm.close }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "cloudPivot-error-catcher-board-title",
          class: [_vm.titleClass, _vm.theme.titleClass]
        },
        [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
      ),
      _c(
        "div",
        {
          staticClass: "cloudPivot-error-catcher-board-message",
          class: [_vm.messageContainerClass, _vm.theme.messageContainerClass]
        },
        _vm._l(_vm.message, function(item, index) {
          return _c(
            "div",
            {
              key: item + "_" + index,
              staticClass: "cloudPivot-error-catcher-board-message-item",
              class: [_vm.messageItemClass, _vm.theme.messageItemClass]
            },
            [_vm._v("\n      " + _vm._s(item) + "\n    ")]
          )
        }),
        0
      ),
      _vm._t("default", [
        _vm.correctGuide
          ? _c(
              "div",
              {
                staticClass: "cloudPivot-error-catcher-board-guide",
                class: [_vm.correctGuideClass, _vm.theme.guideClass]
              },
              [_vm._v("\n      " + _vm._s(_vm.correctGuide) + "\n    ")]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var message_boardvue_type_template_id_1bd80b48_staticRenderFns = []
message_boardvue_type_template_id_1bd80b48_render._withStripped = true


// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-board.vue?vue&type=template&id=1bd80b48&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--6-1!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/message-board.vue?vue&type=script&lang=ts&

/* harmony default export */ var message_boardvue_type_script_lang_ts_ = ({
  name: 'MessageBoard',
  props: {
    title: {
      type: String,
      required: true,
      "default": '错误'
    },
    message: {
      type: Array,
      required: true,
      "default": function _default() {
        return [];
      }
    },
    correctGuide: {
      type: String,
      "default": ''
    },
    containerClass: {
      type: String,
      "default": ''
    },
    titleClass: {
      type: String,
      "default": ''
    },
    messageContainerClass: {
      type: String,
      "default": ''
    },
    messageItemClass: {
      type: String,
      "default": ''
    },
    correctGuideClass: {
      type: String,
      "default": ''
    },
    closeable: {
      type: Boolean,
      "default": false
    },
    onClose: Function,
    autoHide: Boolean,
    theme: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.autoHide) {
      setTimeout(this.close, 3000);
    }

    this.$nextTick(function () {
      var _Vue$prototype$$error;

      _this.theme = ((_Vue$prototype$$error = external_vue_default.a.prototype.$errorcatcher.options.theme) === null || _Vue$prototype$$error === void 0 ? void 0 : _Vue$prototype$$error.board) || {};
    });
  },
  methods: {
    close: function close() {
      this.$emit('close');

      if (this.onClose) {
        this.onClose();
      }

      var node = this.$el;

      if (node) {
        var nodeParent = node.parentElement;

        if (nodeParent) {
          nodeParent.removeChild(node);
        }
      }

      this.$destroy();
    }
  }
});
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-board.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_message_boardvue_type_script_lang_ts_ = (message_boardvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./packages/domain-api/src/error-catcher/components/message-board.vue?vue&type=style&index=0&lang=less&
var message_boardvue_type_style_index_0_lang_less_ = __webpack_require__(28);

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-board.vue






/* normalize component */

var message_board_component = normalizeComponent(
  components_message_boardvue_type_script_lang_ts_,
  message_boardvue_type_template_id_1bd80b48_render,
  message_boardvue_type_template_id_1bd80b48_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var message_board_api; }
message_board_component.options.__file = "packages/domain-api/src/error-catcher/components/message-board.vue"
/* harmony default export */ var message_board = (message_board_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/message-popup.vue?vue&type=template&id=56db3a0e&
var message_popupvue_type_template_id_56db3a0e_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "new-cloudPivot-error-catcher-popup",
      on: { click: _vm.coverClick }
    },
    [
      _c(
        "div",
        {
          staticClass: "new-cloudPivot-error-catcher-popup-container",
          class: [_vm.theme.containerClass, _vm.containerClass]
        },
        [
          _c("span", {
            staticClass: "new-cloudPivot-error-catcher-popup-icon"
          }),
          !_vm.displayFooter
            ? _c("span", {
                staticClass: "new-cloudPivot-error-catcher-popup-close",
                class: [_vm.closeButtonClass, _vm.theme.titleClass],
                on: { click: _vm.close }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "new-cloudPivot-error-catcher-popup-title",
              class: [_vm.titleClass, _vm.theme.titleClass]
            },
            [_vm._v("\n      出错了! " + _vm._s(_vm.title) + "\n    ")]
          ),
          _vm._t("default", [
            _c(
              "div",
              {
                staticClass: "new-cloudPivot-error-catcher-popup-guide",
                class: [_vm.correctGuideClass, _vm.theme.correctGuideClass]
              },
              [
                _vm._v(
                  "\n        错误原因如下\n        " +
                    _vm._s(_vm.correctGuide ? ", " + _vm.correctGuide : "") +
                    "\n      "
                )
              ]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "new-cloudPivot-error-catcher-popup-message",
              class: [
                _vm.messageContainerClass,
                _vm.theme.messageContainerClass
              ]
            },
            _vm._l(_vm.message, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "new-cloudPivot-error-catcher-popup-message-item",
                  class: [_vm.messageItemClass, _vm.theme.messageItemClass]
                },
                [_vm._v("\n        " + _vm._s(item) + "\n      ")]
              )
            }),
            0
          ),
          _vm.displayFooter && !_vm.autoHide
            ? _c(
                "div",
                {
                  staticClass: "new-cloudPivot-error-catcher-popup-footer",
                  class: [_vm.footerClass, _vm.theme.footerClass]
                },
                [
                  _vm.cancelText !== ""
                    ? _c("input", {
                        staticClass: "new-cloudPivot-popup-btn-outline",
                        class: [
                          _vm.cancelButtonClass,
                          _vm.theme.cancelButtonClass
                        ],
                        attrs: { type: "button", value: _vm.cancelText },
                        on: { click: _vm.cancel }
                      })
                    : _vm._e(),
                  _vm.confirmText !== ""
                    ? _c("input", {
                        staticClass: "new-cloudPivot-popup-btn-success",
                        class: [
                          _vm.confirmButtonClass,
                          _vm.theme.confirmButtonClass
                        ],
                        attrs: { type: "button", value: _vm.confirmText },
                        on: { click: _vm.confirm }
                      })
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var message_popupvue_type_template_id_56db3a0e_staticRenderFns = []
message_popupvue_type_template_id_56db3a0e_render._withStripped = true


// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-popup.vue?vue&type=template&id=56db3a0e&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--6-1!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/message-popup.vue?vue&type=script&lang=ts&

/* harmony default export */ var message_popupvue_type_script_lang_ts_ = (external_vue_default.a.extend({
  name: 'MessagePopup',
  props: {
    title: {
      type: String,
      required: true,
      "default": '错误'
    },
    message: {
      type: Array,
      required: true,
      "default": function _default() {
        return [];
      }
    },
    correctGuide: {
      type: String,
      "default": ''
    },
    containerClass: {
      type: String,
      "default": ''
    },
    titleClass: {
      type: String,
      "default": ''
    },
    messageContainerClass: {
      type: String,
      "default": ''
    },
    messageItemClass: {
      type: String,
      "default": ''
    },
    correctGuideClass: {
      type: String,
      "default": ''
    },
    footerClass: {
      type: String,
      "default": ''
    },
    confirmButtonClass: {
      type: String,
      "default": ''
    },
    cancelButtonClass: {
      type: String,
      "default": ''
    },
    closeButtonClass: {
      type: String,
      "default": ''
    },
    displayFooter: {
      type: Boolean,
      "default": true
    },
    autoHide: {
      type: Boolean,
      "default": false
    },
    cancelText: {
      type: String,
      "default": ''
    },
    confirmText: {
      type: String,
      "default": '知道了'
    },
    onConfirm: Function,
    onCancel: Function,
    onClose: Function,
    theme: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.autoHide) {
      setTimeout(this.close, 3000);
    }

    this.$nextTick(function () {
      var _Vue$prototype$$error;

      _this.theme = ((_Vue$prototype$$error = external_vue_default.a.prototype.$errorcatcher.options.theme) === null || _Vue$prototype$$error === void 0 ? void 0 : _Vue$prototype$$error.popup) || {};
    });
  },
  methods: {
    confirm: function confirm() {
      this.onConfirm && this.onConfirm();
      this.close();
    },
    cancel: function cancel() {
      this.onCancel && this.onCancel();
      this.close();
    },
    close: function close(e) {
      e && e.stopPropagation();
      this.onClose && this.onClose();
      this.$emit('close'); // 不管是否有传入的销毁，自我销毁一遍

      var node = this.$el;

      if (node) {
        var nodeParent = node.parentElement;

        if (nodeParent) {
          nodeParent.removeChild(node);
        }
      }

      this.$destroy();
    },
    // 当黑色遮罩层点击，并且没有footer的时候可以关闭
    coverClick: function coverClick(e) {
      e && e.stopPropagation();

      if (!this.displayFooter) {
        this.close();
      }
    }
  }
}));
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-popup.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_message_popupvue_type_script_lang_ts_ = (message_popupvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./packages/domain-api/src/error-catcher/components/message-popup.vue?vue&type=style&index=0&lang=less&
var message_popupvue_type_style_index_0_lang_less_ = __webpack_require__(29);

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-popup.vue






/* normalize component */

var message_popup_component = normalizeComponent(
  components_message_popupvue_type_script_lang_ts_,
  message_popupvue_type_template_id_56db3a0e_render,
  message_popupvue_type_template_id_56db3a0e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var message_popup_api; }
message_popup_component.options.__file = "packages/domain-api/src/error-catcher/components/message-popup.vue"
/* harmony default export */ var message_popup = (message_popup_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/message-popup-custom.vue?vue&type=template&id=99e85d80&
var message_popup_customvue_type_template_id_99e85d80_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "new-cloudPivot-error-catcher-popup",
      on: { click: _vm.coverClick }
    },
    [
      _c(
        "div",
        {
          staticClass: "new-cloudPivot-error-catcher-popup-container",
          class: [_vm.theme.containerClass, _vm.containerClass]
        },
        [
          _c("span", { class: _vm.iconClass }),
          !_vm.displayFooter
            ? _c("span", {
                staticClass: "new-cloudPivot-error-catcher-popup-close",
                class: [_vm.closeButtonClass, _vm.theme.titleClass],
                on: { click: _vm.close }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "new-cloudPivot-error-catcher-popup-title",
              class: [_vm.titleClass, _vm.theme.titleClass]
            },
            [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
          ),
          _vm.message.length > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "new-cloudPivot-error-catcher-popup-message new-cloudPivot-error-catcher-popup-message-custom",
                  class: [
                    _vm.messageContainerClass,
                    _vm.theme.messageContainerClass
                  ]
                },
                _vm._l(_vm.message, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "new-cloudPivot-error-catcher-popup-message-item",
                      class: [_vm.messageItemClass, _vm.theme.messageItemClass]
                    },
                    [_vm._v("\n        " + _vm._s(item) + "\n      ")]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.displayFooter && !_vm.autoHide
            ? _c(
                "div",
                {
                  staticClass: "new-cloudPivot-error-catcher-popup-footer",
                  class: [_vm.footerClass, _vm.theme.footerClass]
                },
                [
                  _vm.cancelText !== ""
                    ? _c("input", {
                        staticClass: "new-cloudPivot-popup-btn-outline",
                        class: [
                          _vm.cancelButtonClass,
                          _vm.theme.cancelButtonClass
                        ],
                        attrs: { type: "button", value: _vm.cancelText },
                        on: { click: _vm.cancel }
                      })
                    : _vm._e(),
                  _vm.confirmText !== ""
                    ? _c("input", {
                        staticClass: "new-cloudPivot-popup-btn-success",
                        class: [
                          _vm.confirmButtonClass,
                          _vm.theme.confirmButtonClass
                        ],
                        attrs: { type: "button", value: _vm.confirmText },
                        on: { click: _vm.confirm }
                      })
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var message_popup_customvue_type_template_id_99e85d80_staticRenderFns = []
message_popup_customvue_type_template_id_99e85d80_render._withStripped = true


// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-popup-custom.vue?vue&type=template&id=99e85d80&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--6-1!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/message-popup-custom.vue?vue&type=script&lang=ts&

var type2IconClass = {
  error: 'new-cloudPivot-error-catcher-popup-icon',
  warning: 'new-cloudPivot-warning-catcher-popup-icon'
};
/* harmony default export */ var message_popup_customvue_type_script_lang_ts_ = (external_vue_default.a.extend({
  name: 'MessagePopupCustom',
  props: {
    title: {
      type: String,
      required: true,
      "default": '错误'
    },
    message: {
      type: Array,
      required: true,
      "default": function _default() {
        return ['系统出现错误, 请联系相关运维工程师解决问题'];
      }
    },
    type: {
      type: String,
      "default": 'error'
    },
    correctGuide: {
      type: String,
      "default": ''
    },
    containerClass: {
      type: String,
      "default": ''
    },
    titleClass: {
      type: String,
      "default": ''
    },
    messageContainerClass: {
      type: String,
      "default": ''
    },
    messageItemClass: {
      type: String,
      "default": ''
    },
    correctGuideClass: {
      type: String,
      "default": ''
    },
    footerClass: {
      type: String,
      "default": ''
    },
    confirmButtonClass: {
      type: String,
      "default": ''
    },
    cancelButtonClass: {
      type: String,
      "default": ''
    },
    closeButtonClass: {
      type: String,
      "default": ''
    },
    displayFooter: {
      type: Boolean,
      "default": true
    },
    autoHide: {
      type: Boolean,
      "default": false
    },
    cancelText: {
      type: String,
      "default": ''
    },
    confirmText: {
      type: String,
      "default": '知道了'
    },
    onConfirm: Function,
    onCancel: Function,
    onClose: Function,
    theme: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  computed: {
    isWarning: function isWarning() {
      return this.type === 'warning';
    },
    iconClass: function iconClass() {
      return type2IconClass[this.type];
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.autoHide) {
      setTimeout(this.close, 3000);
    }

    this.$nextTick(function () {
      var _Vue$prototype$$error;

      _this.theme = ((_Vue$prototype$$error = external_vue_default.a.prototype.$errorcatcher.options.theme) === null || _Vue$prototype$$error === void 0 ? void 0 : _Vue$prototype$$error.popup) || {};
    });
  },
  methods: {
    confirm: function confirm() {
      this.onConfirm && this.onConfirm();
      this.close();
    },
    cancel: function cancel() {
      this.onCancel && this.onCancel();
      this.close();
    },
    close: function close(e) {
      e && e.stopPropagation();
      this.onClose && this.onClose();
      this.$emit('close'); // 不管是否有传入的销毁，自我销毁一遍

      var node = this.$el;

      if (node) {
        var nodeParent = node.parentElement;

        if (nodeParent) {
          nodeParent.removeChild(node);
        }
      }

      this.$destroy();
    },
    // 当黑色遮罩层点击，并且没有footer的时候可以关闭
    coverClick: function coverClick(e) {
      e && e.stopPropagation();

      if (!this.displayFooter) {
        this.close();
      }
    }
  }
}));
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-popup-custom.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_message_popup_customvue_type_script_lang_ts_ = (message_popup_customvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./packages/domain-api/src/error-catcher/components/message-popup-custom.vue?vue&type=style&index=0&lang=less&
var message_popup_customvue_type_style_index_0_lang_less_ = __webpack_require__(30);

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/message-popup-custom.vue






/* normalize component */

var message_popup_custom_component = normalizeComponent(
  components_message_popup_customvue_type_script_lang_ts_,
  message_popup_customvue_type_template_id_99e85d80_render,
  message_popup_customvue_type_template_id_99e85d80_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var message_popup_custom_api; }
message_popup_custom_component.options.__file = "packages/domain-api/src/error-catcher/components/message-popup-custom.vue"
/* harmony default export */ var message_popup_custom = (message_popup_custom_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--6-1!./node_modules/vue-loader/lib??vue-loader-options!./packages/domain-api/src/error-catcher/components/main.vue?vue&type=script&lang=ts&
function mainvue_type_script_lang_ts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function mainvue_type_script_lang_ts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { mainvue_type_script_lang_ts_ownKeys(Object(source), true).forEach(function (key) { mainvue_type_script_lang_ts_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { mainvue_type_script_lang_ts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function mainvue_type_script_lang_ts_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








/* harmony default export */ var mainvue_type_script_lang_ts_ = ({
  name: 'ErrorCatcher',
  components: {
    Toast: components_toast,
    Panel: panel,
    MessageBoard: message_board
  },
  data: function data() {
    return {
      errs: [],
      captureErrors: [],
      duration: 3000,
      showPanel: false,
      showBoard: false,
      messageBoardOptions: null,
      messageBoard: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    external_vue_default.a.nextTick(function () {
      _this.showPanel = external_vue_default.a.prototype.$errorcatcher.options.dev;
    });
  },
  methods: {
    /**
     * 显示toast
     */
    show: function show(err) {
      var _this2 = this;

      var key = err.key;
      this.errs.push(err);
      var duration = err.options && err.options.duration || external_vue_default.a.prototype.$errorcatcher.options.duration || this.duration;
      var autoHide = err.options === undefined || err.options.autoHide || err.options.autoHide === undefined;

      if (autoHide) {
        setTimeout(function () {
          return _this2.remove(key);
        }, duration);
      }
    },

    /**
     * 根据key删除toast
     * @param key {string}
     */
    remove: function remove(key) {
      var index = this.errs.findIndex(function (item) {
        return item.key === key;
      });
      this.errs.splice(index, 1);
    },

    /**
     * 捕获错误（panel）
     * @param err
     */
    captureError: function captureError(err) {
      this.captureErrors.push(errorCodeAdapter(err));
    },

    /**
     * 清除捕获的错误
     */
    clearCaptureError: function clearCaptureError() {
      this.captureErrors = [];
    },

    /**
     * 显示MessageBoard
     */
    showMessageBoard: function showMessageBoard(options, mountNode) {
      // 有挂载node的
      if (mountNode) {
        var Component = external_vue_default.a.component(message_board.name, message_board);
        var instant = new Component({
          propsData: mainvue_type_script_lang_ts_objectSpread({}, options)
        }); // 创建组件挂载的DIV容器

        var parentNode = typeof mountNode === 'string' ? document.querySelector(mountNode) : mountNode;

        if (!parentNode) {
          throw new Error('mountNode传递不正确！可以为DOM的ID，也可以是DOM实例！');
        }

        var node = document.createElement('DIV');
        parentNode.innerHTML = '';
        parentNode.appendChild(node);
        instant.$mount(node);
        return instant.close; // () => this.destroyMessage(instant);
      } else {
        // 无挂载Node的
        this.showBoard = true;
        this.messageBoardOptions = options;
      }
    },

    /**
     * 显示MessagePopup
     */
    showMessagePopup: function showMessagePopup(options) {
      var Component = external_vue_default.a.component(message_popup.name, message_popup);
      var instant = new Component({
        propsData: mainvue_type_script_lang_ts_objectSpread({}, options)
      }); // 创建组件挂载的DIV容器

      var parentNode = this.$refs.popup;
      var node = document.createElement('DIV');
      parentNode.innerHTML = '';
      parentNode.appendChild(node);
      instant.$mount(node);
      return instant.close;
    },

    /**
     * 显示MessagePopupCustom
     */
    showMessagePopupCustom: function showMessagePopupCustom(options) {
      var Component = external_vue_default.a.component(message_popup_custom.name, message_popup_custom);
      var instant = new Component({
        propsData: mainvue_type_script_lang_ts_objectSpread({}, options)
      }); // 创建组件挂载的DIV容器

      var parentNode = this.$refs.popup;
      var node = document.createElement('DIV');
      parentNode.innerHTML = '';
      parentNode.appendChild(node);
      instant.$mount(node);
      return instant.close;
    }
  }
});
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/main.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_mainvue_type_script_lang_ts_ = (mainvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./packages/domain-api/src/error-catcher/components/main.vue?vue&type=style&index=0&lang=less&
var mainvue_type_style_index_0_lang_less_ = __webpack_require__(31);

// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/components/main.vue






/* normalize component */

var main_component = normalizeComponent(
  components_mainvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var main_api; }
main_component.options.__file = "packages/domain-api/src/error-catcher/components/main.vue"
/* harmony default export */ var main = (main_component.exports);
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/plugin.ts



var Instant;
var ErrorCatcherPlugin = {
  install: function install() {
    var _ref,
        _this = this;

    var ErrorCatcherComponent = external_vue_default.a.component(main.name, main);
    Instant = new ErrorCatcherComponent(); //

    external_vue_default.a.prototype.$errorcatcher = Instant;
    external_vue_default.a.prototype.$errorcatcher.options = (_ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref]);

    if (!Instant.$el) {
      Instant.success = function (msg) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this.toast('success', msg, options);
      };

      Instant.info = function (msg) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this.toast('info', msg, options);
      };

      Instant.warn = function (msg) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this.toast('warning', msg, options);
      };

      Instant.error = function (msg) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _this.toast('error', msg, options);
      };

      Instant.handlerError = this.handleError;
      var container = this.createDOM();

      if (container) {
        Instant.$mount(container);
      }
    }
  },
  getInstant: function getInstant() {
    return Instant;
  },
  createDOM: function createDOM() {
    // ssr环境不执行
    if (!(document && typeof window !== 'undefined')) {
      return null;
    }

    var body = document.getElementsByTagName('body')[0];
    var containerName = 'cloudPivot-error-container';
    var container = document.createElement('DIV');
    container.id = containerName;
    body.appendChild(container);
    return container;
  },
  toast: function toast(type, msg, options) {
    var config = {
      key: randomKey(),
      errmsg: msg,
      type: type,
      options: options || {},
      timeStamp: Date.now()
    };
    Instant.show(config);
  },
  handleError: function handleError(err, handlers) {
    var error = errorCodeAdapter(err.response || err);
    var combindHandlers = handlers; // 自定义处理

    if (handlers) {
      if (typeof handlers === 'function') {
        combindHandlers = [handlers];
      }

      for (var i = 0; i < combindHandlers.length; i++) {
        var handler = combindHandlers[i]; // 当自定义handler返回有true时，不使用本错误处理

        if (handler(error)) {
          external_vue_default.a.prototype.$errorcatcher.captureError(error);
          return Promise.reject(error);
        }
      }
    }

    var msg = error.errmsg;

    if (error.errcode && /\d/.test(error.errcode)) {
      msg = error.errcode + ': ' + msg;
    }

    if (error.correctGuide) {
      msg += ', ' + error.correctGuide;
    }

    external_vue_default.a.prototype.$errorcatcher.error(msg);
    external_vue_default.a.prototype.$errorcatcher.captureError(error);
    return Promise.reject(error);
  }
};
/* harmony default export */ var error_catcher_plugin = (ErrorCatcherPlugin);
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/main.ts
function main_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function main_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { main_ownKeys(Object(source), true).forEach(function (key) { main_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { main_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function main_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/**
 * window捕获异常
 * @param err
 * @param url
 * @param line
 * @param col
 * @param error
 */

function windowError(err, url, line, col, error) {
  var msg = '';

  if (!!error && !!error.stack) {
    // 如果浏览器有堆栈信息
    // 直接使用
    msg = error.stack.toString(); // eslint-disable-next-line
  } else if (arguments.callee) {
    // 尝试通过callee拿堆栈信息
    var ext = []; // eslint-disable-next-line

    var f = arguments.callee.caller;
    var c = 3; // 这里只拿三层堆栈信息

    while (f && --c > 0) {
      ext.push(f.toString());

      if (f === f.caller) {
        break; // 如果有环
      }

      f = f.caller;
    }

    msg = ext.join(',');
  }

  external_vue_default.a.prototype.$errorcatcher.captureError({
    key: randomKey(),
    errcode: error.message || '-',
    errmsg: msg,
    timeStamp: Date.now(),
    isAdapted: true
  });
  return err;
}

var created = false;
var theme = {};
/**
 * 初始化
 * @param options
 */

function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // 如果已经创建过了就不再创建
  if (external_vue_default.a.prototype.$errorCatcher || created) {
    return;
  }

  var _options$dev = options.dev,
      dev = _options$dev === void 0 ? undefined : _options$dev,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 3000 : _options$duration,
      _options$isRuntime = options.isRuntime,
      isRuntime = _options$isRuntime === void 0 ? false : _options$isRuntime;
  var isDev = dev;

  if (isDev === undefined) {
    var currentDev = external_vue_default.a.prototype.$errorcatcher && external_vue_default.a.prototype.$errorcatcher.options && external_vue_default.a.prototype.$errorcatcher.options.dev;
    var isProduction = false;

    try {
      isProduction = "production" === 'production';
    } catch (e) {
      isProduction = false;
    }

    isDev = currentDev !== undefined ? currentDev : !isProduction;
  }

  theme = options.theme || theme; // 注入插件

  external_vue_default.a.use(error_catcher_plugin, {
    dev: !!isDev,
    duration: duration,
    theme: theme,
    isRuntime: isRuntime
  });
  created = true; // window error监听

  window.onerror = windowError;

  external_vue_default.a.config.errorHandler = function (err, vm, info) {
    var error = errorCodeAdapter(err);
    console.log('vue error: ', error, err, vm, info);

    if (!error.errmsg) {
      error.errmsg = 'vue捕获异常: ' + info;
    } // 不需要该提示
    // Vue.prototype.$errorcatcher.captureError(error);
    // if (err.toString().indexOf('Network Error') !== -1) {
    //   Vue.prototype.$errorcatcher.showMessagePopup({
    //     title: '网络异常',
    //     message: [`请求：${error.responseURL}出错`, error.errmsg],
    //     correctGuide: '请检查网络状态！'
    //   });
    // }

  };
}

function hasDom() {
  var container = document.querySelector('.cloudPivot-error-container');

  if (container) {
    return true;
  }

  return false;
}

function isCreated() {
  if (created || hasDom()) {
    return true;
  }

  return created;
}

function setTheme(newTheme) {
  var instant = error_catcher_plugin.getInstant();
  instant.options.theme = main_objectSpread(main_objectSpread({}, theme), newTheme);
} // export const errorCodeAdapter = ECA;



/* harmony default export */ var error_catcher_main = ({
  setHostConfig: setHostConfig,
  isCreated: isCreated,
  create: create,
  errorCodeAdapter: errorCodeAdapter,
  getResponseByConfig: getResponseByConfig,
  dataAdapter: dataAdapter,
  setTheme: setTheme
});
// CONCATENATED MODULE: ./packages/domain-api/src/error-catcher/index.js
// import * as ErrorCatcher from './main';

var ErrorCatcher = {
  isCreated: isCreated,
  errorCodeAdapter: errorCodeAdapter,
  create: create,
  setHostConfig: setHostConfig,
  getResponseByConfig: getResponseByConfig,
  dataAdapter: dataAdapter,
  setTheme: setTheme
};

/* harmony default export */ var error_catcher = (ErrorCatcher);
// EXTERNAL MODULE: external "@cloudpivot-shared/utils/src/generate-id"
var generate_id_ = __webpack_require__(5);

// CONCATENATED MODULE: ./packages/domain-api/src/utils/sm4/index.js
var require;var require;/* eslint-disable */

/**
 * sm4加密
 */

/**
 * base64js
 */
var base64js = function () {
  var r, e, t;
  return function r(e, t, n) {
    function o(i, a) {
      if (!t[i]) {
        if (!e[i]) {
          var u = typeof require === 'function' && require;

          if (!a && u) {
            return require(i, !0);
          }

          if (f) {
            return f(i, !0);
          }

          var d = new Error("Cannot find module '" + i + "'");
          throw d.code = 'MODULE_NOT_FOUND', d;
        }

        var c = t[i] = {
          exports: {}
        };
        e[i][0].call(c.exports, function (r) {
          var t = e[i][1][r];
          return o(t || r);
        }, c, c.exports, r, e, t, n);
      }

      return t[i].exports;
    }

    var f = typeof require === 'function' && require;

    for (var i = 0; i < n.length; i++) {
      o(n[i]);
    }

    return o;
  }({
    '/': [function (r, e, t) {
      t.byteLength = c;
      t.toByteArray = v;
      t.fromByteArray = s;
      var n = [];
      var o = [];
      var f = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
      var i = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

      for (var a = 0, u = i.length; a < u; ++a) {
        n[a] = i[a];
        o[i.charCodeAt(a)] = a;
      }

      o['-'.charCodeAt(0)] = 62;
      o['_'.charCodeAt(0)] = 63;

      function d(r) {
        var e = r.length;

        if (e % 4 > 0) {
          throw new Error('Invalid string. Length must be a multiple of 4');
        }

        return r[e - 2] === '=' ? 2 : r[e - 1] === '=' ? 1 : 0;
      }

      function c(r) {
        return r.length * 3 / 4 - d(r);
      }

      function v(r) {
        var e, t, n, i, a;
        var u = r.length;
        i = d(r);
        a = new f(u * 3 / 4 - i);
        t = i > 0 ? u - 4 : u;
        var c = 0;

        for (e = 0; e < t; e += 4) {
          n = o[r.charCodeAt(e)] << 18 | o[r.charCodeAt(e + 1)] << 12 | o[r.charCodeAt(e + 2)] << 6 | o[r.charCodeAt(e + 3)];
          a[c++] = n >> 16 & 255;
          a[c++] = n >> 8 & 255;
          a[c++] = n & 255;
        }

        if (i === 2) {
          n = o[r.charCodeAt(e)] << 2 | o[r.charCodeAt(e + 1)] >> 4;
          a[c++] = n & 255;
        } else {
          if (i === 1) {
            n = o[r.charCodeAt(e)] << 10 | o[r.charCodeAt(e + 1)] << 4 | o[r.charCodeAt(e + 2)] >> 2;
            a[c++] = n >> 8 & 255;
            a[c++] = n & 255;
          }
        }

        return a;
      }

      function l(r) {
        return n[r >> 18 & 63] + n[r >> 12 & 63] + n[r >> 6 & 63] + n[r & 63];
      }

      function h(r, e, t) {
        var n;
        var o = [];

        for (var f = e; f < t; f += 3) {
          n = (r[f] << 16) + (r[f + 1] << 8) + r[f + 2];
          o.push(l(n));
        }

        return o.join('');
      }

      function s(r) {
        var e;
        var t = r.length;
        var o = t % 3;
        var f = '';
        var i = [];
        var a = 16383;

        for (var u = 0, d = t - o; u < d; u += a) {
          i.push(h(r, u, u + a > d ? d : u + a));
        }

        if (o === 1) {
          e = r[t - 1];
          f += n[e >> 2];
          f += n[e << 4 & 63];
          f += '==';
        } else {
          if (o === 2) {
            e = (r[t - 2] << 8) + r[t - 1];
            f += n[e >> 10];
            f += n[e >> 4 & 63];
            f += n[e << 2 & 63];
            f += '=';
          }
        }

        i.push(f);
        return i.join('');
      }
    }, {}]
  }, {}, [])('/');
}();
/**
 * 国密SM4加密算法
 * @author c.z.s
 * @email 70255403@qq.com
 * @company GDT-ZWZX-DEV-PT
 * @date 2018-07
 */


function SM4_Context() {
  this.mode = 1;
  this.isPadding = true;
  this.sk = new Array(32);
}

function SM4() {
  this.SM4_ENCRYPT = 1;
  this.SM4_DECRYPT = 0;
  var SboxTable = [0xd6, 0x90, 0xe9, 0xfe, 0xcc, 0xe1, 0x3d, 0xb7, 0x16, 0xb6, 0x14, 0xc2, 0x28, 0xfb, 0x2c, 0x05, 0x2b, 0x67, 0x9a, 0x76, 0x2a, 0xbe, 0x04, 0xc3, 0xaa, 0x44, 0x13, 0x26, 0x49, 0x86, 0x06, 0x99, 0x9c, 0x42, 0x50, 0xf4, 0x91, 0xef, 0x98, 0x7a, 0x33, 0x54, 0x0b, 0x43, 0xed, 0xcf, 0xac, 0x62, 0xe4, 0xb3, 0x1c, 0xa9, 0xc9, 0x08, 0xe8, 0x95, 0x80, 0xdf, 0x94, 0xfa, 0x75, 0x8f, 0x3f, 0xa6, 0x47, 0x07, 0xa7, 0xfc, 0xf3, 0x73, 0x17, 0xba, 0x83, 0x59, 0x3c, 0x19, 0xe6, 0x85, 0x4f, 0xa8, 0x68, 0x6b, 0x81, 0xb2, 0x71, 0x64, 0xda, 0x8b, 0xf8, 0xeb, 0x0f, 0x4b, 0x70, 0x56, 0x9d, 0x35, 0x1e, 0x24, 0x0e, 0x5e, 0x63, 0x58, 0xd1, 0xa2, 0x25, 0x22, 0x7c, 0x3b, 0x01, 0x21, 0x78, 0x87, 0xd4, 0x00, 0x46, 0x57, 0x9f, 0xd3, 0x27, 0x52, 0x4c, 0x36, 0x02, 0xe7, 0xa0, 0xc4, 0xc8, 0x9e, 0xea, 0xbf, 0x8a, 0xd2, 0x40, 0xc7, 0x38, 0xb5, 0xa3, 0xf7, 0xf2, 0xce, 0xf9, 0x61, 0x15, 0xa1, 0xe0, 0xae, 0x5d, 0xa4, 0x9b, 0x34, 0x1a, 0x55, 0xad, 0x93, 0x32, 0x30, 0xf5, 0x8c, 0xb1, 0xe3, 0x1d, 0xf6, 0xe2, 0x2e, 0x82, 0x66, 0xca, 0x60, 0xc0, 0x29, 0x23, 0xab, 0x0d, 0x53, 0x4e, 0x6f, 0xd5, 0xdb, 0x37, 0x45, 0xde, 0xfd, 0x8e, 0x2f, 0x03, 0xff, 0x6a, 0x72, 0x6d, 0x6c, 0x5b, 0x51, 0x8d, 0x1b, 0xaf, 0x92, 0xbb, 0xdd, 0xbc, 0x7f, 0x11, 0xd9, 0x5c, 0x41, 0x1f, 0x10, 0x5a, 0xd8, 0x0a, 0xc1, 0x31, 0x88, 0xa5, 0xcd, 0x7b, 0xbd, 0x2d, 0x74, 0xd0, 0x12, 0xb8, 0xe5, 0xb4, 0xb0, 0x89, 0x69, 0x97, 0x4a, 0x0c, 0x96, 0x77, 0x7e, 0x65, 0xb9, 0xf1, 0x09, 0xc5, 0x6e, 0xc6, 0x84, 0x18, 0xf0, 0x7d, 0xec, 0x3a, 0xdc, 0x4d, 0x20, 0x79, 0xee, 0x5f, 0x3e, 0xd7, 0xcb, 0x39, 0x48];
  var FK = [0xa3b1bac6, 0x56aa3350, 0x677d9197, 0xb27022dc];
  var CK = [0x00070e15, 0x1c232a31, 0x383f464d, 0x545b6269, 0x70777e85, 0x8c939aa1, 0xa8afb6bd, 0xc4cbd2d9, 0xe0e7eef5, 0xfc030a11, 0x181f262d, 0x343b4249, 0x50575e65, 0x6c737a81, 0x888f969d, 0xa4abb2b9, 0xc0c7ced5, 0xdce3eaf1, 0xf8ff060d, 0x141b2229, 0x30373e45, 0x4c535a61, 0x686f767d, 0x848b9299, 0xa0a7aeb5, 0xbcc3cad1, 0xd8dfe6ed, 0xf4fb0209, 0x10171e25, 0x2c333a41, 0x484f565d, 0x646b7279];

  this.GET_ULONG_BE = function (b, i) {
    return (b[i] & 0xff) << 24 | (b[i + 1] & 0xff) << 16 | (b[i + 2] & 0xff) << 8 | b[i + 3] & 0xff & 0xffffffff;
  };

  this.PUT_ULONG_BE = function (n, b, i) {
    var t1 = 0xff & n >> 24;
    var t2 = 0xff & n >> 16;
    var t3 = 0xff & n >> 8;
    var t4 = 0xff & n;
    b[i] = t1 > 128 ? t1 - 256 : t1;
    b[i + 1] = t2 > 128 ? t2 - 256 : t2;
    b[i + 2] = t3 > 128 ? t3 - 256 : t3;
    b[i + 3] = t4 > 128 ? t4 - 256 : t4;
  };

  this.SHL = function (x, n) {
    return (x & 0xffffffff) << n;
  };

  this.ROTL = function (x, n) {
    var s = this.SHL(x, n);
    var ss = x >> 32 - n;
    return this.SHL(x, n) | x >> 32 - n;
  };

  this.sm4Lt = function (ka) {
    var bb = 0;
    var c = 0;
    var a = new Array(4);
    var b = new Array(4);
    this.PUT_ULONG_BE(ka, a, 0);
    b[0] = this.sm4Sbox(a[0]);
    b[1] = this.sm4Sbox(a[1]);
    b[2] = this.sm4Sbox(a[2]);
    b[3] = this.sm4Sbox(a[3]);
    bb = this.GET_ULONG_BE(b, 0);
    c = bb ^ this.ROTL(bb, 2) ^ this.ROTL(bb, 10) ^ this.ROTL(bb, 18) ^ this.ROTL(bb, 24);
    return c;
  };

  this.sm4F = function (x0, x1, x2, x3, rk) {
    return x0 ^ this.sm4Lt(x1 ^ x2 ^ x3 ^ rk);
  };

  this.sm4CalciRK = function (ka) {
    var bb = 0;
    var rk = 0;
    var a = new Array(4);
    var b = new Array(4);
    this.PUT_ULONG_BE(ka, a, 0);
    b[0] = this.sm4Sbox(a[0]);
    b[1] = this.sm4Sbox(a[1]);
    b[2] = this.sm4Sbox(a[2]);
    b[3] = this.sm4Sbox(a[3]);
    bb = this.GET_ULONG_BE(b, 0);
    rk = bb ^ this.ROTL(bb, 13) ^ this.ROTL(bb, 23);
    return rk;
  };

  this.sm4Sbox = function (inch) {
    var i = inch & 0xff;
    var retVal = SboxTable[i];
    return retVal > 128 ? retVal - 256 : retVal;
  };

  this.sm4_setkey_enc = function (ctx, key) {
    if (ctx == null) {
      alert('ctx is null!');
      return false;
    }

    if (key == null || key.length != 16) {
      alert('key error!');
      return false;
    }

    ctx.mode = this.SM4_ENCRYPT;
    this.sm4_setkey(ctx.sk, key);
  }; // 生成解密密钥


  this.sm4_setkey_dec = function (ctx, key) {
    if (ctx == null) {
      Error('ctx is null!');
    }

    if (key == null || key.length != 16) {
      Error('key error!');
    }

    var i = 0;
    ctx.mode = 0;
    this.sm4_setkey(ctx.sk, key);
    ctx.sk = ctx.sk.reverse();
  };

  this.sm4_setkey = function (SK, key) {
    var MK = new Array(4);
    var k = new Array(36);
    var i = 0;
    MK[0] = this.GET_ULONG_BE(key, 0);
    MK[1] = this.GET_ULONG_BE(key, 4);
    MK[2] = this.GET_ULONG_BE(key, 8);
    MK[3] = this.GET_ULONG_BE(key, 12);
    k[0] = MK[0] ^ FK[0];
    k[1] = MK[1] ^ FK[1];
    k[2] = MK[2] ^ FK[2];
    k[3] = MK[3] ^ FK[3];

    for (var i = 0; i < 32; i++) {
      k[i + 4] = k[i] ^ this.sm4CalciRK(k[i + 1] ^ k[i + 2] ^ k[i + 3] ^ CK[i]);
      SK[i] = k[i + 4];
    }
  };

  this.padding = function (input, mode) {
    if (input == null) {
      return null;
    }

    var ret = null;

    if (mode == this.SM4_ENCRYPT) {
      var p = parseInt(16 - input.length % 16);
      ret = input.slice(0);

      for (var i = 0; i < p; i++) {
        ret[input.length + i] = p;
      }
    } else {
      var p = input[input.length - 1];
      ret = input.slice(0, input.length - p);
    }

    return ret;
  };

  this.sm4_one_round = function (sk, input, output) {
    var i = 0;
    var ulbuf = new Array(36);
    ulbuf[0] = this.GET_ULONG_BE(input, 0);
    ulbuf[1] = this.GET_ULONG_BE(input, 4);
    ulbuf[2] = this.GET_ULONG_BE(input, 8);
    ulbuf[3] = this.GET_ULONG_BE(input, 12);

    while (i < 32) {
      ulbuf[i + 4] = this.sm4F(ulbuf[i], ulbuf[i + 1], ulbuf[i + 2], ulbuf[i + 3], sk[i]);
      i++;
    }

    this.PUT_ULONG_BE(ulbuf[35], output, 0);
    this.PUT_ULONG_BE(ulbuf[34], output, 4);
    this.PUT_ULONG_BE(ulbuf[33], output, 8);
    this.PUT_ULONG_BE(ulbuf[32], output, 12);
  };

  this.sm4_crypt_ecb = function (ctx, input) {
    if (input == null) {
      alert('input is null!');
    }

    if (ctx.isPadding && ctx.mode == this.SM4_ENCRYPT) {
      input = this.padding(input, this.SM4_ENCRYPT);
    }

    var i = 0;
    var length = input.length;
    var bous = new Array();

    for (; length > 0; length -= 16) {
      var out = new Array(16);
      var ins = input.slice(i * 16, 16 * (i + 1));
      this.sm4_one_round(ctx.sk, ins, out);
      bous = bous.concat(out);
      i++;
    }

    var output = bous;

    if (ctx.isPadding && ctx.mode == this.SM4_DECRYPT) {
      output = this.padding(output, this.SM4_DECRYPT);
    }

    for (var i = 0; i < output.length; i++) {
      if (output[i] < 0) {
        output[i] = output[i] + 256;
      }
    }

    return output;
  };

  this.sm4_crypt_cbc = function (ctx, iv, input) {
    if (iv == null || iv.length != 16) {
      alert('iv error!');
    }

    if (input == null) {
      alert('input is null!');
    }

    if (ctx.isPadding && ctx.mode == this.SM4_ENCRYPT) {
      input = this.padding(input, this.SM4_ENCRYPT);
    }

    var i = 0;
    var length = input.length;
    var bous = new Array();

    if (ctx.mode == this.SM4_ENCRYPT) {
      var k = 0;

      for (; length > 0; length -= 16) {
        var out = new Array(16);
        var out1 = new Array(16);
        var ins = input.slice(k * 16, 16 * (k + 1));

        for (i = 0; i < 16; i++) {
          out[i] = ins[i] ^ iv[i];
        }

        this.sm4_one_round(ctx.sk, out, out1);
        iv = out1.slice(0, 16);
        bous = bous.concat(out1);
        k++;
      }
    } else {
      var temp = [];
      var k = 0;

      for (; length > 0; length -= 16) {
        var out = new Array(16);
        var out1 = new Array(16);
        var ins = input.slice(k * 16, 16 * (k + 1));
        temp = ins.slice(0, 16);
        sm4_one_round(ctx.sk, ins, out);

        for (i = 0; i < 16; i++) {
          out1[i] = out[i] ^ iv[i];
        }

        iv = temp.slice(0, 16);
        bous = bous.concat(out1);
        k++;
      }
    }

    var output = bous;

    if (ctx.isPadding && ctx.mode == this.SM4_DECRYPT) {
      output = this.padding(output, this.SM4_DECRYPT);
    }

    for (var i = 0; i < output.length; i++) {
      if (output[i] < 0) {
        output[i] = output[i] + 256;
      }
    }

    return output;
  };
}

function SM4Util() {
  this.secretKey = '';
  this.iv = '';
  this.hexString = false;

  this.setSecretKey = function (key) {
    this.secretKey = key;
  };

  this.encryptData_ECB = function (plainText) {
    try {
      var sm4 = new SM4();
      var ctx = new SM4_Context();
      ctx.isPadding = true;
      ctx.mode = sm4.SM4_ENCRYPT;
      var keyBytes = stringToByte(this.secretKey);
      sm4.sm4_setkey_enc(ctx, keyBytes);
      var encrypted = sm4.sm4_crypt_ecb(ctx, stringToByte(plainText));
      var cipherText = base64js.fromByteArray(encrypted);

      if (cipherText != null && cipherText.trim().length > 0) {
        cipherText.replace(/(\s*|\t|\r|\n)/g, '');
      }

      return cipherText;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  this.decryptData_ECB = function (cipherText) {
    // let serkey = "11HDESAAHIHHUGDZ"
    try {
      var sm4 = new SM4();
      var ctx = new SM4_Context();
      ctx.isPadding = true;
      ctx.mode = sm4.SM4_ENCRYPT;
      var keyBytes = stringToByte(this.secretKey); // sm4_setkey_dec(ctx, keyBytes);

      sm4.sm4_setkey_dec(ctx, keyBytes);
      var decrypted = sm4.sm4_crypt_ecb(ctx, base64js.toByteArray(cipherText));
      return byteToString(decrypted);
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  this.encryptData_CBC = function (plainText) {
    try {
      var sm4 = new SM4();
      var ctx = new SM4_Context();
      ctx.isPadding = true;
      ctx.mode = sm4.SM4_ENCRYPT;
      var keyBytes = stringToByte(this.secretKey);
      var ivBytes = stringToByte(this.iv);
      sm4.sm4_setkey_enc(ctx, keyBytes);
      var encrypted = sm4.sm4_crypt_cbc(ctx, ivBytes, stringToByte(plainText));
      var cipherText = base64js.fromByteArray(encrypted);

      if (cipherText != null && cipherText.trim().length > 0) {
        cipherText.replace(/(\s*|\t|\r|\n)/g, '');
      }

      return cipherText;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  function stringToByte(str) {
    var bytes = new Array();
    var len, c;
    len = str.length;

    for (var i = 0; i < len; i++) {
      c = str.charCodeAt(i);

      if (c >= 0x010000 && c <= 0x10ffff) {
        bytes.push(c >> 18 & 0x07 | 0xf0);
        bytes.push(c >> 12 & 0x3f | 0x80);
        bytes.push(c >> 6 & 0x3f | 0x80);
        bytes.push(c & 0x3f | 0x80);
      } else if (c >= 0x000800 && c <= 0x00ffff) {
        bytes.push(c >> 12 & 0x0f | 0xe0);
        bytes.push(c >> 6 & 0x3f | 0x80);
        bytes.push(c & 0x3f | 0x80);
      } else if (c >= 0x000080 && c <= 0x0007ff) {
        bytes.push(c >> 6 & 0x1f | 0xc0);
        bytes.push(c & 0x3f | 0x80);
      } else {
        bytes.push(c & 0xff);
      }
    }

    return bytes;
  }

  function byteToString(arr) {
    if (typeof arr === 'string') {
      return arr;
    }

    var str = '';
    var _arr = arr;

    for (var i = 0; i < _arr.length; i++) {
      var one = _arr[i].toString(2);

      var v = one.match(/^1+?(?=0)/);

      if (v && one.length == 8) {
        var bytesLength = v[0].length;

        var store = _arr[i].toString(2).slice(7 - bytesLength);

        for (var st = 1; st < bytesLength; st++) {
          store += _arr[st + i].toString(2).slice(2);
        }

        str += String.fromCharCode(parseInt(store, 2));
        i += bytesLength - 1;
      } else {
        str += String.fromCharCode(_arr[i]);
      }
    }

    return str;
  }
}

var s4 = new SM4Util();
s4.iv = ''; // 加密

function sm4_encrypt(data) {
  return s4.encryptData_ECB(data);
} // 解密

function decrypt(data) {
  return s4.decryptData_ECB(data);
}
function setSM4Key(key) {
  return s4.setSecretKey(key);
}
// CONCATENATED MODULE: ./packages/domain-api/src/core/encrypt.ts
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var sm2 = __webpack_require__(32);

var encrypt_Encrypt = /*#__PURE__*/function () {
  function Encrypt() {
    _classCallCheck(this, Encrypt);

    this.status = 'NONE';
    this.inited = false;
    this.enabled = false;
    this.sessionId = '';
    this.sm2PublicKey = '';
    this.sm2PrivateKey = '';
    this.cipherMode = 1; // 1 - C1C3C2，0 - C1C2C3，默认为1

    this.sm4Key = '';
    this.sm4Options = {};
    this.type = 'sm2'; // 'sm2' | 'sm4',
  }

  _createClass(Encrypt, [{
    key: "setConfig",
    value: function setConfig(config) {
      var _this = this;

      Object.keys(config).forEach(function (key) {
        _this[key] = config[key];
      });
    }
  }, {
    key: "getConfig",
    value: function getConfig(key) {
      if (key) {
        return this[key];
      } else {
        return {
          inited: this.inited,
          enabled: this.enabled,
          sessionId: this.sessionId,
          sm2PublicKey: this.sm2PublicKey,
          sm2privateKey: this.sm2PrivateKey,
          cipherMode: this.cipherMode,
          sm4Key: this.sm4Key,
          sm4Options: this.sm4Options,
          type: this.type
        };
      }
    }
    /**
     * 创建sessionId
     */

  }, {
    key: "createSessionId",
    value: function createSessionId(length) {
      this.sessionId = Object(generate_id_["uuid"])(length || 32);
      return this.sessionId;
    }
    /**
     * 获取sessionId, 如果没有，则创建一个
     */

  }, {
    key: "getSessionId",
    value: function getSessionId() {
      if (!this.sessionId) {
        this.createSessionId();
      }

      return this.sessionId;
    }
  }, {
    key: "createSM4Key",
    value: function createSM4Key() {
      this.sm4Key = Object(generate_id_["uuid"])(16);
      setSM4Key(this.sm4Key);
      return this.sm4Key;
    }
    /**
     * 加密
     * @param data
     * @param type
     * @param options
     */

  }, {
    key: "encrypt",
    value: function encrypt(data, type) {
      var encryptData = typeof data !== 'string' ? JSON.stringify(data) : data;
      var encryptType = type || this.type;

      if (encryptType === 'sm2') {
        return this.encryptSM2(encryptData);
      }

      return sm4_encrypt(encryptData);
    }
  }, {
    key: "encryptSM2",
    value: function encryptSM2(data) {
      var str = typeof data !== 'string' ? JSON.stringify(data) : data;
      return sm2.doEncrypt(str, this.sm2PublicKey, this.cipherMode);
    }
  }, {
    key: "encryptSM4",
    value: function encryptSM4(data) {
      var str = typeof data !== 'string' ? JSON.stringify(data) : data;
      return sm4_encrypt(str);
    }
    /**
     * 解密
     * @param data
     * @param type
     * @param options
     */

  }, {
    key: "decrypt",
    value: function decrypt(data, type) {
      var encryptType = type || this.type;

      if (encryptType === 'sm2') {
        return this.decryptSM2(data);
      }

      return this.decryptSM4(data);
    }
  }, {
    key: "decryptSM2",
    value: function decryptSM2(data) {
      if (!this.sm2PrivateKey) {
        console.error('sm2PrivateKey is empty!');
        return;
      }

      return sm2.doDecrypt(data, this.sm2PrivateKey, this.cipherMode);
    }
  }, {
    key: "decryptSM4",
    value: function decryptSM4(data) {
      return decrypt(data);
    }
  }]);

  return Encrypt;
}();


// CONCATENATED MODULE: ./packages/domain-api/src/interceptors/encrypt-api.ts
var encrypt_api_api = {
  config: '/api/sm4/security/get/switch/config',
  sm2: '/api/sm4/security/generate/sm2/public_key',
  sm4: '/api/sm4/security/record/sm4/secret'
};
// CONCATENATED MODULE: ./packages/domain-api/src/core/request.ts


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function request_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function request_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { request_ownKeys(Object(source), true).forEach(function (key) { request_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { request_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function request_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function request_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function request_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { request_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { request_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function request_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function request_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function request_createClass(Constructor, protoProps, staticProps) { if (protoProps) request_defineProperties(Constructor.prototype, protoProps); if (staticProps) request_defineProperties(Constructor, staticProps); return Constructor; }


 // const ConfigRequest: any = axios.create();

var encryptConfigApi = Object.keys(encrypt_api_api).map(function (key) {
  return encrypt_api_api[key];
});
/**
 * Request类
 */

var request_Request = /*#__PURE__*/function () {
  /**
   * 构造函数，初始化
   * @param config
   */
  function Request(config) {
    var _this = this;

    request_classCallCheck(this, Request);

    this.HOST = {
      status: 'none',
      value: ''
    };
    this.hostConfig = null;
    this.requestFn = null;
    this.logger = false;
    this.ignoreNormalStatusUrl = [];
    this.interceptorsFn = {
      request: [],
      requestError: [],
      response: [],
      responseError: []
    };
    this.MOCK_CONFIG = null;
    this.MOCK_CONFIG_EXTEND = null;
    this.MOCK_MODE = false;
    this.responseData = {
      correctGuid: null,
      data: null,
      errCode: null,
      errKey: null,
      errMessage: null,
      success: true,
      timestamp: null,
      traceId: null
    };
    this.encryptInstant = new encrypt_Encrypt();
    /**
     * 拦截器方法对象
     */

    this.interceptors = {
      request: function () {
        var _request = request_asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee(config) {
          var newConfig, request, i, item, returnValue;
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (_this.logger) {
                    console.log('%cBefore request:', 'color:#fff;background:#5265c6;padding: 0 2px;border-radius:4px;', config);
                  }

                  newConfig = request_objectSpread({}, config); // 自定义拦截

                  request = _this.interceptorsFn.request;
                  i = 0;

                case 4:
                  if (!(i < request.length)) {
                    _context.next = 15;
                    break;
                  }

                  item = request[i];
                  _context.next = 8;
                  return item(newConfig);

                case 8:
                  returnValue = _context.sent;

                  if (!(returnValue === true)) {
                    _context.next = 11;
                    break;
                  }

                  return _context.abrupt("break", 15);

                case 11:
                  if (returnValue) newConfig = returnValue;

                case 12:
                  i++;
                  _context.next = 4;
                  break;

                case 15:
                  _context.next = 17;
                  return _this.beforeRequest(newConfig);

                case 17:
                  newConfig = _context.sent;
                  return _context.abrupt("return", newConfig);

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function request(_x) {
          return _request.apply(this, arguments);
        }

        return request;
      }(),
      requestError: function () {
        var _requestError = request_asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee2(error) {
          var newError, requestError, i, item, returnValue;
          return regenerator_default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  newError = null;
                  requestError = _this.interceptorsFn.requestError;
                  i = 0;

                case 3:
                  if (!(i < requestError.length)) {
                    _context2.next = 14;
                    break;
                  }

                  item = requestError[i];
                  _context2.next = 7;
                  return item(newError || error);

                case 7:
                  returnValue = _context2.sent;

                  if (!(returnValue === true)) {
                    _context2.next = 10;
                    break;
                  }

                  return _context2.abrupt("break", 14);

                case 10:
                  if (returnValue) newError = returnValue;

                case 11:
                  i++;
                  _context2.next = 3;
                  break;

                case 14:
                  return _context2.abrupt("return", Promise.reject(newError || error));

                case 15:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function requestError(_x2) {
          return _requestError.apply(this, arguments);
        }

        return requestError;
      }(),
      response: function () {
        var _response = request_asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee3(res) {
          var _res$config, _res$config2;

          var url, newRes, response, i, item, returnValue;
          return regenerator_default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (_this.logger) {
                    console.log('%cAfter request: ', 'color:#fff;background:#76c652;padding:0 2px;border-radius:4px;', res);
                  }

                  url = ((_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) + '#' + ((_res$config2 = res.config) === null || _res$config2 === void 0 ? void 0 : _res$config2.method);
                  newRes = request_objectSpread({}, res);

                  if (!_this.ignoreNormalStatusUrl.includes(url)) {
                    _context3.next = 5;
                    break;
                  }

                  return _context3.abrupt("return", newRes);

                case 5:
                  // 解密处理
                  newRes = _this.afterResponse(newRes);
                  response = _this.interceptorsFn.response;
                  i = 0;

                case 8:
                  if (!(i < response.length)) {
                    _context3.next = 19;
                    break;
                  }

                  item = response[i];
                  _context3.next = 12;
                  return item(newRes);

                case 12:
                  returnValue = _context3.sent;

                  if (!(returnValue === true)) {
                    _context3.next = 15;
                    break;
                  }

                  return _context3.abrupt("break", 19);

                case 15:
                  if (returnValue) newRes = returnValue;

                case 16:
                  i++;
                  _context3.next = 8;
                  break;

                case 19:
                  return _context3.abrupt("return", newRes);

                case 20:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function response(_x3) {
          return _response.apply(this, arguments);
        }

        return response;
      }(),
      responseError: function () {
        var _responseError = request_asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee4(error) {
          var newError, responseError, i, item, returnValue;
          return regenerator_default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  newError = null;
                  responseError = _this.interceptorsFn.responseError;
                  console.log('res', error); // if ((error as any)?.config?.url === encryptConfigApi[0]) {
                  //   return Promise.reject(error);
                  // }

                  i = 0;

                case 4:
                  if (!(i < responseError.length)) {
                    _context4.next = 15;
                    break;
                  }

                  item = responseError[i];
                  _context4.next = 8;
                  return item(newError || error);

                case 8:
                  returnValue = _context4.sent;

                  if (!(returnValue !== false)) {
                    _context4.next = 11;
                    break;
                  }

                  return _context4.abrupt("break", 15);

                case 11:
                  if (returnValue) newError = returnValue;

                case 12:
                  i++;
                  _context4.next = 4;
                  break;

                case 15:
                  return _context4.abrupt("return", Promise.reject(newError || error));

                case 16:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function responseError(_x4) {
          return _responseError.apply(this, arguments);
        }

        return responseError;
      }()
    };
    this.id = 0;
    if (config) this.init(config);
    this.id = Math.round(Math.random() * 1000);
  }
  /**
   * 初始化
   * @param config
   */


  request_createClass(Request, [{
    key: "init",
    value: function init(config) {
      var requestFn = config.requestFn,
          requestInterceptorFn = config.requestInterceptorFn,
          responseInterceptorFn = config.responseInterceptorFn,
          logger = config.logger;
      if (typeof logger === 'boolean') this.logger = logger; // 设置请求方法

      this.setRequestFn(requestFn); // 设置拦截器

      this.setInterceptors(requestInterceptorFn, responseInterceptorFn);
    }
  }, {
    key: "useLogger",
    value: function useLogger() {
      this.logger = true;
    }
    /**
     * 设置请求方法
     * @param fn
     */

  }, {
    key: "setRequestFn",
    value: function setRequestFn(fn) {
      this.requestFn = fn;
    }
    /**
     * 请求方法
     * @param options
     */

  }, {
    key: "request",
    value: function () {
      var _request2 = request_asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee5(options) {
        var _this2 = this;

        var ignoreNormalStatus,
            mock,
            mockExtend,
            combinedOptions,
            result,
            url,
            _args5 = arguments;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ignoreNormalStatus = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;

                if (this.requestFn) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  reject(new Error('请求方法尚未定义，请使用init()进行定义!'));
                }));

              case 3:
                mock = this.MOCK_CONFIG;
                mockExtend = this.MOCK_CONFIG_EXTEND;
                this.resetMock(); // 获取配置

                _context5.next = 8;
                return this.getHostConfig();

              case 8:
                // 合并请求头
                combinedOptions = this.combineOptions(options);

                if (!this.canMock()) {
                  _context5.next = 15;
                  break;
                }

                if (typeof mock === 'string' && !mockExtend) {
                  combinedOptions.url = mock;
                }

                if (!(mock && _typeof(mock) === 'object' || mockExtend)) {
                  _context5.next = 15;
                  break;
                }

                result = request_objectSpread(request_objectSpread({}, this.responseData), {}, {
                  data: mock
                });

                if (mockExtend) {
                  result = request_objectSpread(request_objectSpread(request_objectSpread({}, result), mockExtend), {}, {
                    success: false
                  });
                }

                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  if (mockExtend) {
                    var errorRes = request_objectSpread(request_objectSpread(request_objectSpread({}, result.data), result), {}, {
                      status: 200,
                      data: request_objectSpread(request_objectSpread(request_objectSpread({}, result.data), result), {}, {
                        status: 200,
                        timestamp: Date.now()
                      })
                    });

                    _this2.interceptors.response(errorRes);

                    reject(result);
                  }

                  resolve(result);
                }));

              case 15:
                if (ignoreNormalStatus) {
                  url = options.url + '#' + options.method;

                  if (!this.ignoreNormalStatusUrl.includes(url)) {
                    this.ignoreNormalStatusUrl.push(url);
                  }
                }

                return _context5.abrupt("return", this.requestFn(combinedOptions));

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function request(_x5) {
        return _request2.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "utilEncryptStatusDONE",
    value: function utilEncryptStatusDONE() {
      var _this3 = this;

      return new Promise(function (resolve) {
        var checkStatus = function checkStatus() {
          if (_this3.encryptInstant.status === 'DONE') {
            resolve('DONE');
          } else {
            setTimeout(checkStatus, 200);
          }
        };

        checkStatus();
      });
    }
    /**
     * 请求拦截器，对加密进行处理 ：： 执行顺序在其他拦截器之后
     * @param config
     */

  }, {
    key: "beforeRequest",
    value: function () {
      var _beforeRequest = request_asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee6(config) {
        var _config$headers;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!((_config$headers = config.headers) === null || _config$headers === void 0 ? void 0 : _config$headers.disabledEncrypt)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", config);

              case 2:
                if (!(this.encryptInstant.status === 'PENDING' && !encryptConfigApi.includes(config.url))) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 5;
                return this.utilEncryptStatusDONE();

              case 5:
                if (this.encryptInstant.enabled) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", config);

              case 7:
                config.headers = request_objectSpread(request_objectSpread({}, config.headers || {}), {}, {
                  sid: this.encryptInstant.getSessionId()
                }); // @todo 有待验证....
                // 对URL加密, (有可能多余的，因为params还没解析)
                // config.url = this.encryptURL(config.url);
                // // 对参数加密
                // if (config.params) {
                //   const params = {};
                //   Object.keys(config.params).forEach(key => {
                //     params[key] = this.encryptInstant.encryptSM4(config.params[key]);
                //   });
                //   config.params = params;
                // }

                if (config.url.indexOf('v1/print/tpl/list') !== -1) {
                  console.log('tpl....');
                } // 对数据加密


                if (config.data) {
                  config.data = {
                    data: this.encryptInstant.encryptSM4(config.data)
                  };
                }

                if (this.logger) {
                  console.log('%cEncrypted request config:', 'color: #002bc9;font-weight:bold;', config); // console.log('encrypted before request:', config);
                }

                return _context6.abrupt("return", config);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function beforeRequest(_x6) {
        return _beforeRequest.apply(this, arguments);
      }

      return beforeRequest;
    }()
    /**
     * 还原解密，当密钥过期时
     * @param requestConfig
     */

  }, {
    key: "decryptRequest",
    value: function decryptRequest(requestConfig) {
      var _requestConfig$header;

      if (!this.encryptInstant.enabled) return requestConfig;
      if ((_requestConfig$header = requestConfig.headers) === null || _requestConfig$header === void 0 ? void 0 : _requestConfig$header.disabledEncrypt) return requestConfig;
      requestConfig.url = this.decryptURL(requestConfig.url);
      var data = requestConfig.data;

      if (data && data[0] === '{' && data[data.length - 1] === '}') {
        data = JSON.parse(data);
        data = this.encryptInstant.decryptSM4(data.data);
      }

      if (data && data[0] === '{' && data[data.length - 1] === '}') {
        data = JSON.parse(data);
      }

      requestConfig.data = data;
      return requestConfig;
    }
    /**
     * 请求拦截器，对返回数据加密进行处理 ：： 执行顺序在其他拦截器之前
     * @param config
     */

  }, {
    key: "afterResponse",
    value: function afterResponse(res) {
      var _res$config$headers;

      if (!this.encryptInstant.enabled) return res;
      if ((_res$config$headers = res.config.headers) === null || _res$config$headers === void 0 ? void 0 : _res$config$headers.disabledEncrypt) return res;

      if (res.data.data) {
        try {
          var data = this.encryptInstant.decryptSM4(res.data.data);
          res.data.data = data;

          if (data && typeof data === 'string') {
            if (data[0] === '{' && data[data.length - 1] === '}' || data[0] === '[' && data[data.length - 1] === ']') {
              res.data.data = JSON.parse(data);
            } // 特殊处理 “http://....”这种带双引号字符


            if (data[0] === '"' && data[data.length - 1] === '"') {
              res.data.data = data.substr(1, data.length - 2);
            }
          }
        } catch (e) {
          console.error(e);
        }

        if (this.logger) {
          console.log('%cDecrypted response data:', 'color: #3dc900;font-weight:bold;', res.config, res.data.data);
        }
      }

      return res;
    }
    /**
     * 对url的params进行加密
     * @param url
     */

  }, {
    key: "encryptURL",
    value: function encryptURL(url) {
      var _this4 = this;

      var splitURL = url.split('?');

      if (!splitURL || splitURL.length <= 1) {
        return url;
      }

      var query = splitURL[1].match(/([^=?&]+)=([^&]*)/gi);
      var params = '';
      query.forEach(function (q) {
        var a = q.split('=');

        var value = _this4.encryptInstant.encrypt(a[1]);

        params += params === '' ? '' : '&';
        params += "".concat(a[0], "=").concat(value);
      });
      return splitURL[0] + '?' + params;
    }
    /**
     * url解密
     * @param url
     */

  }, {
    key: "decryptURL",
    value: function decryptURL(url) {
      var _this5 = this;

      var splitURL = url.split('?');

      if (!splitURL || splitURL.length <= 1) {
        return url;
      }

      var query = splitURL[1].match(/([^=?&]+)=([^&]*)/gi);
      var params = '';
      query.forEach(function (q) {
        var a = q.split('=');

        var value = _this5.encryptInstant.decrypt(a[1]);

        params += params === '' ? '' : '&';
        params += "".concat(a[0], "=").concat(value);
      });
      return splitURL[0] + '?' + params;
    }
    /**
     * 用配置host替换url
     * @param options
     */

  }, {
    key: "combineOptions",
    value: function combineOptions(options) {
      var url = options.url,
          rest = _objectWithoutProperties(options, ["url"]);

      var newURL = this.HOST.value + url;

      if (this.HOST.value.substring(this.HOST.value.length - 1) === '/' && url.substring(0, 1) === '/') {
        newURL = this.HOST + url.substring(1);
      }

      return request_objectSpread({
        url: newURL
      }, rest);
    }
  }, {
    key: "untilHostConfigIsDone",
    value: function untilHostConfigIsDone() {
      var _this6 = this;

      return new Promise(function (resolve) {
        var check = function check() {
          if (_this6.HOST.status === 'done') {
            resolve();
          } else {
            setTimeout(check, 200);
          }
        };

        check();
      });
    }
    /**
     * 获取配置文件HOST的定义
     */

  }, {
    key: "getHostConfig",
    value: function () {
      var _getHostConfig = request_asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.setHostConfigStatus('done');
                /** *******当前没有设置配置文件，先注释掉这份逻辑****2021-3-31*******/
                // if (!this.HOST.file) {
                //   this.setHostConfigStatus('done');
                //   return;
                // }
                // if (this.HOST.status === 'done') return;
                // if (this.HOST.status === 'pending') {
                //   await this.untilHostConfigIsDone();
                //   return;
                // }
                // this.setHostConfigStatus('pending');
                // const result = await ConfigRequest.get(this.HOST.file).catch(() => {
                //   console.warn(
                //     '获取HOST配置失败，请检查目录下的config.json是否配置有api_host属性',
                //   );
                //   return false;
                // });
                // if (result) {
                //   this.HOST.value =
                //     (result &&
                //       (result.api_host || (result.data && result.data.api_host))) ||
                //     '';
                //   this.hostConfig = result;
                //   ErrorCatcher.setHostConfig(result.data);
                //   console.log('获取配置成功', this.HOST);
                // }
                // this.setHostConfigStatus('done');

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getHostConfig() {
        return _getHostConfig.apply(this, arguments);
      }

      return getHostConfig;
    }()
  }, {
    key: "setHostConfigStatus",
    value: function setHostConfigStatus(status) {
      this.HOST.status = status;
    }
  }, {
    key: "getRequestFunciton",
    value: function getRequestFunciton() {
      if (!this.requestFn) {
        return new Promise(function (resolve, reject) {
          reject(new Error('请求方法尚未定义，请使用init()进行定义!'));
        });
      }

      return this.request;
    }
  }, {
    key: "canMock",
    value: function canMock() {
      var isProduction = false;

      try {
        isProduction = "production" === 'production';
      } catch (e) {
        console.log(e);
      }

      return !isProduction && this.MOCK_MODE;
    }
  }, {
    key: "mockMode",
    value: function mockMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.MOCK_MODE = mode;
    }
  }, {
    key: "mock",
    value: function mock(config) {
      var errorRes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.MOCK_CONFIG = config;
      this.MOCK_CONFIG_EXTEND = errorRes;
    }
  }, {
    key: "resetMock",
    value: function resetMock() {
      this.MOCK_CONFIG = null;
      this.MOCK_CONFIG_EXTEND = null;
    }
    /**
     * 设置请求拦截器
     * @param requestInterceptorFn
     * @param responseInterceptorFn
     */

  }, {
    key: "setInterceptors",
    value: function setInterceptors(requestInterceptorFn, responseInterceptorFn) {
      // if (ErrorCatcher && !ErrorCatcher.isCreated()) {
      //   ErrorCatcher.create();
      // }
      var _this$interceptors = this.interceptors,
          request = _this$interceptors.request,
          requestError = _this$interceptors.requestError,
          response = _this$interceptors.response,
          responseError = _this$interceptors.responseError; // const request = (arg: any) =>
      //   addErrorCatcher(this.interceptors.request)(arg);
      // const requestError = (arg: any) =>
      //   addErrorCatcher(this.interceptors.requestError)(arg);
      // const repsonse = (arg: any) =>
      //   addErrorCatcher(this.interceptors.response)(arg);
      // const responseError = (arg: any) =>
      //   addErrorCatcher(this.interceptors.responseError)(arg);

      requestInterceptorFn && requestInterceptorFn(request, requestError);
      responseInterceptorFn && responseInterceptorFn(response, responseError);
    }
    /**
     * 设置请求拦截器处理（请求生命周期中）
     */

  }, {
    key: "addInterceptor",
    value: function addInterceptor(type, fn, highOrder, name) {
      if (!fn) return;

      if (!this.interceptorsFn[type]) {
        throw new Error("\u62E6\u622A\u5C5E\u6027\"".concat(type, "\"\u4E0D\u5339\u914D: <\"request\" | \"requestError\" | \"response\" | \"responseError\">"));
      }

      this.validInterceptorName(name);
      var id = name || "".concat(type, "_").concat(this.interceptorsFn[type].length);

      if (!fn.prototype) {
        fn.prototype = {};
      }

      fn.prototype.unique_id = id;
      fn.prototype.highOrder = !!highOrder;

      if (highOrder) {
        var index = this.interceptorsFn[type].findIndex(function (func) {
          return !func.prototype.highOrder;
        });
        this.interceptorsFn[type].splice(index, 0, fn);
        return;
      }

      this.interceptorsFn[type].push(fn);
    }
    /**
     * 校验拦截器名称
     * @param name
     */

  }, {
    key: "validInterceptorName",
    value: function validInterceptorName(name) {
      if (!name) return;
      var types = ['request', 'requestError', 'response', 'responseError'];

      for (var _i = 0, _types = types; _i < _types.length; _i++) {
        var type = _types[_i];
        type += '_';

        if (name.substring(0, type.length) === type) {
          throw new Error("\u62E6\u622A\u5668name\u4E0D\u80FD\u4EE5\"".concat(type, "_\"\u5F00\u5934"));
        }
      }
    }
    /**
     * 通过name移除拦截器
     * @param name
     */

  }, {
    key: "removeInterceptorByName",
    value: function removeInterceptorByName(name) {
      var _this7 = this;

      Object.keys(this.interceptorsFn).some(function (type) {
        return _this7.interceptorsFn[type].some(function (item, index) {
          var id = item.prototype.unique_id;

          if (id === name) {
            _this7.interceptorsFn[type].splice(index, 1);

            return true;
          }
        });
      });
    }
    /**
     * 打印所有拦截器名称
     */

  }, {
    key: "logAllIntercepteors",
    value: function logAllIntercepteors() {
      var _this8 = this;

      var logFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      Object.keys(this.interceptorsFn).forEach(function (type) {
        _this8.interceptorsFn[type].forEach(function (item) {
          console.log('interceptor: ', type, ' > ', item.prototype.unique_id);

          if (logFn) {
            console.log(item);
          }
        });
      });
    }
  }]);

  return Request;
}();

/* harmony default export */ var core_request = (request_Request);
// CONCATENATED MODULE: ./packages/domain-api/src/core/index.ts
function core_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = core_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function core_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function core_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function core_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { core_ownKeys(Object(source), true).forEach(function (key) { core_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { core_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function core_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable */



var requestInstant = new core_request();
/**
 * restfulURL处理
 * @param url
 * @param prefix
 * @param params
 * @param config
 */

function restfulURLAdapter(url, prefix, params, config) {
  var urlParams = url.match(/\{([^\}]+)\}/g);

  if (urlParams && urlParams.length > 0) {
    var newURL = url;
    urlParams.forEach(function (p) {
      var key = p.replace('{', '').replace('}', '');
      newURL = newURL.replace(p, params[key]);
      delete params[key];
    });
    config = core_objectSpread(core_objectSpread({}, config), {}, {
      url: prefix + newURL
    });
  }

  return {
    config: config,
    params: params
  };
}
/**
 * Launcher url adapter
 * @param config
 */


function launcherURLAdapter(config) {
  var findLauncherURL = config.url.match(/\/launcher\/:appCode:/);

  if (findLauncherURL && findLauncherURL.length > 0) {
    var appCode = localStorage.getItem('appCode');

    if (appCode) {
      config.url = config.url.replace(':appCode:', appCode);
    }
  }

  return config;
}
/**
 * 处理扩展属性
 * @param config
 * @param extendRequestOptions
 */


function extendRequestConfig(config, extendRequestOptions) {
  var headers = extendRequestOptions.headers,
      others = core_objectWithoutProperties(extendRequestOptions, ["headers"]);

  if (headers) {
    if (config.headers) {
      config.headers = core_objectSpread(core_objectSpread({}, config.headers), headers);
    } else {
      config.headers = headers;
    }
  }

  if (others) {
    config = core_objectSpread(core_objectSpread({}, config), others);
  }

  return config;
}
/**
 * 非get请求参数处理
 * @param config
 * @param params
 * @param parameters
 * @param rest
 */


function notGetMethodParmasAdapter(config, params, parameters, rest) {
  if (rest.method !== 'get') {
    var body = parameters.body,
        query = parameters.query;
    var queryParams = {},
        bodyParams = {}; // 如果传的参数是数组, 不是值对象，不处理，
    // BUT这种情况不是一个标准的传参方式

    if (params instanceof Array) {
      bodyParams = params;
    } else {
      Object.keys(params).forEach(function (key) {
        if (query.includes(key)) {
          queryParams[key] = params[key];
        } else {
          bodyParams[key] = params[key];
        }
      });
    }

    config = core_objectSpread(core_objectSpread({}, config), {}, {
      url: config.url,
      params: queryParams,
      data: bodyParams
    });
  }

  return config;
}
/**
 * 请求方法
 * @param {obejct} options
 * @param {object} params
 * @param {string} basePath
 * @param {string} host
 * @return {object} 返回领域请求方法树
 */


function requestDynamic(options) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var extendRequestOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var basePath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var host = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

  var security = options.security,
      actionName = options.actionName,
      url = options.url,
      parameters = options.parameters,
      rest = core_objectWithoutProperties(options, ["security", "actionName", "url", "parameters"]);

  var prefix = basePath;

  var config = core_objectSpread(core_objectSpread({}, rest), {}, {
    url: prefix + url,
    params: params
  }); // 替换launcherURL


  config = launcherURLAdapter(config); // 替换地址的请求参数

  var restfulAdapter = restfulURLAdapter(url, prefix, params, config);
  params = restfulAdapter.params;
  config = restfulAdapter.config; // 扩展的extendRequestOptions处理

  config = extendRequestConfig(config, extendRequestOptions); // 非get请求需要将params转换为data

  config = notGetMethodParmasAdapter(config, params, parameters, rest);
  return requestInstant.request(config);
}
/**
 * 根据提供的api树，返回
 * @param apiTree
 * @return {object} 返回领域请求方法树
 */


function createDynamicRequest(apiTree, basePath, host) {
  var API = {};

  if (!Array.isArray(apiTree)) {
    Object.keys(apiTree).forEach(function (key) {
      API[key] = createDynamicRequest(apiTree[key], basePath, host);
    });
    return API;
  }

  var apiCall = function apiCall(item) {
    return function () {
      var extendRequestOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return requestDynamic(item, null, extendRequestOptions, basePath, host);
    };
  };

  var apiCallWithParams = function apiCallWithParams(item) {
    return function (params) {
      var extendRequestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return requestDynamic(item, params, extendRequestOptions, basePath, host);
    };
  };

  apiTree.forEach(function (item) {
    var _item$parameters = item.parameters,
        query = _item$parameters.query,
        body = _item$parameters.body;

    if (query.length === 0 && body.length === 0) {
      API[item.actionName] = apiCall(item);
    } else {
      API[item.actionName] = apiCallWithParams(item);
    }
  });
  return API;
}
/**
 * 添加领域
 * @param domain
 */


function add(domain) {
  var API = {};

  if (domain.type === 'dynamic') {
    var getConfig = function getConfig(config) {
      var basePath = config.basePath,
          host = config.host;
      var httpsHost = host ? 'https://' + host.replace(/https?:\/\//g, '') : '';
      return {
        basePath: basePath,
        httpsHost: httpsHost
      };
    };

    var getTree = function getTree(tree) {
      var dyAPI = {};

      if (tree.CONFIG) {
        config = getConfig(tree.CONFIG);
      }

      Object.keys(tree).forEach(function (key) {
        if (tree[key] instanceof Array) {
          dyAPI[key] = createDynamicRequest(tree[key], config.basePath, config.httpsHost);
          return;
        }

        if (key === 'CONFIG') {
          dyAPI['getStaticConfig'] = function () {
            return console.log(getConfig(tree.CONFIG));
          };

          return;
        }

        dyAPI[key] = getTree(tree[key]);
      });
      return dyAPI;
    };

    var config = {
      basePath: '',
      httpsHost: ''
    };
    API = getTree(domain.tree);
  } // 定义获取常量方法


  API.Global = {
    // 添加拦截器
    addInterceptor: addInterceptor,
    // 获取API请求方法
    // ignoreNormalStatus - 如果 接口状态是200，则不进行结果校验； 业务方自己判断接口是否成功。 （login 接口）
    request: function request(options, ignoreNormalStatus) {
      return requestInstant.request(options, ignoreNormalStatus);
    },
    // 开启请求logger
    useLogger: function useLogger() {
      return requestInstant.useLogger();
    },
    errorCodeAdapter: error_catcher.errorCodeAdapter,
    removeInterceptorByName: function removeInterceptorByName(name) {
      return requestInstant.removeInterceptorByName(name);
    },
    logAllIntercepteors: function logAllIntercepteors(logFn) {
      return requestInstant.logAllIntercepteors(logFn);
    }
  };
  API.Encrypt = {
    setConfig: requestInstant.encryptInstant.setConfig.bind(requestInstant.encryptInstant),
    getConfig: requestInstant.encryptInstant.getConfig.bind(requestInstant.encryptInstant),
    encrypt: requestInstant.encryptInstant.encrypt.bind(requestInstant.encryptInstant),
    decrypt: requestInstant.encryptInstant.decrypt.bind(requestInstant.encryptInstant),
    getSessionId: requestInstant.encryptInstant.getSessionId.bind(requestInstant.encryptInstant),
    createSessionId: requestInstant.encryptInstant.createSessionId.bind(requestInstant.encryptInstant),
    createSM4Key: requestInstant.encryptInstant.createSM4Key.bind(requestInstant.encryptInstant),
    decryptRequest: requestInstant.decryptRequest.bind(requestInstant)
  };

  API.mock = function (config, errorRes) {
    requestInstant.mock(config, errorRes);
    return API;
  };

  API.mockMode = function (mode) {
    return requestInstant.mockMode(mode);
  };

  API.register = function (domain) {
    if (!/^([A-Z](([a-zA-Z0-9])+)\.)+([a-z][a-zA-Z0-9]*)$/.test(domain)) {
      throw new Error('需要注册的域必须符合域大写驼峰，方法小写驼峰的格式，如: Paas.Admin.get');
    }

    if (true) {
      throw new Error("API.register('".concat(domain, "')\u65B9\u6CD5\u7981\u6B62\u5728\u751F\u4EA7\u73AF\u5883\u4E0B\u4F7F\u7528!"));
    }

    var api = API;
    var tree = domain.split('.').filter(function (item) {
      return item !== '';
    });
    tree.forEach(function (item, index) {
      if (index < tree.length - 1) {
        var key = item.slice(0, 1).toUpperCase() + item.slice(1);

        if (!api[key]) {
          api[key] = {};
        }

        api = api[key];
      } else {
        api[item] = function (params) {
          var extendsConfigOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return requestInstant.request({
            url: ''
          });
        };
      }
    });
    return API;
  };

  return API;
}
/**
 * 初始化request方法
 * @param option
 */

function init(option) {
  var requestFn = option && option.requestFn || external_axios_default.a.request;
  requestInstant.init(core_objectSpread(core_objectSpread({}, option), {}, {
    requestFn: requestFn
  }));
}
/**
 * 添加拦截器
 * @param type
 * @param fn
 * @param highOrder
 */

function addInterceptor(type, fn, highOrder, name) {
  requestInstant.addInterceptor(type, fn, highOrder, name);
}
// CONCATENATED MODULE: ./packages/domain-api/src/interceptors/lifecycle.ts
var Lifecycle = {
  // 发起请求之前
  Request: 'request',
  // 发起请求出错
  RequestError: 'requestError',
  // 响应之后
  Response: 'response',
  // 响应错误
  ResponseError: 'responseError'
};
/* harmony default export */ var lifecycle = (Lifecycle);
// CONCATENATED MODULE: ./packages/domain-api/src/interceptors/request.ts

var addTokenInHeader = {
  type: lifecycle.Request,
  callback: function callback(config) {
    // 忽略添加token的地址
    var ignoredTokenURLs = ['/authorization/login'];
    var hasIgnored = ignoredTokenURLs.some(function (i) {
      return config.url.indexOf(i) !== -1;
    });

    if (hasIgnored) {
      return config;
    } // 其他地址查找localStorag 的token,自动附带到请求头上


    var token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = "Bearer ".concat(token);
    } // debug_id


    var debugId = localStorage.getItem('debug_request_id');

    if (debugId) {
      config.headers.debug_request_id = debugId;
    }

    return config;
  }
};
// CONCATENATED MODULE: ./packages/domain-api/src/interceptors/response.ts
function response_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function response_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { response_ownKeys(Object(source), true).forEach(function (key) { response_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { response_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function response_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/**
 * 简化返回数据层级
 */

var sortenResponseData = {
  type: lifecycle.Response,
  callback: function callback(res) {
    var data = error_catcher.dataAdapter(res.data);
    return response_objectSpread(response_objectSpread({}, data), {}, {
      orgResponse: res
    });
  },
  highOrder: true
};
var DEFAULT_PAGE_SIZE = 10; // 默认分页数

/**
 * 列表分页信息
 * 由于后端的接口返回（最新api标准）列表类的数据返回，只返回 total总数，
 * 故此，需要自己根据请求的参数进行计算，并将当前页数，每页显示数目，总页数等信息返回
 */

var paginavtion = {
  type: lifecycle.Response,
  callback: function callback(res) {
    var orgResponse = res.orgResponse;

    if (orgResponse && orgResponse.config && orgResponse.config.requestType === 'list') {
      var _orgResponse$config$p = orgResponse.config.params,
          params = _orgResponse$config$p === void 0 ? {} : _orgResponse$config$p;
      var _params$page = params.page,
          page = _params$page === void 0 ? 1 : _params$page,
          _params$pageSize = params.pageSize,
          pageSize = _params$pageSize === void 0 ? DEFAULT_PAGE_SIZE : _params$pageSize;
      var total = res.total || res.data.total;
      var pageCount = parseInt((total / pageSize).toString(), 10);
      pageCount += total % pageSize > 0 ? 1 : 0;
      res.data = response_objectSpread(response_objectSpread({}, res.data), {}, {
        total: total,
        page: page,
        pageCount: pageCount,
        pageSize: pageSize
      });
    }

    return res;
  }
};
/**
 * errcode为700017代表没有权限访问这个接口，跳转无权限提示页面
 * @param response
 */

var checkPermission = {
  type: lifecycle.Response,
  callback: function callback(response) {
    var res = getDataFromOriginResponse(response);
    var errCode = res && (res.errcode || res.errCode);
    var noPermissionCode = [700017, 40005];

    if (errCode && noPermissionCode.indexOf(errCode) !== -1) {
      window.location.href = '/no-permission.html';
    }
  }
};
/**
 * 接口响应200，但是errCode不为空的错误处理
 */

var errorResponse200 = {
  type: lifecycle.Response,
  callback: function callback(response) {
    var orgResponse = response.orgResponse,
        ignoredError = response.ignoredError;
    if (ignoredError) return; // 从原始响应提获取data层

    var res = getDataFromOriginResponse(orgResponse);
    var success = error_catcher.getResponseByConfig(res, 'success');
    var errcode = error_catcher.getResponseByConfig(res, 'errCode');

    if (res && (success !== undefined && !success || errcode)) {
      var error = error_catcher.errorCodeAdapter(response);

      if (error.errcode === '1002013') {
        window.localStorage.removeItem('globalSwitch');
        var path = window.location.pathname;
        var hash = window.location.hash;

        if (path.indexOf('/login') === -1 && hash.indexOf('/login') === -1) {
          var url = '/platform/#/login';
          window.location.href = url;
          return;
        }
      }

      if (!external_vue_default.a.prototype.$errorcatcher.captureError) {
        return;
      } // 由于200的响应默认不会作为系统错误捕获，
      // 这里手动捕获当做错误处理


      external_vue_default.a.prototype.$errorcatcher.captureError(error); // const isRuntime = Vue.prototype.$errorcatcher.options.isRuntime || false;
      // 显示错误弹窗

      var message = [error.errmsg];
      message.push(error.traceId ? "TraceId: ".concat(error.traceId) : '');
      external_vue_default.a.prototype.$errorcatcher.showMessagePopup({
        title: '错误码: ' + error.errcode,
        message: message,
        correctGuide: error.correctGuide,
        displayFooter: true
      }); // else {
      //   const propsData = getPopupPropsByErrorCode(error);
      //   Vue.prototype.$errorcatcher.showMessagePopupCustom(propsData);
      // }
    }
  }
};
/**
 * 根据错误码获取消息弹窗传参
 * @param error 错误对象数据(包含错误码)
 */

function getPopupPropsByErrorCode(error) {
  var propsData = {
    title: '错误码: ' + error.errcode,
    message: [error.errmsg],
    correctGuide: error.correctGuide,
    displayFooter: true
  };

  if (error.errcode === '403') {
    // 403特殊处理
    propsData.title = error.errmsg;
    propsData.message = [];
    propsData.type = 'warning';
    propsData.containerClass = 'warning-container';
    propsData.titleClass = 'warning-title';
    propsData.confirmButtonClass = 'warning-confirm-button';
  }

  return propsData;
}
/**
 * 获取response响应层
 * @param res
 */

function getDataFromOriginResponse(res) {
  if (res && (res.config || res.headers)) {
    return res.data;
  }

  return res;
}
// CONCATENATED MODULE: ./packages/domain-api/src/interceptors/response-errors.ts




var getErrMsgFrom500 = function getErrMsgFrom500(err) {
  var data = err.response && err.response.data || {};
  if (data.errCode === '500') return data.errMessage;
  return '';
};

var getErrorStatus = function getErrorStatus(err) {
  return err.httpStatus || err.response && err.response.status;
};

var getErrorInfo = function getErrorInfo(err) {
  var _err$response;

  return (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data;
};
/**
 * 401
 * @param response
 */


var error401 = {
  type: lifecycle.ResponseError,
  callback: function callback(err) {
    if (getErrorStatus(err) === 401) {
      window.localStorage.removeItem('globalSwitch');
      var path = window.location.pathname;
      var hash = window.location.hash;

      if (path.indexOf('/login') === -1 && hash.indexOf('/login') === -1) {
        var url = "/platform/#/login?redirect_url=".concat(window.location.href);
        window.location.href = url;
      }

      return true;
    }

    return false;
  }
};
/**
 * 403
 * @param response
 */

var error403 = {
  type: lifecycle.ResponseError,
  callback: function callback(err) {
    var status = getErrorStatus(err);

    if (getErrorStatus(err) === 403) {
      error_catcher.create();
      setTimeout(function () {
        var error = error_catcher.errorCodeAdapter(err.orgResponse || err.response.data); // Vue.prototype.$errorcatcher.captureError(err);
        // 这里手动捕获当做错误处理

        external_vue_default.a.prototype.$errorcatcher.captureError(error); // 显示错误弹窗

        var message = [error.errmsg];
        message.push(error.traceId ? "TraceId: ".concat(error.traceId) : ''); // console.log(error);

        external_vue_default.a.prototype.$errorcatcher.showMessagePopup({
          title: '错误码: ' + (error.errcode || status),
          message: message,
          correctGuide: error.correctGuide || '如有疑问请联系相关后端工程师！',
          displayFooter: true
        });
      });
      return true;
    }

    return false;
  }
};
/**
 * 404
 * @param response
 */

var error404 = {
  type: lifecycle.ResponseError,
  callback: function callback(err) {
    var status = getErrorStatus(err);

    if (getErrorStatus(err) === 404) {
      error_catcher.create();
      external_vue_default.a.prototype.$errorcatcher.captureError(err);
      external_vue_default.a.prototype.$errorcatcher.showMessagePopup({
        title: "\u9519\u8BEF\u7801\uFF1A\u72B6\u6001".concat(status),
        message: ['404 请求资源未找到!', '请确认请求方法/地址的正确性'],
        correctGuide: '如有疑问请联系相关后端工程师！',
        displayFooter: true
      });
      return true;
    }

    return false;
  }
};
/**
 * 405
 * @param response
 */

var error405 = {
  type: lifecycle.ResponseError,
  callback: function callback(err) {
    var status = getErrorStatus(err);

    if (getErrorStatus(err) === 405) {
      error_catcher.create();
      external_vue_default.a.prototype.$errorcatcher.captureError(err);
      external_vue_default.a.prototype.$errorcatcher.showMessagePopup({
        title: "\u9519\u8BEF\u7801\uFF1A\u72B6\u6001".concat(status),
        message: ['405 请求资源不允许访问!', '请确认请求方法/地址的正确性'],
        correctGuide: '如有疑问请联系相关后端工程师！',
        displayFooter: true
      });
      return true;
    }

    return false;
  }
};
/**
 * >=500
 * @param response
 */

var error500 = {
  type: lifecycle.ResponseError,
  callback: function callback(err) {
    var status = getErrorStatus(err);

    if (status >= 500) {
      error_catcher.create();
      var msg = getErrMsgFrom500(err);
      console.log('500');
      external_vue_default.a.prototype.$errorcatcher.captureError(err);
      external_vue_default.a.prototype.$errorcatcher.showMessagePopup({
        title: "\u9519\u8BEF\u7801\uFF1A\u72B6\u6001".concat(status),
        message: [msg || "\u54CD\u5E94\u72B6\u6001".concat(status)],
        correctGuide: '',
        displayFooter: true
      });
      return true;
    }

    return false;
  }
};
/**
 * newwork error;
 * @param response
 */

var networkError = {
  type: lifecycle.ResponseError,
  callback: function callback(err) {
    error_catcher.create();
    console.log('请求出错了!', err);
    var errorInfo = getErrorInfo(err);

    if (errorInfo && (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errCode) && (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.success) === false) {
      var message = [errorInfo.errMessage];
      message.push(errorInfo.traceId ? "TraceId: ".concat(errorInfo.traceId) : '');
      external_vue_default.a.prototype.$errorcatcher.showMessagePopup({
        title: '错误码: ' + errorInfo.errCode,
        message: message,
        correctGuide: '',
        displayFooter: true
      });
      return true;
    }

    return false;
  }
};
// CONCATENATED MODULE: ./packages/domain-api/src/interceptors/index.ts


 // 整体导出

/* harmony default export */ var interceptors = ([// res => res.data
sortenResponseData, // 添加token在请求头
addTokenInHeader, // 分页处理
paginavtion, // 权限检查
checkPermission, // 接口200，但是errCode不为空
errorResponse200, error401, error403, error404, error405, error500, networkError]);
// EXTERNAL MODULE: ./packages/domain-api/src/domain-created/Metadata.json
var Metadata = __webpack_require__(15);

// EXTERNAL MODULE: ./packages/domain-api/src/domain-created/CommonService.json
var CommonService = __webpack_require__(16);

// CONCATENATED MODULE: ./packages/domain-api/src/domain-tree.js


var tree = {};
tree.Metadata = Metadata;
tree.CommonService = CommonService;
/* harmony default export */ var domain_tree = ({
  tree: tree,
  type: 'dynamic'
});
// CONCATENATED MODULE: ./packages/domain-api/src/api.js




var BASE_URL = localStorage.getItem('ENV_ORIGIN') || '';
console.log('BASE_URL: ', BASE_URL);
var Axios = external_axios_default.a.create({
  baseURL: BASE_URL,
  withCredentials: true
});
console.log('axios baseURL: ', Axios.defaults.baseURL);
/**
 * 初始化配置
 */

init({
  // logger: true,
  requestFn: Axios.request,
  requestInterceptorFn: function requestInterceptorFn(requestFn, requestErrorFn) {
    return Axios.interceptors.request.use(requestFn, requestErrorFn);
  },
  responseInterceptorFn: function responseInterceptorFn(responseFn, responseErrorFn) {
    return Axios.interceptors.response.use(responseFn, responseErrorFn);
  }
});
/**
 * 添加拦截器
 */

interceptors.forEach(function (_ref) {
  var type = _ref.type,
      callback = _ref.callback,
      highOrder = _ref.highOrder,
      name = _ref.name;
  addInterceptor(type, callback, highOrder, name);
});
/**
 * 添加领域接口
 */

var api_API = add(domain_tree); // 初始化加密配置
// initEncrypt(API);

/* harmony default export */ var src_api = (api_API);
// CONCATENATED MODULE: ./packages/domain-api/src/index.js


src_api.ErrorCatcher = error_catcher;
/* harmony default export */ var src = __webpack_exports__["default"] = (src_api);

/***/ })
/******/ ]);